{
    "version": "2.0.0",
    "description": "AI-curated professional scene template library with beautifully aligned layouts",
    "metadata": {
        "totalTemplates": 453,
        "lastUpdated": "2025-11-22",
        "author": "SignStudio AI Designer",
        "designPrinciples": "Professional alignment, visual hierarchy, balanced composition, modern aesthetics, digital signage best practices"
    },
    "resolutions": {
        "fullhd_landscape": {
            "name": "Full HD Landscape",
            "width": 1920,
            "height": 1080,
            "aspectRatio": "16:9",
            "orientation": "landscape",
            "description": "Standard widescreen display"
        },
        "hd_landscape": {
            "name": "HD Landscape",
            "width": 1280,
            "height": 720,
            "aspectRatio": "16:9",
            "orientation": "landscape",
            "description": "HD widescreen"
        },
        "fullhd_portrait": {
            "name": "Full HD Portrait",
            "width": 1080,
            "height": 1920,
            "aspectRatio": "9:16",
            "orientation": "portrait",
            "description": "Vertical display (digital signage)"
        },
        "hd_portrait": {
            "name": "HD Portrait",
            "width": 720,
            "height": 1280,
            "aspectRatio": "9:16",
            "orientation": "portrait",
            "description": "Vertical HD display"
        },
        "square_hd": {
            "name": "Square HD",
            "width": 1080,
            "height": 1080,
            "aspectRatio": "1:1",
            "orientation": "square",
            "description": "Perfect square (social media)"
        },
        "square_standard": {
            "name": "Square Standard",
            "width": 800,
            "height": 800,
            "aspectRatio": "1:1",
            "orientation": "square",
            "description": "Standard square display"
        },
        "ultrawide": {
            "name": "Ultrawide",
            "width": 2560,
            "height": 1080,
            "aspectRatio": "21:9",
            "orientation": "ultrawide",
            "description": "Ultrawide cinematic display"
        },
        "standard_landscape": {
            "name": "Standard Landscape",
            "width": 1024,
            "height": 768,
            "aspectRatio": "4:3",
            "orientation": "landscape",
            "description": "Classic 4:3 display"
        },
        "standard_portrait": {
            "name": "Standard Portrait",
            "width": 768,
            "height": 1024,
            "aspectRatio": "3:4",
            "orientation": "portrait",
            "description": "Classic portrait 3:4"
        },
        "compact_landscape": {
            "name": "Compact Landscape",
            "width": 800,
            "height": 600,
            "aspectRatio": "4:3",
            "orientation": "landscape",
            "description": "Compact display"
        },
        "digital_signage_portrait": {
            "name": "Digital Signage Portrait",
            "width": 1080,
            "height": 1620,
            "aspectRatio": "2:3",
            "orientation": "portrait",
            "description": "Common digital signage vertical"
        },
        "wide_landscape": {
            "name": "Wide Landscape",
            "width": 1920,
            "height": 1200,
            "aspectRatio": "16:10",
            "orientation": "landscape",
            "description": "Wide landscape format"
        }
    },
    "categories": {
        "corporate": {
            "name": "Corporate",
            "icon": "business",
            "description": "Professional business and corporate layouts"
        },
        "marketing": {
            "name": "Marketing",
            "icon": "campaign",
            "description": "Marketing and promotional content"
        },
        "data": {
            "name": "Data & Analytics",
            "icon": "analytics",
            "description": "Data visualization and analytics displays"
        },
        "media": {
            "name": "Media & Entertainment",
            "icon": "movie",
            "description": "Media, video, and entertainment content"
        },
        "social": {
            "name": "Social Media",
            "icon": "share",
            "description": "Social media optimized layouts"
        },
        "education": {
            "name": "Education",
            "icon": "school",
            "description": "Educational and training content"
        },
        "retail": {
            "name": "Retail & E-commerce",
            "icon": "shopping_cart",
            "description": "Retail and shopping displays"
        },
        "hospitality": {
            "name": "Hospitality",
            "icon": "hotel",
            "description": "Hotels, restaurants, and hospitality"
        },
        "healthcare": {
            "name": "Healthcare",
            "icon": "local_hospital",
            "description": "Medical and healthcare displays"
        },
        "creative": {
            "name": "Creative & Portfolio",
            "icon": "palette",
            "description": "Creative and portfolio showcases"
        },
        "minimal": {
            "name": "Minimal",
            "icon": "crop_square",
            "description": "Clean minimal designs"
        },
        "bold": {
            "name": "Bold & Dynamic",
            "icon": "flash_on",
            "description": "Bold, eye-catching layouts"
        }
    },
    "templates": [
        {
            "id": "corp_hero_split_fhd_001",
            "name": "corporate hero split",
            "icon": "business_center",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "professional hero layout with balanced split design",
            "tags": [
                "corporate",
                "hero",
                "split",
                "professional"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 8,
                    "w": 42,
                    "h": 84,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 15,
                    "w": 43,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 52,
                    "y": 28,
                    "w": 43,
                    "h": 35,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 52,
                    "y": 68,
                    "w": 20,
                    "h": 20,
                    "type": "icon",
                    "iconType": "trending_up",
                    "rounded": true
                }
            ]
        },
        {
            "id": "corp_stats_dashboard_fhd_002",
            "name": "corporate stats dashboard",
            "icon": "dashboard",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "executive dashboard with key metrics",
            "tags": [
                "corporate",
                "dashboard",
                "stats",
                "metrics"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 11,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 21,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 21,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 51,
                    "y": 18,
                    "w": 21,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 74,
                    "y": 18,
                    "w": 21,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 90,
                    "h": 37,
                    "type": "chart",
                    "chartType": "line",
                    "iconType": "show_chart"
                }
            ]
        },
        {
            "id": "corp_team_grid_fhd_003",
            "name": "corporate team grid",
            "icon": "groups",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "team member showcase grid",
            "tags": [
                "corporate",
                "team",
                "people",
                "grid"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 27,
                    "h": 72,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 20,
                    "w": 27,
                    "h": 72,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 67,
                    "y": 20,
                    "w": 27,
                    "h": 72,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "corp_feature_showcase_fhd_004",
            "name": "corporate feature showcase",
            "icon": "stars",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "feature highlights with icons",
            "tags": [
                "corporate",
                "features",
                "showcase",
                "icons"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 8,
                    "w": 90,
                    "h": 11,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 27,
                    "h": 18,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 42,
                    "w": 27,
                    "h": 50,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 36,
                    "y": 22,
                    "w": 27,
                    "h": 18,
                    "type": "icon",
                    "iconType": "security",
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 42,
                    "w": 27,
                    "h": 50,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 67,
                    "y": 22,
                    "w": 27,
                    "h": 18,
                    "type": "icon",
                    "iconType": "speed",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 67,
                    "y": 42,
                    "w": 27,
                    "h": 50,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "corp_timeline_fhd_005",
            "name": "corporate timeline",
            "icon": "timeline",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "professional timeline layout",
            "tags": [
                "corporate",
                "timeline",
                "chronology",
                "roadmap"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 8,
                    "y": 20,
                    "w": 84,
                    "h": 72,
                    "type": "timeline",
                    "special": true
                }
            ]
        },
        {
            "id": "mkt_hero_cta_fhd_006",
            "name": "marketing hero with cta",
            "icon": "campaign",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bold marketing hero with call-to-action",
            "tags": [
                "marketing",
                "hero",
                "cta",
                "promo"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 12,
                    "w": 50,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 28,
                    "w": 50,
                    "h": 25,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 22,
                    "h": 12,
                    "type": "button"
                },
                {
                    "x": 60,
                    "y": 5,
                    "w": 35,
                    "h": 90,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                }
            ]
        },
        {
            "id": "mkt_product_feature_fhd_007",
            "name": "marketing product features",
            "icon": "local_offer",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "product feature grid with icons",
            "tags": [
                "marketing",
                "product",
                "features",
                "grid"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 20,
                    "h": 68,
                    "type": "icon",
                    "iconType": "star"
                },
                {
                    "x": 28,
                    "y": 22,
                    "w": 20,
                    "h": 68,
                    "type": "icon",
                    "iconType": "favorite"
                },
                {
                    "x": 51,
                    "y": 22,
                    "w": 20,
                    "h": 68,
                    "type": "icon",
                    "iconType": "thumb_up",
                    "special": true
                },
                {
                    "x": 74,
                    "y": 22,
                    "w": 20,
                    "h": 68,
                    "type": "icon",
                    "iconType": "verified"
                }
            ]
        },
        {
            "id": "mkt_testimonial_fhd_008",
            "name": "marketing testimonial",
            "icon": "format_quote",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "customer testimonial layout",
            "tags": [
                "marketing",
                "testimonial",
                "quote",
                "social-proof"
            ],
            "blocks": [
                {
                    "x": 15,
                    "y": 20,
                    "w": 18,
                    "h": 25,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 38,
                    "y": 15,
                    "w": 52,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 38,
                    "y": 28,
                    "w": 52,
                    "h": 45,
                    "type": "text",
                    "lines": 8,
                    "special": true
                },
                {
                    "x": 38,
                    "y": 78,
                    "w": 25,
                    "h": 8,
                    "type": "title",
                    "lines": 1
                }
            ]
        },
        {
            "id": "mkt_pricing_compare_fhd_009",
            "name": "marketing pricing comparison",
            "icon": "payments",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "pricing tiers comparison",
            "tags": [
                "marketing",
                "pricing",
                "plans",
                "comparison"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 27,
                    "h": 72,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 20,
                    "w": 27,
                    "h": 72,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 20,
                    "w": 27,
                    "h": 72,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "mkt_promo_banner_fhd_010",
            "name": "marketing promo banner",
            "icon": "celebration",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "promotional banner layout",
            "tags": [
                "marketing",
                "promo",
                "banner",
                "sale"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 25,
                    "w": 35,
                    "h": 50,
                    "type": "icon",
                    "iconType": "local_offer",
                    "special": true
                },
                {
                    "x": 45,
                    "y": 20,
                    "w": 50,
                    "h": 22,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 45,
                    "y": 42,
                    "w": 50,
                    "h": 25,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 45,
                    "y": 72,
                    "w": 25,
                    "h": 12,
                    "type": "button"
                }
            ]
        },
        {
            "id": "data_chart_hero_fhd_011",
            "name": "data chart hero",
            "icon": "analytics",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large chart with summary",
            "tags": [
                "data",
                "chart",
                "analytics",
                "hero"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 11,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 65,
                    "h": 75,
                    "type": "chart",
                    "chartType": "column",
                    "iconType": "insert_chart",
                    "special": true
                },
                {
                    "x": 73,
                    "y": 18,
                    "w": 22,
                    "h": 75,
                    "type": "bullets",
                    "lines": 8
                }
            ]
        },
        {
            "id": "data_kpi_grid_fhd_012",
            "name": "data kpi grid",
            "icon": "speed",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "key performance indicators grid",
            "tags": [
                "data",
                "kpi",
                "metrics",
                "grid"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 17,
                    "w": 20,
                    "h": 28,
                    "type": "textbox"
                },
                {
                    "x": 27,
                    "y": 17,
                    "w": 20,
                    "h": 28,
                    "type": "textbox"
                },
                {
                    "x": 49,
                    "y": 17,
                    "w": 20,
                    "h": 28,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 71,
                    "y": 17,
                    "w": 20,
                    "h": 28,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 48,
                    "w": 44,
                    "h": 45,
                    "type": "chart",
                    "chartType": "pie",
                    "iconType": "pie_chart"
                },
                {
                    "x": 51,
                    "y": 48,
                    "w": 44,
                    "h": 45,
                    "type": "chart",
                    "chartType": "doughnut",
                    "iconType": "donut_large"
                }
            ]
        },
        {
            "id": "data_multi_chart_fhd_014",
            "name": "data multi-chart comparison",
            "icon": "auto_graph",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "multiple charts for comparison",
            "tags": [
                "data",
                "charts",
                "comparison",
                "analytics"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 44,
                    "h": 38,
                    "type": "chart",
                    "chartType": "bar",
                    "iconType": "insert_chart"
                },
                {
                    "x": 51,
                    "y": 16,
                    "w": 44,
                    "h": 38,
                    "type": "chart",
                    "chartType": "line",
                    "iconType": "show_chart",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 57,
                    "w": 90,
                    "h": 36,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "data_progress_tracker_fhd_015",
            "name": "data progress tracker",
            "icon": "trending_up",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "progress tracking dashboard",
            "tags": [
                "data",
                "progress",
                "tracking",
                "goals"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 90,
                    "h": 15,
                    "type": "progress"
                },
                {
                    "x": 5,
                    "y": 40,
                    "w": 90,
                    "h": 15,
                    "type": "progress"
                },
                {
                    "x": 5,
                    "y": 60,
                    "w": 90,
                    "h": 15,
                    "type": "progress",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 80,
                    "w": 90,
                    "h": 15,
                    "type": "progress"
                }
            ]
        },
        {
            "id": "media_video_hero_fhd_016",
            "name": "media video hero",
            "icon": "play_circle",
            "category": "media",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large video showcase",
            "tags": [
                "media",
                "video",
                "hero",
                "featured"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 65,
                    "type": "video",
                    "iconType": "play",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 73,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 84,
                    "w": 90,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "media_gallery_grid_fhd_017",
            "name": "media gallery grid",
            "icon": "collections",
            "category": "media",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "photo gallery grid layout",
            "tags": [
                "media",
                "gallery",
                "photos",
                "grid"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 11,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 35,
                    "y": 18,
                    "w": 28,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 65,
                    "y": 18,
                    "w": 28,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 5,
                    "y": 59,
                    "w": 28,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 35,
                    "y": 59,
                    "w": 28,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 65,
                    "y": 59,
                    "w": 28,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "media_featured_playlist_fhd_018",
            "name": "media featured playlist",
            "icon": "playlist_play",
            "category": "media",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "media playlist showcase",
            "tags": [
                "media",
                "playlist",
                "music",
                "videos"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 55,
                    "h": 90,
                    "type": "video",
                    "iconType": "play",
                    "special": true
                },
                {
                    "x": 63,
                    "y": 8,
                    "w": 32,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 63,
                    "y": 22,
                    "w": 32,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 63,
                    "y": 43,
                    "w": 32,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 63,
                    "y": 64,
                    "w": 32,
                    "h": 18,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "media_cinema_poster_fhd_019",
            "name": "media cinema poster",
            "icon": "movie",
            "category": "media",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "cinematic poster layout",
            "tags": [
                "media",
                "cinema",
                "poster",
                "entertainment"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 42,
                    "h": 90,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 15,
                    "w": 43,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 52,
                    "y": 32,
                    "w": 43,
                    "h": 30,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 52,
                    "y": 67,
                    "w": 43,
                    "h": 8,
                    "type": "title",
                    "lines": 1
                },
                {
                    "x": 52,
                    "y": 78,
                    "w": 20,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "media_photo_story_fhd_020",
            "name": "media photo story",
            "icon": "photo_library",
            "category": "media",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "photo storytelling layout",
            "tags": [
                "media",
                "photo",
                "story",
                "narrative"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 45,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 52,
                    "y": 5,
                    "w": 43,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 53,
                    "w": 90,
                    "h": 11,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 65,
                    "w": 90,
                    "h": 28,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "social_insta_post_square_021",
            "name": "social instagram post",
            "icon": "photo_camera",
            "category": "social",
            "resolution": "square_hd",
            "width": 1080,
            "height": 1080,
            "description": "instagram optimized layout",
            "tags": [
                "social",
                "instagram",
                "square",
                "post"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 65,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 73,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 85,
                    "w": 90,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "social_quote_card_square_022",
            "name": "social quote card",
            "icon": "format_quote",
            "category": "social",
            "resolution": "square_hd",
            "width": 1080,
            "height": 1080,
            "description": "inspirational quote layout",
            "tags": [
                "social",
                "quote",
                "inspiration",
                "card"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 25,
                    "w": 80,
                    "h": 12,
                    "type": "icon",
                    "iconType": "format_quote"
                },
                {
                    "x": 10,
                    "y": 40,
                    "w": 80,
                    "h": 36,
                    "type": "header",
                    "lines": 2,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 73,
                    "w": 80,
                    "h": 8,
                    "type": "title",
                    "lines": 1
                }
            ]
        },
        {
            "id": "social_announcement_square_023",
            "name": "social announcement",
            "icon": "campaign",
            "category": "social",
            "resolution": "square_hd",
            "width": 1080,
            "height": 1080,
            "description": "bold social announcement",
            "tags": [
                "social",
                "announcement",
                "news",
                "update"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 15,
                    "w": 80,
                    "h": 18,
                    "type": "icon",
                    "iconType": "notifications_active",
                    "special": true
                },
                {
                    "x": 10,
                    "y": 38,
                    "w": 80,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 54,
                    "w": 80,
                    "h": 28,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 30,
                    "y": 85,
                    "w": 40,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "social_story_portrait_024",
            "name": "social story vertical",
            "icon": "auto_stories",
            "category": "social",
            "resolution": "fullhd_portrait",
            "width": 1080,
            "height": 1920,
            "description": "vertical story format",
            "tags": [
                "social",
                "story",
                "vertical",
                "instagram"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 3,
                    "w": 90,
                    "h": 55,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 60,
                    "w": 90,
                    "h": 9,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 90,
                    "h": 20,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 30,
                    "y": 92,
                    "w": 40,
                    "h": 5,
                    "type": "button"
                }
            ]
        },
        {
            "id": "social_stat_card_square_025",
            "name": "social stat card",
            "icon": "insights",
            "category": "social",
            "resolution": "square_hd",
            "width": 1080,
            "height": 1080,
            "description": "social media stats display",
            "tags": [
                "social",
                "stats",
                "metrics",
                "engagement"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 15,
                    "w": 80,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 30,
                    "w": 80,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 10,
                    "y": 70,
                    "w": 35,
                    "h": 18,
                    "type": "icon",
                    "iconType": "favorite"
                },
                {
                    "x": 55,
                    "y": 70,
                    "w": 35,
                    "h": 18,
                    "type": "icon",
                    "iconType": "share"
                }
            ]
        },
        {
            "id": "edu_lesson_slide_fhd_026",
            "name": "education lesson slide",
            "icon": "school",
            "category": "education",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "educational lesson layout",
            "tags": [
                "education",
                "lesson",
                "teaching",
                "learning"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 42,
                    "h": 72,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 52,
                    "y": 20,
                    "w": 43,
                    "h": 72,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                }
            ]
        },
        {
            "id": "edu_diagram_explain_fhd_027",
            "name": "education diagram explanation",
            "icon": "account_tree",
            "category": "education",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "diagram with explanation",
            "tags": [
                "education",
                "diagram",
                "explanation",
                "visual"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 11,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 58,
                    "h": 75,
                    "type": "pyramid",
                    "special": true
                },
                {
                    "x": 66,
                    "y": 18,
                    "w": 29,
                    "h": 75,
                    "type": "bullets",
                    "lines": 8
                }
            ]
        },
        {
            "id": "edu_steps_process_fhd_028",
            "name": "education step-by-step",
            "icon": "stairs",
            "category": "education",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "step by step process",
            "tags": [
                "education",
                "steps",
                "process",
                "tutorial"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 27,
                    "h": 15,
                    "type": "icon",
                    "iconType": "looks_one",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 38,
                    "w": 27,
                    "h": 54,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 36,
                    "y": 20,
                    "w": 27,
                    "h": 15,
                    "type": "icon",
                    "iconType": "looks_two",
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 38,
                    "w": 27,
                    "h": 54,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 67,
                    "y": 20,
                    "w": 27,
                    "h": 15,
                    "type": "icon",
                    "iconType": "looks_3",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 67,
                    "y": 38,
                    "w": 27,
                    "h": 54,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "edu_quiz_question_fhd_029",
            "name": "education quiz question",
            "icon": "quiz",
            "category": "education",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "interactive quiz layout",
            "tags": [
                "education",
                "quiz",
                "question",
                "interactive"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 10,
                    "w": 80,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 32,
                    "w": 80,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 10,
                    "y": 47,
                    "w": 80,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 10,
                    "y": 62,
                    "w": 80,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 10,
                    "y": 77,
                    "w": 80,
                    "h": 12,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "edu_certificate_fhd_030",
            "name": "education certificate",
            "icon": "workspace_premium",
            "category": "education",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "achievement certificate layout",
            "tags": [
                "education",
                "certificate",
                "achievement",
                "award"
            ],
            "blocks": [
                {
                    "x": 20,
                    "y": 15,
                    "w": 60,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 35,
                    "y": 32,
                    "w": 30,
                    "h": 25,
                    "type": "icon",
                    "iconType": "workspace_premium",
                    "special": true
                },
                {
                    "x": 20,
                    "y": 62,
                    "w": 60,
                    "h": 10,
                    "type": "title",
                    "lines": 1
                },
                {
                    "x": 20,
                    "y": 75,
                    "w": 60,
                    "h": 12,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "retail_product_hero_fhd_031",
            "name": "retail product hero",
            "icon": "shopping_bag",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "product hero showcase",
            "tags": [
                "retail",
                "product",
                "hero",
                "ecommerce"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 50,
                    "h": 90,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 60,
                    "y": 15,
                    "w": 35,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 60,
                    "y": 32,
                    "w": 35,
                    "h": 28,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 60,
                    "y": 65,
                    "w": 35,
                    "h": 10,
                    "type": "title",
                    "lines": 1
                },
                {
                    "x": 60,
                    "y": 78,
                    "w": 18,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "retail_sale_banner_fhd_032",
            "name": "retail sale banner",
            "icon": "local_offer",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bold sale promotion",
            "tags": [
                "retail",
                "sale",
                "promo",
                "discount"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 20,
                    "w": 35,
                    "h": 60,
                    "type": "icon",
                    "iconType": "sell",
                    "special": true
                },
                {
                    "x": 50,
                    "y": 25,
                    "w": 45,
                    "h": 22,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 50,
                    "y": 48,
                    "w": 45,
                    "h": 25,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 50,
                    "y": 78,
                    "w": 20,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "retail_product_grid_fhd_033",
            "name": "retail product grid",
            "icon": "grid_view",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "product catalog grid",
            "tags": [
                "retail",
                "products",
                "grid",
                "catalog"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 11,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 21,
                    "h": 75,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 21,
                    "h": 75,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 51,
                    "y": 18,
                    "w": 21,
                    "h": 75,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 74,
                    "y": 18,
                    "w": 21,
                    "h": 75,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "retail_category_showcase_fhd_034",
            "name": "retail category showcase",
            "icon": "category",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "product category display",
            "tags": [
                "retail",
                "category",
                "collection",
                "showcase"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 44,
                    "h": 72,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 51,
                    "y": 20,
                    "w": 44,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 51,
                    "y": 57,
                    "w": 44,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "retail_testimonial_fhd_035",
            "name": "retail customer review",
            "icon": "star_rate",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "customer review showcase",
            "tags": [
                "retail",
                "review",
                "testimonial",
                "rating"
            ],
            "blocks": [
                {
                    "x": 15,
                    "y": 20,
                    "w": 20,
                    "h": 28,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 40,
                    "y": 15,
                    "w": 50,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 40,
                    "y": 28,
                    "w": 50,
                    "h": 8,
                    "type": "icon",
                    "iconType": "star"
                },
                {
                    "x": 40,
                    "y": 40,
                    "w": 50,
                    "h": 35,
                    "type": "text",
                    "lines": 7,
                    "special": true
                },
                {
                    "x": 40,
                    "y": 78,
                    "w": 25,
                    "h": 8,
                    "type": "title",
                    "lines": 1
                }
            ]
        },
        {
            "id": "hosp_menu_board_fhd_036",
            "name": "hospitality menu board",
            "icon": "restaurant_menu",
            "category": "hospitality",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "restaurant menu display",
            "tags": [
                "hospitality",
                "menu",
                "restaurant",
                "food"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 42,
                    "h": 72,
                    "type": "bullets",
                    "lines": 10
                },
                {
                    "x": 52,
                    "y": 20,
                    "w": 43,
                    "h": 72,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                }
            ]
        },
        {
            "id": "hosp_welcome_fhd_037",
            "name": "hospitality welcome screen",
            "icon": "waving_hand",
            "category": "hospitality",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "warm welcome display",
            "tags": [
                "hospitality",
                "welcome",
                "greeting",
                "hotel"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 55,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 65,
                    "w": 80,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 80,
                    "w": 80,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "hosp_amenities_fhd_039",
            "name": "hospitality amenities",
            "icon": "local_hotel",
            "category": "hospitality",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "hotel amenities showcase",
            "tags": [
                "hospitality",
                "amenities",
                "hotel",
                "services"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 27,
                    "h": 18,
                    "type": "icon",
                    "iconType": "pool"
                },
                {
                    "x": 5,
                    "y": 40,
                    "w": 27,
                    "h": 52,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 36,
                    "y": 20,
                    "w": 27,
                    "h": 18,
                    "type": "icon",
                    "iconType": "restaurant"
                },
                {
                    "x": 36,
                    "y": 40,
                    "w": 27,
                    "h": 52,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 67,
                    "y": 20,
                    "w": 27,
                    "h": 18,
                    "type": "icon",
                    "iconType": "fitness_center",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 40,
                    "w": 27,
                    "h": 52,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "hosp_special_offer_fhd_040",
            "name": "hospitality special offer",
            "icon": "card_giftcard",
            "category": "hospitality",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "special promotion display",
            "tags": [
                "hospitality",
                "offer",
                "promo",
                "special"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 10,
                    "w": 40,
                    "h": 80,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 50,
                    "y": 20,
                    "w": 45,
                    "h": 18,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 50,
                    "y": 40,
                    "w": 45,
                    "h": 30,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 50,
                    "y": 75,
                    "w": 22,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "health_appointment_fhd_041",
            "name": "healthcare appointment",
            "icon": "calendar_today",
            "category": "healthcare",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "appointment reminder display",
            "tags": [
                "healthcare",
                "appointment",
                "reminder",
                "schedule"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 15,
                    "w": 80,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 15,
                    "y": 35,
                    "w": 25,
                    "h": 35,
                    "type": "icon",
                    "iconType": "event",
                    "special": true
                },
                {
                    "x": 45,
                    "y": 35,
                    "w": 45,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 25,
                    "y": 78,
                    "w": 50,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "health_safety_info_fhd_042",
            "name": "healthcare safety information",
            "icon": "health_and_safety",
            "category": "healthcare",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "safety guidelines display",
            "tags": [
                "healthcare",
                "safety",
                "guidelines",
                "info"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 27,
                    "h": 20,
                    "type": "icon",
                    "iconType": "masks",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 43,
                    "w": 27,
                    "h": 49,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 36,
                    "y": 20,
                    "w": 27,
                    "h": 20,
                    "type": "icon",
                    "iconType": "sanitizer",
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 43,
                    "w": 27,
                    "h": 49,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 67,
                    "y": 20,
                    "w": 27,
                    "h": 20,
                    "type": "icon",
                    "iconType": "social_distance",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 67,
                    "y": 43,
                    "w": 27,
                    "h": 49,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "health_doctor_profile_fhd_043",
            "name": "healthcare doctor profile",
            "icon": "medical_services",
            "category": "healthcare",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "doctor profile showcase",
            "tags": [
                "healthcare",
                "doctor",
                "profile",
                "physician"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 10,
                    "w": 35,
                    "h": 80,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 45,
                    "y": 15,
                    "w": 50,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 45,
                    "y": 32,
                    "w": 50,
                    "h": 8,
                    "type": "title",
                    "lines": 1
                },
                {
                    "x": 45,
                    "y": 45,
                    "w": 50,
                    "h": 35,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 45,
                    "y": 82,
                    "w": 25,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "health_wellness_tips_fhd_044",
            "name": "healthcare wellness tips",
            "icon": "favorite",
            "category": "healthcare",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "wellness and health tips",
            "tags": [
                "healthcare",
                "wellness",
                "tips",
                "health"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 42,
                    "h": 72,
                    "type": "bullets",
                    "lines": 10,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 20,
                    "w": 43,
                    "h": 72,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "health_emergency_fhd_045",
            "name": "healthcare emergency info",
            "icon": "emergency",
            "category": "healthcare",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "emergency contact information",
            "tags": [
                "healthcare",
                "emergency",
                "contact",
                "urgent"
            ],
            "blocks": [
                {
                    "x": 15,
                    "y": 15,
                    "w": 70,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 35,
                    "w": 50,
                    "h": 35,
                    "type": "icon",
                    "iconType": "emergency"
                },
                {
                    "x": 15,
                    "y": 75,
                    "w": 70,
                    "h": 12,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "creative_portfolio_hero_fhd_046",
            "name": "creative portfolio hero",
            "icon": "brush",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "portfolio hero showcase",
            "tags": [
                "creative",
                "portfolio",
                "hero",
                "showcase"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 65,
                    "h": 90,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 73,
                    "y": 20,
                    "w": 22,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 73,
                    "y": 38,
                    "w": 22,
                    "h": 42,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 73,
                    "y": 85,
                    "w": 22,
                    "h": 8,
                    "type": "button"
                }
            ]
        },
        {
            "id": "creative_masonry_fhd_047",
            "name": "creative masonry grid",
            "icon": "view_quilt",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "creative masonry layout",
            "tags": [
                "creative",
                "masonry",
                "grid",
                "mixed"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 44,
                    "h": 77,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 51,
                    "y": 16,
                    "w": 44,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 51,
                    "y": 56,
                    "w": 44,
                    "h": 37,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "creative_art_display_fhd_048",
            "name": "creative art display",
            "icon": "palette",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "artistic showcase layout",
            "tags": [
                "creative",
                "art",
                "display",
                "gallery"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 15,
                    "y": 70,
                    "w": 70,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 15,
                    "y": 83,
                    "w": 70,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "creative_before_after_fhd_049",
            "name": "creative before after",
            "icon": "compare",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "before and after comparison",
            "tags": [
                "creative",
                "compare",
                "before-after",
                "transformation"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 11,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 75,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 75,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                }
            ]
        },
        {
            "id": "creative_mood_board_fhd_050",
            "name": "creative mood board",
            "icon": "photo_library",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "creative mood board collage",
            "tags": [
                "creative",
                "moodboard",
                "collage",
                "inspiration"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 30,
                    "h": 40,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 37,
                    "y": 16,
                    "w": 30,
                    "h": 40,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 69,
                    "y": 16,
                    "w": 26,
                    "h": 40,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 26,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 33,
                    "y": 58,
                    "w": 34,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 69,
                    "y": 58,
                    "w": 26,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "minimal_centered_fhd_051",
            "name": "minimal centered focus",
            "icon": "filter_center_focus",
            "category": "minimal",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "clean centered minimal design",
            "tags": [
                "minimal",
                "centered",
                "clean",
                "simple"
            ],
            "blocks": [
                {
                    "x": 20,
                    "y": 25,
                    "w": 60,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 45,
                    "w": 60,
                    "h": 30,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 35,
                    "y": 80,
                    "w": 30,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "minimal_asymmetric_fhd_052",
            "name": "minimal asymmetric",
            "icon": "crop_free",
            "category": "minimal",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "modern asymmetric minimal layout",
            "tags": [
                "minimal",
                "asymmetric",
                "modern",
                "clean"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 15,
                    "w": 35,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 32,
                    "w": 35,
                    "h": 48,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 55,
                    "y": 25,
                    "w": 35,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "minimal_whitespace_fhd_053",
            "name": "minimal whitespace",
            "icon": "space_bar",
            "category": "minimal",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "generous whitespace design",
            "tags": [
                "minimal",
                "whitespace",
                "breathing-room",
                "clean"
            ],
            "blocks": [
                {
                    "x": 25,
                    "y": 30,
                    "w": 50,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 45,
                    "w": 50,
                    "h": 25,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "minimal_icon_focus_fhd_054",
            "name": "minimal icon focus",
            "icon": "radio_button_checked",
            "category": "minimal",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "icon-centric minimal design",
            "tags": [
                "minimal",
                "icon",
                "focus",
                "simple"
            ],
            "blocks": [
                {
                    "x": 30,
                    "y": 15,
                    "w": 40,
                    "h": 35,
                    "type": "icon",
                    "iconType": "lightbulb",
                    "special": true
                },
                {
                    "x": 25,
                    "y": 55,
                    "w": 50,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 25,
                    "y": 70,
                    "w": 50,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "minimal_single_image_fhd_055",
            "name": "minimal single image",
            "icon": "image",
            "category": "minimal",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "single image minimal layout",
            "tags": [
                "minimal",
                "image",
                "photo",
                "simple"
            ],
            "blocks": [
                {
                    "x": 15,
                    "y": 10,
                    "w": 70,
                    "h": 70,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 85,
                    "w": 50,
                    "h": 8,
                    "type": "title",
                    "lines": 1
                }
            ]
        },
        {
            "id": "bold_diagonal_split_fhd_056",
            "name": "bold diagonal split",
            "icon": "call_split",
            "category": "bold",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "dynamic diagonal composition",
            "tags": [
                "bold",
                "diagonal",
                "dynamic",
                "split"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 48,
                    "h": 90,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 56,
                    "y": 20,
                    "w": 39,
                    "h": 18,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 56,
                    "y": 40,
                    "w": 39,
                    "h": 35,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 56,
                    "y": 80,
                    "w": 20,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "bold_oversized_text_fhd_057",
            "name": "bold oversized typography",
            "icon": "text_fields",
            "category": "bold",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "impact typography layout",
            "tags": [
                "bold",
                "typography",
                "large",
                "impact"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 20,
                    "w": 90,
                    "h": 30,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 50,
                    "w": 80,
                    "h": 30,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 35,
                    "y": 85,
                    "w": 30,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "bold_full_bleed_fhd_058",
            "name": "bold full bleed image",
            "icon": "fullscreen",
            "category": "bold",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "edge-to-edge bold imagery",
            "tags": [
                "bold",
                "full-bleed",
                "immersive",
                "edge-to-edge"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 0,
                    "w": 100,
                    "h": 100,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 70,
                    "w": 80,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 85,
                    "w": 50,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "bold_color_block_fhd_059",
            "name": "bold color blocking",
            "icon": "palette",
            "category": "bold",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "strong color block design",
            "tags": [
                "bold",
                "color",
                "blocks",
                "vibrant"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 35,
                    "h": 90,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 43,
                    "y": 5,
                    "w": 52,
                    "h": 43,
                    "type": "textbox"
                },
                {
                    "x": 43,
                    "y": 52,
                    "w": 52,
                    "h": 43,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "bold_mega_icon_fhd_060",
            "name": "bold mega icon",
            "icon": "stars",
            "category": "bold",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "oversized icon statement",
            "tags": [
                "bold",
                "icon",
                "large",
                "statement"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 10,
                    "w": 50,
                    "h": 80,
                    "type": "icon",
                    "iconType": "rocket_launch",
                    "special": true
                },
                {
                    "x": 60,
                    "y": 25,
                    "w": 35,
                    "h": 18,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 60,
                    "y": 45,
                    "w": 35,
                    "h": 35,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "corp_vision_portrait_061",
            "name": "corporate vision portrait",
            "icon": "visibility",
            "category": "corporate",
            "resolution": "fullhd_portrait",
            "width": 1080,
            "height": 1920,
            "description": "vertical corporate vision display",
            "tags": [
                "corporate",
                "portrait",
                "vision",
                "vertical"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 3,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 13,
                    "w": 90,
                    "h": 40,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 55,
                    "w": 90,
                    "h": 35,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "corp_metrics_portrait_062",
            "name": "corporate metrics portrait",
            "icon": "leaderboard",
            "category": "corporate",
            "resolution": "fullhd_portrait",
            "width": 1080,
            "height": 1920,
            "description": "vertical metrics dashboard",
            "tags": [
                "corporate",
                "portrait",
                "metrics",
                "dashboard"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 2,
                    "w": 90,
                    "h": 9,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 11,
                    "w": 42,
                    "h": 20,
                    "type": "textbox"
                },
                {
                    "x": 53,
                    "y": 11,
                    "w": 42,
                    "h": 20,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 33,
                    "w": 90,
                    "h": 30,
                    "type": "chart",
                    "chartType": "column",
                    "iconType": "insert_chart"
                },
                {
                    "x": 5,
                    "y": 65,
                    "w": 90,
                    "h": 30,
                    "type": "chart",
                    "chartType": "line",
                    "iconType": "show_chart"
                }
            ]
        },
        {
            "id": "mkt_vertical_promo_063",
            "name": "marketing vertical promo",
            "icon": "campaign",
            "category": "marketing",
            "resolution": "fullhd_portrait",
            "width": 1080,
            "height": 1920,
            "description": "vertical promotional display",
            "tags": [
                "marketing",
                "portrait",
                "promo",
                "vertical"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 58,
                    "w": 80,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 70,
                    "w": 80,
                    "h": 18,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 25,
                    "y": 91,
                    "w": 50,
                    "h": 6,
                    "type": "button"
                }
            ]
        },
        {
            "id": "retail_vertical_showcase_064",
            "name": "retail vertical product",
            "icon": "shopping_bag",
            "category": "retail",
            "resolution": "fullhd_portrait",
            "width": 1080,
            "height": 1920,
            "description": "vertical product showcase",
            "tags": [
                "retail",
                "portrait",
                "product",
                "vertical"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 55,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 62,
                    "w": 80,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 72,
                    "w": 80,
                    "h": 15,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 10,
                    "y": 89,
                    "w": 80,
                    "h": 6,
                    "type": "button"
                }
            ]
        },
        {
            "id": "edu_vertical_lesson_066",
            "name": "education vertical lesson",
            "icon": "school",
            "category": "education",
            "resolution": "fullhd_portrait",
            "width": 1080,
            "height": 1920,
            "description": "vertical educational content",
            "tags": [
                "education",
                "portrait",
                "lesson",
                "vertical"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 3,
                    "w": 90,
                    "h": 9,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 12,
                    "w": 80,
                    "h": 12,
                    "type": "icon",
                    "iconType": "menu_book"
                },
                {
                    "x": 5,
                    "y": 26,
                    "w": 90,
                    "h": 35,
                    "type": "text",
                    "lines": 15,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 63,
                    "w": 90,
                    "h": 32,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "hosp_vertical_menu_067",
            "name": "hospitality vertical menu",
            "icon": "restaurant",
            "category": "hospitality",
            "resolution": "fullhd_portrait",
            "width": 1080,
            "height": 1920,
            "description": "vertical restaurant menu",
            "tags": [
                "hospitality",
                "portrait",
                "menu",
                "vertical"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 2,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 12,
                    "w": 90,
                    "h": 83,
                    "type": "bullets",
                    "lines": 25,
                    "special": true
                }
            ]
        },
        {
            "id": "social_vertical_story_068",
            "name": "social vertical story",
            "icon": "collections",
            "category": "social",
            "resolution": "hd_portrait",
            "width": 720,
            "height": 1280,
            "description": "mobile-optimized vertical story",
            "tags": [
                "social",
                "portrait",
                "story",
                "mobile"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 68,
                    "w": 80,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 78,
                    "w": 80,
                    "h": 15,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "minimal_vertical_centered_069",
            "name": "minimal vertical centered",
            "icon": "center_focus_strong",
            "category": "minimal",
            "resolution": "fullhd_portrait",
            "width": 1080,
            "height": 1920,
            "description": "centered vertical minimal",
            "tags": [
                "minimal",
                "portrait",
                "centered",
                "clean"
            ],
            "blocks": [
                {
                    "x": 15,
                    "y": 25,
                    "w": 70,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 15,
                    "y": 40,
                    "w": 70,
                    "h": 30,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 25,
                    "y": 75,
                    "w": 50,
                    "h": 6,
                    "type": "button"
                }
            ]
        },
        {
            "id": "creative_vertical_portfolio_070",
            "name": "creative vertical portfolio",
            "icon": "auto_awesome",
            "category": "creative",
            "resolution": "fullhd_portrait",
            "width": 1080,
            "height": 1920,
            "description": "vertical creative portfolio",
            "tags": [
                "creative",
                "portrait",
                "portfolio",
                "showcase"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 3,
                    "w": 90,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 50,
                    "w": 90,
                    "h": 23,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 5,
                    "y": 75,
                    "w": 90,
                    "h": 9,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 84,
                    "w": 90,
                    "h": 12,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "corp_ultra_dashboard_071",
            "name": "corporate ultrawide dashboard",
            "icon": "dashboard",
            "category": "corporate",
            "resolution": "ultrawide",
            "width": 2560,
            "height": 1080,
            "description": "panoramic executive dashboard",
            "tags": [
                "corporate",
                "ultrawide",
                "dashboard",
                "panoramic"
            ],
            "blocks": [
                {
                    "x": 2,
                    "y": 5,
                    "w": 96,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 2,
                    "y": 16,
                    "w": 15,
                    "h": 78,
                    "type": "textbox"
                },
                {
                    "x": 18,
                    "y": 16,
                    "w": 15,
                    "h": 78,
                    "type": "textbox"
                },
                {
                    "x": 34,
                    "y": 16,
                    "w": 15,
                    "h": 78,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 50,
                    "y": 16,
                    "w": 15,
                    "h": 78,
                    "type": "textbox"
                },
                {
                    "x": 66,
                    "y": 16,
                    "w": 32,
                    "h": 78,
                    "type": "chart",
                    "chartType": "line",
                    "iconType": "show_chart"
                }
            ]
        },
        {
            "id": "media_ultra_gallery_073",
            "name": "media ultrawide gallery",
            "icon": "panorama",
            "category": "media",
            "resolution": "ultrawide",
            "width": 2560,
            "height": 1080,
            "description": "cinematic media gallery",
            "tags": [
                "media",
                "ultrawide",
                "gallery",
                "cinematic"
            ],
            "blocks": [
                {
                    "x": 2,
                    "y": 5,
                    "w": 96,
                    "h": 9,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 2,
                    "y": 15,
                    "w": 23,
                    "h": 80,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 26,
                    "y": 15,
                    "w": 23,
                    "h": 80,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 50,
                    "y": 15,
                    "w": 23,
                    "h": 80,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 74,
                    "y": 15,
                    "w": 23,
                    "h": 80,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "mkt_ultra_hero_074",
            "name": "marketing ultrawide hero",
            "icon": "view_carousel",
            "category": "marketing",
            "resolution": "ultrawide",
            "width": 2560,
            "height": 1080,
            "description": "cinematic marketing hero",
            "tags": [
                "marketing",
                "ultrawide",
                "hero",
                "cinematic"
            ],
            "blocks": [
                {
                    "x": 2,
                    "y": 5,
                    "w": 55,
                    "h": 90,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 60,
                    "y": 20,
                    "w": 36,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 60,
                    "y": 38,
                    "w": 36,
                    "h": 30,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 60,
                    "y": 75,
                    "w": 18,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "creative_ultra_showcase_075",
            "name": "creative ultrawide showcase",
            "icon": "photo_size_select_large",
            "category": "creative",
            "resolution": "ultrawide",
            "width": 2560,
            "height": 1080,
            "description": "panoramic creative showcase",
            "tags": [
                "creative",
                "ultrawide",
                "showcase",
                "panoramic"
            ],
            "blocks": [
                {
                    "x": 2,
                    "y": 5,
                    "w": 96,
                    "h": 55,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 2,
                    "y": 65,
                    "w": 96,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 15,
                    "y": 76,
                    "w": 70,
                    "h": 18,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "corp_standard_presentation_076",
            "name": "corporate standard presentation",
            "icon": "present_to_all",
            "category": "corporate",
            "resolution": "standard_landscape",
            "width": 1024,
            "height": 768,
            "description": "classic presentation layout",
            "tags": [
                "corporate",
                "4:3",
                "presentation",
                "classic"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 42,
                    "h": 70,
                    "type": "bullets",
                    "lines": 8,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 22,
                    "w": 43,
                    "h": 70,
                    "type": "chart",
                    "chartType": "column",
                    "iconType": "insert_chart"
                }
            ]
        },
        {
            "id": "edu_standard_classroom_077",
            "name": "education standard classroom",
            "icon": "co_present",
            "category": "education",
            "resolution": "standard_landscape",
            "width": 1024,
            "height": 768,
            "description": "classroom display layout",
            "tags": [
                "education",
                "4:3",
                "classroom",
                "teaching"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 90,
                    "h": 48,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 74,
                    "w": 90,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "mkt_standard_ad_079",
            "name": "marketing standard advertisement",
            "icon": "announcement",
            "category": "marketing",
            "resolution": "standard_landscape",
            "width": 1024,
            "height": 768,
            "description": "classic ad layout",
            "tags": [
                "marketing",
                "4:3",
                "ad",
                "promotion"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 8,
                    "w": 42,
                    "h": 84,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 20,
                    "w": 43,
                    "h": 18,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 52,
                    "y": 40,
                    "w": 43,
                    "h": 32,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 52,
                    "y": 78,
                    "w": 20,
                    "h": 12,
                    "type": "button"
                }
            ]
        },
        {
            "id": "retail_standard_display_080",
            "name": "retail standard display",
            "icon": "storefront",
            "category": "retail",
            "resolution": "standard_landscape",
            "width": 1024,
            "height": 768,
            "description": "retail product display",
            "tags": [
                "retail",
                "4:3",
                "display",
                "product"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 28,
                    "h": 70,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 22,
                    "w": 28,
                    "h": 70,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 67,
                    "y": 22,
                    "w": 28,
                    "h": 70,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "social_square_std_promo_081",
            "name": "social square standard promo",
            "icon": "tag",
            "category": "social",
            "resolution": "square_standard",
            "width": 800,
            "height": 800,
            "description": "compact square social post",
            "tags": [
                "social",
                "square",
                "promo",
                "compact"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 10,
                    "w": 80,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 64,
                    "w": 80,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 79,
                    "w": 80,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "minimal_square_simple_082",
            "name": "minimal square simple",
            "icon": "crop_square",
            "category": "minimal",
            "resolution": "square_standard",
            "width": 800,
            "height": 800,
            "description": "ultra minimal square",
            "tags": [
                "minimal",
                "square",
                "simple",
                "clean"
            ],
            "blocks": [
                {
                    "x": 20,
                    "y": 30,
                    "w": 60,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 50,
                    "w": 60,
                    "h": 25,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "creative_square_art_083",
            "name": "creative square art",
            "icon": "auto_fix_high",
            "category": "creative",
            "resolution": "square_standard",
            "width": 800,
            "height": 800,
            "description": "artistic square layout",
            "tags": [
                "creative",
                "square",
                "art",
                "design"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 70,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 78,
                    "w": 80,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 90,
                    "w": 80,
                    "h": 8,
                    "type": "text",
                    "lines": 1
                }
            ]
        },
        {
            "id": "data_square_kpi_084",
            "name": "data square kpi",
            "icon": "assessment",
            "category": "data",
            "resolution": "square_standard",
            "width": 800,
            "height": 800,
            "description": "compact kpi display",
            "tags": [
                "data",
                "square",
                "kpi",
                "metrics"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 10,
                    "w": 80,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 26,
                    "w": 80,
                    "h": 65,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 25,
                    "y": 94,
                    "w": 50,
                    "h": 5,
                    "type": "button"
                }
            ]
        },
        {
            "id": "hosp_square_special_085",
            "name": "hospitality square special",
            "icon": "restaurant",
            "category": "hospitality",
            "resolution": "square_standard",
            "width": 800,
            "height": 800,
            "description": "daily special display",
            "tags": [
                "hospitality",
                "square",
                "special",
                "menu"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 10,
                    "w": 80,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 58,
                    "w": 80,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 73,
                    "w": 80,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "corp_compact_brief_086",
            "name": "corporate compact brief",
            "icon": "article",
            "category": "corporate",
            "resolution": "compact_landscape",
            "width": 800,
            "height": 600,
            "description": "compact corporate brief",
            "tags": [
                "corporate",
                "compact",
                "brief",
                "summary"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 42,
                    "h": 70,
                    "type": "text",
                    "lines": 10,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 22,
                    "w": 43,
                    "h": 70,
                    "type": "bullets",
                    "lines": 8
                }
            ]
        },
        {
            "id": "edu_compact_quick_087",
            "name": "education compact quick tip",
            "icon": "tips_and_updates",
            "category": "education",
            "resolution": "compact_landscape",
            "width": 800,
            "height": 600,
            "description": "quick educational tip",
            "tags": [
                "education",
                "compact",
                "tip",
                "quick"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 15,
                    "w": 80,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 15,
                    "y": 32,
                    "w": 70,
                    "h": 50,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 30,
                    "y": 85,
                    "w": 40,
                    "h": 10,
                    "type": "icon",
                    "iconType": "lightbulb"
                }
            ]
        },
        {
            "id": "mkt_compact_flash_088",
            "name": "marketing compact flash sale",
            "icon": "flash_on",
            "category": "marketing",
            "resolution": "compact_landscape",
            "width": 800,
            "height": 600,
            "description": "compact flash sale display",
            "tags": [
                "marketing",
                "compact",
                "sale",
                "flash"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 15,
                    "w": 35,
                    "h": 70,
                    "type": "icon",
                    "iconType": "bolt",
                    "special": true
                },
                {
                    "x": 45,
                    "y": 20,
                    "w": 50,
                    "h": 22,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 45,
                    "y": 45,
                    "w": 50,
                    "h": 30,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "retail_compact_product_089",
            "name": "retail compact product",
            "icon": "inventory_2",
            "category": "retail",
            "resolution": "compact_landscape",
            "width": 800,
            "height": 600,
            "description": "compact product showcase",
            "tags": [
                "retail",
                "compact",
                "product",
                "showcase"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 48,
                    "h": 90,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 56,
                    "y": 15,
                    "w": 39,
                    "h": 18,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 56,
                    "y": 35,
                    "w": 39,
                    "h": 40,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 56,
                    "y": 80,
                    "w": 20,
                    "h": 12,
                    "type": "button"
                }
            ]
        },
        {
            "id": "data_compact_snapshot_090",
            "name": "data compact snapshot",
            "icon": "photo_camera",
            "category": "data",
            "resolution": "compact_landscape",
            "width": 800,
            "height": 600,
            "description": "compact data snapshot",
            "tags": [
                "data",
                "compact",
                "snapshot",
                "quick"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 28,
                    "h": 70,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 22,
                    "w": 28,
                    "h": 70,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 22,
                    "w": 28,
                    "h": 70,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "hosp_digital_portrait_menu_091",
            "name": "hospitality digital signage menu",
            "icon": "menu_book",
            "category": "hospitality",
            "resolution": "digital_signage_portrait",
            "width": 1080,
            "height": 1620,
            "description": "tall digital signage menu",
            "tags": [
                "hospitality",
                "digital-signage",
                "menu",
                "portrait"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 2,
                    "w": 90,
                    "h": 8,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 10,
                    "w": 90,
                    "h": 25,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 37,
                    "w": 90,
                    "h": 60,
                    "type": "bullets",
                    "lines": 20
                }
            ]
        },
        {
            "id": "retail_digital_portrait_promo_092",
            "name": "retail digital signage promo",
            "icon": "storefront",
            "category": "retail",
            "resolution": "digital_signage_portrait",
            "width": 1080,
            "height": 1620,
            "description": "tall retail promotional display",
            "tags": [
                "retail",
                "digital-signage",
                "promo",
                "portrait"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 52,
                    "w": 80,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 62,
                    "w": 80,
                    "h": 25,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 25,
                    "y": 90,
                    "w": 50,
                    "h": 5,
                    "type": "button"
                }
            ]
        },
        {
            "id": "corp_digital_portrait_announce_093",
            "name": "corporate digital signage announcement",
            "icon": "campaign",
            "category": "corporate",
            "resolution": "digital_signage_portrait",
            "width": 1080,
            "height": 1620,
            "description": "tall corporate announcement",
            "tags": [
                "corporate",
                "digital-signage",
                "announcement",
                "portrait"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 8,
                    "w": 80,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 15,
                    "y": 18,
                    "w": 70,
                    "h": 18,
                    "type": "icon",
                    "iconType": "notification_important",
                    "special": true
                },
                {
                    "x": 10,
                    "y": 38,
                    "w": 80,
                    "h": 50,
                    "type": "text",
                    "lines": 20
                },
                {
                    "x": 25,
                    "y": 92,
                    "w": 50,
                    "h": 5,
                    "type": "button"
                }
            ]
        },
        {
            "id": "mkt_digital_portrait_campaign_094",
            "name": "marketing digital signage campaign",
            "icon": "rocket_launch",
            "category": "marketing",
            "resolution": "digital_signage_portrait",
            "width": 1080,
            "height": 1620,
            "description": "tall marketing campaign",
            "tags": [
                "marketing",
                "digital-signage",
                "campaign",
                "portrait"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 3,
                    "w": 90,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 55,
                    "w": 80,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 67,
                    "w": 80,
                    "h": 22,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 25,
                    "y": 92,
                    "w": 50,
                    "h": 5,
                    "type": "button"
                }
            ]
        },
        {
            "id": "edu_digital_portrait_info_095",
            "name": "education digital signage info",
            "icon": "info",
            "category": "education",
            "resolution": "digital_signage_portrait",
            "width": 1080,
            "height": 1620,
            "description": "tall educational information",
            "tags": [
                "education",
                "digital-signage",
                "info",
                "portrait"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 3,
                    "w": 90,
                    "h": 9,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 12,
                    "w": 80,
                    "h": 15,
                    "type": "icon",
                    "iconType": "school"
                },
                {
                    "x": 5,
                    "y": 29,
                    "w": 90,
                    "h": 65,
                    "type": "text",
                    "lines": 25,
                    "special": true
                }
            ]
        },
        {
            "id": "corp_wide_command_center_096",
            "name": "corporate wide command center",
            "icon": "monitoring",
            "category": "corporate",
            "resolution": "wide_landscape",
            "width": 1920,
            "height": 1200,
            "description": "wide format control dashboard",
            "tags": [
                "corporate",
                "16:10",
                "dashboard",
                "command"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 4,
                    "w": 90,
                    "h": 9,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 13,
                    "w": 20,
                    "h": 40,
                    "type": "textbox"
                },
                {
                    "x": 27,
                    "y": 13,
                    "w": 20,
                    "h": 40,
                    "type": "textbox"
                },
                {
                    "x": 49,
                    "y": 13,
                    "w": 20,
                    "h": 40,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 71,
                    "y": 13,
                    "w": 20,
                    "h": 40,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 55,
                    "w": 90,
                    "h": 40,
                    "type": "chart",
                    "chartType": "line",
                    "iconType": "show_chart"
                }
            ]
        },
        {
            "id": "media_wide_cinema_098",
            "name": "media wide cinema display",
            "icon": "theaters",
            "category": "media",
            "resolution": "wide_landscape",
            "width": 1920,
            "height": 1200,
            "description": "cinematic media display",
            "tags": [
                "media",
                "16:10",
                "cinema",
                "display"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 4,
                    "w": 90,
                    "h": 60,
                    "type": "video",
                    "iconType": "play",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 67,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 78,
                    "w": 90,
                    "h": 18,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "creative_wide_showcase_099",
            "name": "creative wide showcase",
            "icon": "photo_size_select_actual",
            "category": "creative",
            "resolution": "wide_landscape",
            "width": 1920,
            "height": 1200,
            "description": "wide creative portfolio",
            "tags": [
                "creative",
                "16:10",
                "showcase",
                "portfolio"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 4,
                    "w": 90,
                    "h": 9,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 13,
                    "w": 58,
                    "h": 82,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 66,
                    "y": 13,
                    "w": 29,
                    "h": 40,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 66,
                    "y": 55,
                    "w": 29,
                    "h": 40,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "mkt_wide_campaign_100",
            "name": "marketing wide campaign",
            "icon": "ads_click",
            "category": "marketing",
            "resolution": "wide_landscape",
            "width": 1920,
            "height": 1200,
            "description": "wide marketing campaign",
            "tags": [
                "marketing",
                "16:10",
                "campaign",
                "promo"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 8,
                    "w": 48,
                    "h": 84,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 56,
                    "y": 15,
                    "w": 39,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 56,
                    "y": 32,
                    "w": 39,
                    "h": 40,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 56,
                    "y": 77,
                    "w": 20,
                    "h": 10,
                    "type": "button"
                }
            ]
        },
        {
            "id": "json_card_profile_001",
            "name": "data card",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple data card with fields and text",
            "tags": [
                "json",
                "data",
                "card",
                "simple"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 8,
                    "w": 42,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 12,
                    "w": 43,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 52,
                    "y": 25,
                    "w": 35,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 32,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 39,
                    "w": 43,
                    "h": 30,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 5,
                    "y": 50,
                    "w": 42,
                    "h": 42,
                    "type": "chart",
                    "chartType": "column",
                    "iconType": "insert_chart"
                }
            ]
        },
        {
            "id": "json_data_dashboard_002",
            "name": "two column article",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper style two column layout",
            "tags": [
                "json",
                "article",
                "columns",
                "text"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 30,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 42,
                    "h": 65,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 53,
                    "y": 22,
                    "w": 42,
                    "h": 65,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_product_card_003",
            "name": "product listing",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "product card with image, title, price and description",
            "tags": [
                "json",
                "product",
                "ecommerce",
                "listing"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 42,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 42,
                    "h": 9,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 42,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 73,
                    "w": 42,
                    "h": 17,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 52,
                    "y": 5,
                    "w": 43,
                    "h": 85,
                    "type": "chart",
                    "chartType": "column",
                    "iconType": "inventory"
                }
            ]
        },
        {
            "id": "json_info_grid_004",
            "name": "three column text",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "magazine three column layout",
            "tags": [
                "json",
                "magazine",
                "columns",
                "text"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 36,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_timeline_card_005",
            "name": "article view",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "article layout with header, author info and content",
            "tags": [
                "json",
                "article",
                "content",
                "news"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 28,
                    "w": 90,
                    "h": 60,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_stats_card_006",
            "name": "stats overview",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "statistics display with header, metric boxes and chart",
            "tags": [
                "json",
                "stats",
                "metrics",
                "analytics"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 90,
                    "h": 44,
                    "type": "chart",
                    "chartType": "column",
                    "iconType": "assessment"
                }
            ]
        },
        {
            "id": "json_team_card_007",
            "name": "team profile",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "team member card with avatar, name, role and bio",
            "tags": [
                "json",
                "team",
                "profile",
                "people"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 30,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 53,
                    "w": 30,
                    "h": 9,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 63,
                    "w": 30,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 30,
                    "h": 22,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 40,
                    "y": 5,
                    "w": 55,
                    "h": 85,
                    "type": "icon",
                    "iconType": "groups",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_feature_list_008",
            "name": "event details",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "event card with image, title, date and description",
            "tags": [
                "json",
                "event",
                "calendar",
                "details"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 40,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 48,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 59,
                    "w": 45,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 59,
                    "w": 43,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 64,
                    "w": 90,
                    "h": 24,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_pricing_card_009",
            "name": "pricing plan",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "pricing card with plan name, price, features and icon",
            "tags": [
                "json",
                "pricing",
                "plan",
                "subscription"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 30,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 90,
                    "h": 34,
                    "type": "icon",
                    "iconType": "storefront",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_location_card_010",
            "name": "location info",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "location card with address, contact and map icon",
            "tags": [
                "json",
                "location",
                "address",
                "contact"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 26,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 33,
                    "w": 90,
                    "h": 55,
                    "type": "icon",
                    "iconType": "location_on",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_event_card_011",
            "name": "user profile",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "user profile with avatar, name, email and bio",
            "tags": [
                "json",
                "user",
                "profile",
                "account"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 35,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 35,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 35,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 74,
                    "w": 35,
                    "h": 16,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 45,
                    "y": 5,
                    "w": 50,
                    "h": 85,
                    "type": "chart",
                    "chartType": "pie",
                    "iconType": "badge"
                }
            ]
        },
        {
            "id": "json_review_card_012",
            "name": "review card",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "review card with rating, reviewer name and comment",
            "tags": [
                "json",
                "review",
                "rating",
                "feedback"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 28,
                    "w": 90,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 66,
                    "w": 90,
                    "h": 22,
                    "type": "icon",
                    "iconType": "article",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_invoice_card_013",
            "name": "invoice summary",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "invoice card with number, date, amount and items",
            "tags": [
                "json",
                "invoice",
                "billing",
                "receipt"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 45,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 16,
                    "w": 43,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 40,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 5,
                    "y": 64,
                    "w": 90,
                    "h": 24,
                    "type": "icon",
                    "iconType": "receipt",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_contact_card_014",
            "name": "contact card",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "contact info with name, phone, email and address",
            "tags": [
                "json",
                "contact",
                "info",
                "details"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 36,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_property_card_015",
            "name": "property listing",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "property card with photo, price, specs and details",
            "tags": [
                "json",
                "property",
                "real estate",
                "listing"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 42,
                    "h": 55,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 63,
                    "w": 42,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 74,
                    "w": 42,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 79,
                    "w": 42,
                    "h": 11,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 52,
                    "y": 5,
                    "w": 43,
                    "h": 85,
                    "type": "icon",
                    "iconType": "business",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_weather_card_016",
            "name": "weather forecast",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "weather card with location, temperature and conditions",
            "tags": [
                "json",
                "weather",
                "forecast",
                "temperature"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 42,
                    "h": 65,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 53,
                    "y": 22,
                    "w": 42,
                    "h": 65,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_recipe_card_017",
            "name": "recipe card",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "recipe card with photo, title, ingredients and instructions",
            "tags": [
                "json",
                "recipe",
                "cooking",
                "food"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 53,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 64,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 90,
                    "h": 19,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_ticket_card_018",
            "name": "ticket info",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "ticket card with event, date, seat and barcode",
            "tags": [
                "json",
                "ticket",
                "event",
                "admission"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 26,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 33,
                    "w": 90,
                    "h": 55,
                    "type": "icon",
                    "iconType": "analytics",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_notification_card_019",
            "name": "notification",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "notification card with title, time, message and icon",
            "tags": [
                "json",
                "notification",
                "alert",
                "message"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 30,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 42,
                    "h": 65,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 53,
                    "y": 22,
                    "w": 42,
                    "h": 65,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_achievement_card_020",
            "name": "achievement badge",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "achievement card with badge icon, title and description",
            "tags": [
                "json",
                "achievement",
                "award",
                "badge"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 40,
                    "type": "icon",
                    "iconType": "badge",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 59,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 64,
                    "w": 90,
                    "h": 24,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_shipment_card_021",
            "name": "shipment tracking",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "shipment card with tracking number, status and delivery info",
            "tags": [
                "json",
                "shipment",
                "tracking",
                "delivery"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 36,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_appointment_card_022",
            "name": "appointment card",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "appointment card with date, time, location and notes",
            "tags": [
                "json",
                "appointment",
                "calendar",
                "schedule"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 45,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 16,
                    "w": 43,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 40,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 5,
                    "y": 64,
                    "w": 90,
                    "h": 24,
                    "type": "icon",
                    "iconType": "calendar_today",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_booking_card_023",
            "name": "booking confirmation",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "booking card with confirmation number, dates and details",
            "tags": [
                "json",
                "booking",
                "reservation",
                "confirmation"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 30,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 42,
                    "h": 65,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 53,
                    "y": 22,
                    "w": 42,
                    "h": 65,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_menu_card_024",
            "name": "menu item",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "menu item card with photo, dish name, price and description",
            "tags": [
                "json",
                "menu",
                "food",
                "restaurant"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 74,
                    "w": 90,
                    "h": 14,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_certificate_card_025",
            "name": "certificate award",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "certificate with title, recipient name, date and seal",
            "tags": [
                "json",
                "certificate",
                "award",
                "achievement"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 24,
                    "w": 28,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 36,
                    "y": 24,
                    "w": 28,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 24,
                    "w": 28,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_subscription_card_026",
            "name": "subscription plan",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "subscription card with plan name, price, billing and features",
            "tags": [
                "json",
                "subscription",
                "billing",
                "plan"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 30,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 42,
                    "h": 65,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 53,
                    "y": 22,
                    "w": 42,
                    "h": 65,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_portfolio_card_027",
            "name": "portfolio project",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "portfolio project with image, title, tech and description",
            "tags": [
                "json",
                "portfolio",
                "project",
                "work"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 55,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 63,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 74,
                    "w": 90,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 79,
                    "w": 90,
                    "h": 9,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_job_card_028",
            "name": "job posting",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "job posting with title, company, location and description",
            "tags": [
                "json",
                "job",
                "careers",
                "hiring"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 45,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 16,
                    "w": 43,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 40,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 5,
                    "y": 64,
                    "w": 90,
                    "h": 24,
                    "type": "icon",
                    "iconType": "work",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_course_card_029",
            "name": "course overview",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "course card with title, instructor, duration and syllabus",
            "tags": [
                "json",
                "course",
                "education",
                "learning"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 45,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 16,
                    "w": 43,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 40,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 5,
                    "y": 64,
                    "w": 90,
                    "h": 24,
                    "type": "icon",
                    "iconType": "school",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_vehicle_card_030",
            "name": "vehicle listing",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "vehicle card with photo, make/model, price and specs",
            "tags": [
                "json",
                "vehicle",
                "auto",
                "car"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 45,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 69,
                    "w": 43,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 74,
                    "w": 90,
                    "h": 14,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_news_brief_031",
            "name": "news brief",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "news brief with headline and two column text",
            "tags": [
                "json",
                "news",
                "article",
                "brief"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 24,
                    "w": 42,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 53,
                    "y": 24,
                    "w": 42,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_product_spec_032",
            "name": "product specs",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "product specifications in three columns",
            "tags": [
                "json",
                "product",
                "specs",
                "details"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "icon",
                    "iconType": "shopping_cart",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 28,
                    "h": 43,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 36,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 22,
                    "w": 28,
                    "h": 65,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_event_listing_033",
            "name": "event listing",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "event listing with date icon and details",
            "tags": [
                "json",
                "event",
                "calendar",
                "listing"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 20,
                    "h": 82,
                    "type": "icon",
                    "iconType": "event",
                    "rounded": true
                },
                {
                    "x": 28,
                    "y": 5,
                    "w": 67,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 61,
                    "y": 18,
                    "w": 34,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 67,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_featured_article_034",
            "name": "featured article",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "featured article with headline and three columns",
            "tags": [
                "json",
                "article",
                "featured",
                "news"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 28,
                    "h": 67,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 36,
                    "y": 20,
                    "w": 28,
                    "h": 67,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 20,
                    "w": 28,
                    "h": 67,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_stats_card_035",
            "name": "statistics card",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "statistics card with icon and data fields",
            "tags": [
                "json",
                "statistics",
                "data",
                "metrics"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "icon",
                    "iconType": "analytics",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 21,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 26,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 90,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_quote_card_036",
            "name": "quote display",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "quote card with icon and two column layout",
            "tags": [
                "json",
                "quote",
                "testimonial",
                "text"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 20,
                    "h": 82,
                    "type": "icon",
                    "iconType": "format_quote",
                    "rounded": true
                },
                {
                    "x": 28,
                    "y": 5,
                    "w": 67,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 30,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_update_feed_037",
            "name": "update feed",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "update feed with icon and field list",
            "tags": [
                "json",
                "update",
                "feed",
                "news"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 24,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 24,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 24,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 30,
                    "w": 90,
                    "h": 57,
                    "type": "text",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_profile_detail_038",
            "name": "profile details",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "profile with person icon and info columns",
            "tags": [
                "json",
                "profile",
                "user",
                "person"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "icon",
                    "iconType": "person",
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 21,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 21,
                    "w": 28,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 90,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_timeline_entry_039",
            "name": "timeline entry",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "timeline entry with timeline icon and two columns",
            "tags": [
                "json",
                "timeline",
                "history",
                "events"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 20,
                    "h": 69,
                    "type": "icon",
                    "iconType": "timeline",
                    "rounded": true
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 61,
                    "y": 18,
                    "w": 34,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 30,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_announcement_040",
            "name": "announcement",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "announcement with campaign icon and text columns",
            "tags": [
                "json",
                "announcement",
                "news",
                "alert"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 20,
                    "h": 82,
                    "type": "icon",
                    "iconType": "campaign",
                    "rounded": true
                },
                {
                    "x": 28,
                    "y": 5,
                    "w": 67,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field",
                    "special": true
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 30,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_press_release_041",
            "name": "press release",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "press release with headline and three text columns",
            "tags": [
                "json",
                "press",
                "news",
                "release"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 20,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 26,
                    "w": 28,
                    "h": 61,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 36,
                    "y": 26,
                    "w": 28,
                    "h": 61,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 26,
                    "w": 28,
                    "h": 61,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_report_summary_042",
            "name": "report summary",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "report summary with icon and two column layout",
            "tags": [
                "json",
                "report",
                "summary",
                "document"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 20,
                    "h": 82,
                    "type": "icon",
                    "iconType": "description",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 5,
                    "w": 67,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 61,
                    "y": 18,
                    "w": 34,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 30,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_testimonial_043",
            "name": "testimonial",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "testimonial with star icon and text columns",
            "tags": [
                "json",
                "testimonial",
                "review",
                "feedback"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 20,
                    "h": 69,
                    "type": "icon",
                    "iconType": "star",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 30,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_financial_card_044",
            "name": "financial data",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "financial data with payments icon and fields",
            "tags": [
                "json",
                "financial",
                "payments",
                "money"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "icon",
                    "iconType": "payments",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 21,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 26,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 31,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 90,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_editorial_045",
            "name": "editorial column",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "editorial column with headline and two columns",
            "tags": [
                "json",
                "editorial",
                "opinion",
                "column"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 26,
                    "w": 42,
                    "h": 61,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 53,
                    "y": 26,
                    "w": 42,
                    "h": 61,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_directory_entry_046",
            "name": "directory entry",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "directory entry with location icon and details",
            "tags": [
                "json",
                "directory",
                "location",
                "business"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 20,
                    "h": 69,
                    "type": "icon",
                    "iconType": "location_on",
                    "rounded": true
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 61,
                    "y": 18,
                    "w": 34,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 30,
                    "w": 67,
                    "h": 57,
                    "type": "text",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_bulletin_047",
            "name": "bulletin board",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bulletin board with pin icon and three columns",
            "tags": [
                "json",
                "bulletin",
                "notice",
                "board"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 20,
                    "type": "icon",
                    "iconType": "push_pin",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 69,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 69,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 5,
                    "y": 41,
                    "w": 28,
                    "h": 46,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_service_listing_048",
            "name": "service listing",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "service listing with build icon and columns",
            "tags": [
                "json",
                "service",
                "listing",
                "business"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 20,
                    "h": 82,
                    "type": "icon",
                    "iconType": "build",
                    "rounded": true
                },
                {
                    "x": 28,
                    "y": 5,
                    "w": 67,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 61,
                    "y": 18,
                    "w": 34,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 67,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_feature_spotlight_049",
            "name": "feature spotlight",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "feature spotlight with lightbulb icon and columns",
            "tags": [
                "json",
                "feature",
                "spotlight",
                "highlight"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 30,
                    "type": "icon",
                    "iconType": "lightbulb",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 24,
                    "w": 28,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 24,
                    "w": 28,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 5,
                    "y": 51,
                    "w": 28,
                    "h": 36,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_inventory_item_050",
            "name": "inventory item",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "inventory item with inventory icon and data fields",
            "tags": [
                "json",
                "inventory",
                "stock",
                "warehouse"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 22,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 22,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 28,
                    "w": 90,
                    "h": 59,
                    "type": "text",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_campaign_brief_051",
            "name": "campaign brief",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "campaign brief with rocket icon and text columns",
            "tags": [
                "json",
                "campaign",
                "marketing",
                "launch"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 20,
                    "h": 82,
                    "type": "icon",
                    "iconType": "rocket_launch",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 5,
                    "w": 67,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 30,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_performance_review_052",
            "name": "performance review",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "performance review with trending icon and data",
            "tags": [
                "json",
                "performance",
                "review",
                "metrics"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 20,
                    "h": 69,
                    "type": "icon",
                    "iconType": "trending_up",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 61,
                    "y": 18,
                    "w": 34,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 30,
                    "w": 67,
                    "h": 57,
                    "type": "text",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_blog_post_053",
            "name": "blog post",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "blog post with article icon and three columns",
            "tags": [
                "json",
                "blog",
                "article",
                "post"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 26,
                    "w": 28,
                    "h": 61,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 36,
                    "y": 26,
                    "w": 28,
                    "h": 61,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 26,
                    "w": 28,
                    "h": 61,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_policy_update_054",
            "name": "policy update",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "policy update with gavel icon and two columns",
            "tags": [
                "json",
                "policy",
                "update",
                "legal"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 20,
                    "h": 82,
                    "type": "icon",
                    "iconType": "gavel",
                    "rounded": true
                },
                {
                    "x": 28,
                    "y": 5,
                    "w": 67,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 61,
                    "y": 18,
                    "w": 34,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 30,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_team_update_055",
            "name": "team update",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "team update with groups icon and text",
            "tags": [
                "json",
                "team",
                "update",
                "people"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 30,
                    "type": "icon",
                    "iconType": "groups",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 51,
                    "w": 28,
                    "h": 36,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 36,
                    "y": 24,
                    "w": 28,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 24,
                    "w": 28,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_security_alert_056",
            "name": "security alert",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "security alert with shield icon and details",
            "tags": [
                "json",
                "security",
                "alert",
                "warning"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 20,
                    "h": 69,
                    "type": "icon",
                    "iconType": "security",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 61,
                    "y": 18,
                    "w": 34,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 30,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_milestone_card_057",
            "name": "milestone card",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "milestone card with flag icon and columns",
            "tags": [
                "json",
                "milestone",
                "achievement",
                "goal"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 20,
                    "h": 82,
                    "type": "icon",
                    "iconType": "flag",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 5,
                    "w": 67,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 30,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 61,
                    "y": 24,
                    "w": 34,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_research_note_058",
            "name": "research note",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "research note with science icon and text columns",
            "tags": [
                "json",
                "research",
                "science",
                "study"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 25,
                    "type": "icon",
                    "iconType": "science",
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 69,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 69,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 28,
                    "h": 41,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_helpdesk_ticket_059",
            "name": "helpdesk ticket",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "helpdesk ticket with support icon and fields",
            "tags": [
                "json",
                "helpdesk",
                "support",
                "ticket"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "icon",
                    "iconType": "support_agent",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 21,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 26,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 90,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_magazine_article_060",
            "name": "magazine article",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "magazine article with large headline and three columns",
            "tags": [
                "json",
                "magazine",
                "article",
                "editorial"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 17,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 22,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 28,
                    "w": 28,
                    "h": 59,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 36,
                    "y": 28,
                    "w": 28,
                    "h": 59,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 28,
                    "w": 28,
                    "h": 59,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_accent_left_061",
            "name": "accent left card",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "card with left accent icon and content on right",
            "tags": [
                "json",
                "accent",
                "card",
                "layout"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 18,
                    "h": 82,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 26,
                    "y": 5,
                    "w": 69,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 26,
                    "y": 18,
                    "w": 69,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 26,
                    "y": 23,
                    "w": 69,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 26,
                    "y": 28,
                    "w": 69,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 26,
                    "y": 35,
                    "w": 69,
                    "h": 52,
                    "type": "text",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_big_numbers_062",
            "name": "big numbers",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three big number stats with labels",
            "tags": [
                "json",
                "numbers",
                "stats",
                "metrics"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 44,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 44,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 50,
                    "w": 90,
                    "h": 37,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_image_grid_063",
            "name": "image grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "grid of images with text below",
            "tags": [
                "json",
                "images",
                "grid",
                "gallery"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 20,
                    "h": 30,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 28,
                    "y": 16,
                    "w": 20,
                    "h": 30,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 51,
                    "y": 16,
                    "w": 20,
                    "h": 30,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 74,
                    "y": 16,
                    "w": 20,
                    "h": 30,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 49,
                    "w": 90,
                    "h": 38,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_accent_top_064",
            "name": "accent top",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "card with top accent image and content below",
            "tags": [
                "json",
                "accent",
                "top",
                "card"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 43,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 54,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 59,
                    "w": 90,
                    "h": 28,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_four_columns_065",
            "name": "four columns",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "four column layout with fields",
            "tags": [
                "json",
                "columns",
                "grid",
                "layout"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 20,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 20,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 51,
                    "y": 18,
                    "w": 20,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 74,
                    "y": 18,
                    "w": 20,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 24,
                    "w": 20,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 28,
                    "y": 24,
                    "w": 20,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 51,
                    "y": 24,
                    "w": 20,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 74,
                    "y": 24,
                    "w": 20,
                    "h": 63,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_split_layout_066",
            "name": "split layout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "split layout with icon on left, text on right",
            "tags": [
                "json",
                "split",
                "hero",
                "layout"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 42,
                    "h": 82,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 5,
                    "w": 43,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 52,
                    "y": 20,
                    "w": 43,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 52,
                    "y": 25,
                    "w": 43,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 52,
                    "y": 30,
                    "w": 43,
                    "h": 57,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_nested_cards_067",
            "name": "nested items",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "nested card layout with multiple sections",
            "tags": [
                "json",
                "nested",
                "cards",
                "sections"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 90,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 60,
                    "w": 90,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 81,
                    "w": 90,
                    "h": 6,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_circle_stats_068",
            "name": "circle stats",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "circular icons with stats below",
            "tags": [
                "json",
                "circle",
                "stats",
                "icons"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "icon",
                    "iconType": "Speed",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "icon",
                    "iconType": "trending_up",
                    "rounded": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 54,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 54,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 60,
                    "w": 90,
                    "h": 27,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_image_left_069",
            "name": "image left text right",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image on left with text columns on right",
            "tags": [
                "json",
                "image",
                "split",
                "layout"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 42,
                    "h": 82,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 5,
                    "w": 43,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 52,
                    "y": 18,
                    "w": 43,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 52,
                    "y": 23,
                    "w": 43,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 52,
                    "y": 30,
                    "w": 43,
                    "h": 57,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_table_layout_070",
            "name": "table rows",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "table-like layout with rows of fields",
            "tags": [
                "json",
                "table",
                "rows",
                "grid"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 21,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 26,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 26,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 31,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 31,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 38,
                    "w": 90,
                    "h": 49,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_accent_background_071",
            "name": "accent background",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "card with accent background and centered content",
            "tags": [
                "json",
                "accent",
                "background",
                "centered"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 90,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 58,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 63,
                    "w": 90,
                    "h": 24,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_icon_row_072",
            "name": "icon row",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "row of icons with text below",
            "tags": [
                "json",
                "icons",
                "row",
                "features"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 20,
                    "h": 25,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 20,
                    "h": 25,
                    "type": "icon",
                    "iconType": "thumb_up",
                    "rounded": true
                },
                {
                    "x": 51,
                    "y": 18,
                    "w": 20,
                    "h": 25,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true
                },
                {
                    "x": 74,
                    "y": 18,
                    "w": 20,
                    "h": 25,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 90,
                    "h": 41,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_compact_list_073",
            "name": "compact list",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "compact list with small icon and fields",
            "tags": [
                "json",
                "list",
                "compact",
                "dense"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 12,
                    "h": 71,
                    "type": "icon",
                    "iconType": "list",
                    "rounded": true
                },
                {
                    "x": 20,
                    "y": 16,
                    "w": 75,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 20,
                    "y": 21,
                    "w": 75,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 20,
                    "y": 26,
                    "w": 75,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 20,
                    "y": 31,
                    "w": 75,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 20,
                    "y": 36,
                    "w": 75,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 20,
                    "y": 41,
                    "w": 75,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 20,
                    "y": 48,
                    "w": 75,
                    "h": 39,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_two_images_074",
            "name": "two images side by side",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "two images side by side with text below",
            "tags": [
                "json",
                "images",
                "compare",
                "gallery"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 42,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 42,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 61,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 61,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 66,
                    "w": 90,
                    "h": 21,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_chart_focus_075",
            "name": "chart focus",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large chart with header and minimal text",
            "tags": [
                "json",
                "chart",
                "data",
                "visual"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 24,
                    "w": 90,
                    "h": 55,
                    "type": "chart",
                    "chartType": "line",
                    "iconType": "show_chart",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 82,
                    "w": 90,
                    "h": 5,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_sidebar_layout_076",
            "name": "sidebar layout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "narrow sidebar with main content area",
            "tags": [
                "json",
                "sidebar",
                "layout",
                "split"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 18,
                    "h": 20,
                    "type": "icon",
                    "iconType": "menu",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 18,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 18,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 49,
                    "w": 18,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 26,
                    "y": 16,
                    "w": 69,
                    "h": 71,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_grid_cards_077",
            "name": "grid cards",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "grid of small cards with icons",
            "tags": [
                "json",
                "grid",
                "cards",
                "icons"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 30,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 30,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 30,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 49,
                    "w": 28,
                    "h": 30,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 49,
                    "w": 28,
                    "h": 30,
                    "type": "textbox"
                },
                {
                    "x": 67,
                    "y": 49,
                    "w": 28,
                    "h": 30,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 82,
                    "w": 90,
                    "h": 5,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_hero_banner_078",
            "name": "hero banner",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "hero banner with large text and image background",
            "tags": [
                "json",
                "hero",
                "banner",
                "featured"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 73,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 73,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 78,
                    "w": 90,
                    "h": 9,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_feature_comparison_079",
            "name": "feature comparison",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "comparison layout with two columns",
            "tags": [
                "json",
                "comparison",
                "features",
                "columns"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 8,
                    "type": "textbox"
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 8,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 29,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 29,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 34,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 34,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 42,
                    "h": 48,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 53,
                    "y": 39,
                    "w": 42,
                    "h": 48,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_timeline_vertical_080",
            "name": "vertical timeline",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "vertical timeline with icon and steps",
            "tags": [
                "json",
                "timeline",
                "vertical",
                "steps"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 12,
                    "h": 15,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 16,
                    "w": 75,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 20,
                    "y": 21,
                    "w": 75,
                    "h": 8,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 34,
                    "w": 12,
                    "h": 15,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 20,
                    "y": 34,
                    "w": 75,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 20,
                    "y": 39,
                    "w": 75,
                    "h": 8,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 52,
                    "w": 12,
                    "h": 15,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 20,
                    "y": 52,
                    "w": 75,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 20,
                    "y": 57,
                    "w": 75,
                    "h": 30,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_three_images_081",
            "name": "three image columns",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three image columns with text below",
            "tags": [
                "json",
                "images",
                "gallery",
                "columns"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 42,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 42,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 42,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 61,
                    "w": 90,
                    "h": 26,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_pie_donut_082",
            "name": "pie and donut charts",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "two charts side by side with stats",
            "tags": [
                "json",
                "chart",
                "pie",
                "donut"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 50,
                    "type": "chart",
                    "chartType": "pie",
                    "iconType": "pie_chart",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 50,
                    "type": "chart",
                    "chartType": "doughnut",
                    "iconType": "donut_large"
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 69,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 74,
                    "w": 90,
                    "h": 13,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_bar_column_083",
            "name": "bar and column charts",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bar and column charts with labels",
            "tags": [
                "json",
                "chart",
                "bar",
                "column"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 42,
                    "type": "chart",
                    "chartType": "bar",
                    "iconType": "insert_chart"
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 42,
                    "type": "chart",
                    "chartType": "column",
                    "iconType": "insert_chart",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 61,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 61,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 66,
                    "w": 90,
                    "h": 21,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_team_photos_084",
            "name": "team photos grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "grid of team member photos",
            "tags": [
                "json",
                "team",
                "photos",
                "people"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 54,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 54,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 59,
                    "w": 90,
                    "h": 28,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_image_gallery_085",
            "name": "image gallery horizontal",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "horizontal image gallery strip",
            "tags": [
                "json",
                "gallery",
                "images",
                "strip"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 28,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 28,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 28,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 47,
                    "w": 90,
                    "h": 40,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_accent_right_086",
            "name": "accent right",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "content on left with accent icon on right",
            "tags": [
                "json",
                "accent",
                "right",
                "layout"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 69,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 69,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 23,
                    "w": 69,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 28,
                    "w": 69,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 35,
                    "w": 69,
                    "h": 52,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 77,
                    "y": 5,
                    "w": 18,
                    "h": 82,
                    "type": "icon",
                    "iconType": "workspace_premium",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_content_button_087",
            "name": "content with button",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "text content with call to action button",
            "tags": [
                "json",
                "button",
                "cta",
                "action"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 23,
                    "w": 90,
                    "h": 42,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 28,
                    "h": 10,
                    "type": "button"
                },
                {
                    "x": 36,
                    "y": 68,
                    "w": 28,
                    "h": 10,
                    "type": "button",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 81,
                    "w": 90,
                    "h": 6,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_toggle_sections_088",
            "name": "toggle sections",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "accordion style toggle sections",
            "tags": [
                "json",
                "toggle",
                "accordion",
                "sections"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 8,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 27,
                    "w": 90,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 48,
                    "w": 90,
                    "h": 8,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 59,
                    "w": 90,
                    "h": 8,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 70,
                    "w": 90,
                    "h": 17,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_title_card_089",
            "name": "title card simple",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple title card with minimal content",
            "tags": [
                "json",
                "title",
                "simple",
                "card"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 22,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 26,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 26,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 31,
                    "w": 90,
                    "h": 56,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_gif_embed_090",
            "name": "gif or media embed",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "embedded gif or media with caption",
            "tags": [
                "json",
                "gif",
                "media",
                "embed"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 50,
                    "type": "video",
                    "iconType": "gif_box",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 71,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 76,
                    "w": 90,
                    "h": 11,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_diagram_flow_091",
            "name": "diagram or flowchart",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flowchart or diagram layout",
            "tags": [
                "json",
                "diagram",
                "flowchart",
                "process"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 20,
                    "y": 37,
                    "w": 28,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 52,
                    "y": 37,
                    "w": 28,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 58,
                    "w": 28,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 79,
                    "w": 90,
                    "h": 8,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_youtube_embed_092",
            "name": "video player",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "video player embed with description",
            "tags": [
                "json",
                "video",
                "youtube",
                "player"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 55,
                    "type": "video",
                    "iconType": "play_circle",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 76,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 81,
                    "w": 90,
                    "h": 6,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_webpage_embed_093",
            "name": "webpage embed",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "embedded webpage or iframe",
            "tags": [
                "json",
                "webpage",
                "embed",
                "iframe"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 60,
                    "type": "video",
                    "iconType": "web"
                },
                {
                    "x": 5,
                    "y": 79,
                    "w": 90,
                    "h": 8,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_stats_bar_094",
            "name": "bar stats horizontal",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "horizontal bar stats with percentages",
            "tags": [
                "json",
                "stats",
                "bars",
                "progress"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 12,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 33,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 33,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 33,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 38,
                    "w": 90,
                    "h": 49,
                    "type": "text",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_split_image_text_096",
            "name": "split vertical",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "vertical split with image top and text bottom",
            "tags": [
                "json",
                "split",
                "vertical",
                "image"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 53,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 64,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 64,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 90,
                    "h": 18,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_metric_cards_097",
            "name": "metric cards row",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "row of metric cards with icons",
            "tags": [
                "json",
                "metrics",
                "cards",
                "stats"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 20,
                    "h": 15,
                    "type": "icon",
                    "iconType": "analytics",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 16,
                    "w": 20,
                    "h": 15,
                    "type": "icon",
                    "iconType": "trending_up",
                    "rounded": true
                },
                {
                    "x": 51,
                    "y": 16,
                    "w": 20,
                    "h": 15,
                    "type": "icon",
                    "iconType": "speed",
                    "rounded": true
                },
                {
                    "x": 74,
                    "y": 16,
                    "w": 20,
                    "h": 15,
                    "type": "icon",
                    "iconType": "auto_graph",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 34,
                    "w": 20,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 28,
                    "y": 34,
                    "w": 20,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 51,
                    "y": 34,
                    "w": 20,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 74,
                    "y": 34,
                    "w": 20,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 90,
                    "h": 48,
                    "type": "text",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_testimonial_quote_098",
            "name": "testimonial with quote",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large quote with author info",
            "tags": [
                "json",
                "testimonial",
                "quote",
                "review"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 15,
                    "h": 55,
                    "type": "icon",
                    "iconType": "format_quote",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 23,
                    "y": 18,
                    "w": 72,
                    "h": 45,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 23,
                    "y": 66,
                    "w": 72,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 23,
                    "y": 71,
                    "w": 72,
                    "h": 16,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_pricing_card_099",
            "name": "pricing card",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "pricing card with features list",
            "tags": [
                "json",
                "pricing",
                "plan",
                "subscription"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 20,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 41,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 51,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 61,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 66,
                    "w": 90,
                    "h": 10,
                    "type": "button"
                },
                {
                    "x": 5,
                    "y": 79,
                    "w": 90,
                    "h": 8,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_faq_item_100",
            "name": "faq question",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "faq question and answer format",
            "tags": [
                "json",
                "faq",
                "question",
                "answer"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 15,
                    "h": 67,
                    "type": "icon",
                    "iconType": "help_outline",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 23,
                    "y": 20,
                    "w": 72,
                    "h": 67,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_horizontal_split_101",
            "name": "horizontal equal split",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "equal horizontal split layout",
            "tags": [
                "json",
                "split",
                "horizontal",
                "equal"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 71,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 71,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_bottom_header_102",
            "name": "bottom header flip",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "content first, header at bottom - flipped layout",
            "tags": [
                "json",
                "bottom",
                "flip",
                "reverse"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 42,
                    "h": 55,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 53,
                    "y": 5,
                    "w": 42,
                    "h": 55,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 5,
                    "y": 63,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 63,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 83,
                    "w": 90,
                    "h": 4,
                    "type": "text",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_right_image_103",
            "name": "text left image right",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "text columns on left, large image on right",
            "tags": [
                "json",
                "image",
                "right",
                "flip"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 43,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 43,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 23,
                    "w": 43,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 30,
                    "w": 43,
                    "h": 57,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 52,
                    "y": 5,
                    "w": 43,
                    "h": 82,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_centered_icon_104",
            "name": "centered icon radial",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "centered icon with content radiating around",
            "tags": [
                "json",
                "centered",
                "radial",
                "icon"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 35,
                    "y": 16,
                    "w": 25,
                    "h": 45,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 64,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 64,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 64,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 90,
                    "h": 18,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_corner_accent_105",
            "name": "corner accent icon",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "small icon in corner with main content",
            "tags": [
                "json",
                "corner",
                "accent",
                "minimal"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 90,
                    "h": 50,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 78,
                    "y": 73,
                    "w": 17,
                    "h": 14,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_bottom_image_106",
            "name": "image at bottom",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "text content above, image at bottom",
            "tags": [
                "json",
                "bottom",
                "image",
                "reverse"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 23,
                    "w": 90,
                    "h": 20,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 90,
                    "h": 41,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_diagonal_split_107",
            "name": "diagonal content",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "diagonal staggered content blocks",
            "tags": [
                "json",
                "diagonal",
                "stagger",
                "creative"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 35,
                    "h": 25,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 45,
                    "y": 28,
                    "w": 35,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 15,
                    "y": 56,
                    "w": 35,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 55,
                    "y": 68,
                    "w": 35,
                    "h": 19,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_circular_icons_108",
            "name": "circular icon pattern",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "circular arrangement of icons",
            "tags": [
                "json",
                "circular",
                "icons",
                "radial"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 15,
                    "y": 18,
                    "w": 18,
                    "h": 20,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true
                },
                {
                    "x": 66,
                    "y": 18,
                    "w": 18,
                    "h": 20,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 41,
                    "w": 18,
                    "h": 20,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true
                },
                {
                    "x": 76,
                    "y": 41,
                    "w": 18,
                    "h": 20,
                    "type": "icon",
                    "iconType": "thumb_up",
                    "rounded": true
                },
                {
                    "x": 41,
                    "y": 64,
                    "w": 18,
                    "h": 20,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_minimal_center_109",
            "name": "minimal centered",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "minimal centered content with breathing room",
            "tags": [
                "json",
                "minimal",
                "centered",
                "simple"
            ],
            "blocks": [
                {
                    "x": 20,
                    "y": 15,
                    "w": 60,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 20,
                    "y": 30,
                    "w": 60,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 20,
                    "y": 35,
                    "w": 60,
                    "h": 40,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 35,
                    "y": 78,
                    "w": 30,
                    "h": 9,
                    "type": "button",
                    "special": true
                }
            ]
        },
        {
            "id": "json_stacked_cards_110",
            "name": "stacked card style",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "vertically stacked card sections",
            "tags": [
                "json",
                "stacked",
                "vertical",
                "cards"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 34,
                    "w": 90,
                    "h": 15,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 52,
                    "w": 90,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 70,
                    "w": 90,
                    "h": 17,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_L_shaped_111",
            "name": "L-shaped layout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "L-shaped content arrangement",
            "tags": [
                "json",
                "L-shape",
                "creative",
                "layout"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 43,
                    "h": 69,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 52,
                    "y": 18,
                    "w": 43,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 56,
                    "w": 43,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 52,
                    "y": 61,
                    "w": 43,
                    "h": 2,
                    "type": "field"
                }
            ]
        },
        {
            "id": "json_floating_elements_112",
            "name": "floating elements",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "scattered floating content blocks",
            "tags": [
                "json",
                "floating",
                "scattered",
                "creative"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 25,
                    "h": 20,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 35,
                    "y": 20,
                    "w": 30,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 70,
                    "y": 16,
                    "w": 25,
                    "h": 20,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true
                },
                {
                    "x": 15,
                    "y": 42,
                    "w": 35,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 55,
                    "y": 50,
                    "w": 35,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 25,
                    "y": 71,
                    "w": 50,
                    "h": 16,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_inverted_pyramid_113",
            "name": "inverted pyramid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "narrow top expanding to wide bottom",
            "tags": [
                "json",
                "pyramid",
                "inverted",
                "shape"
            ],
            "blocks": [
                {
                    "x": 30,
                    "y": 5,
                    "w": 40,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 35,
                    "y": 18,
                    "w": 30,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 25,
                    "y": 23,
                    "w": 50,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 15,
                    "y": 46,
                    "w": 70,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 90,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                }
            ]
        },
        {
            "id": "json_zigzag_114",
            "name": "zigzag layout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "alternating left-right content blocks",
            "tags": [
                "json",
                "zigzag",
                "alternating",
                "pattern"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 40,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 55,
                    "y": 31,
                    "w": 40,
                    "h": 12,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 40,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 55,
                    "y": 61,
                    "w": 40,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 76,
                    "w": 90,
                    "h": 11,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_right_sidebar_115",
            "name": "right sidebar flip",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "main content left, sidebar on right",
            "tags": [
                "json",
                "sidebar",
                "right",
                "flip"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 69,
                    "h": 71,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 77,
                    "y": 16,
                    "w": 18,
                    "h": 20,
                    "type": "icon",
                    "iconType": "menu",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 77,
                    "y": 39,
                    "w": 18,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 77,
                    "y": 44,
                    "w": 18,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 77,
                    "y": 49,
                    "w": 18,
                    "h": 2,
                    "type": "field"
                }
            ]
        },
        {
            "id": "json_cross_layout_116",
            "name": "cross pattern",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "cross-shaped content arrangement",
            "tags": [
                "json",
                "cross",
                "pattern",
                "radial"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 34,
                    "w": 28,
                    "h": 20,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 34,
                    "w": 28,
                    "h": 20,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 67,
                    "y": 34,
                    "w": 28,
                    "h": 20,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 57,
                    "w": 28,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 75,
                    "w": 90,
                    "h": 12,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_bottom_icons_117",
            "name": "icons at bottom",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "text content above, icon row at bottom",
            "tags": [
                "json",
                "bottom",
                "icons",
                "reverse"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 40,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 61,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 61,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true
                },
                {
                    "x": 51,
                    "y": 61,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true
                },
                {
                    "x": 74,
                    "y": 61,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "thumb_up",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 82,
                    "w": 90,
                    "h": 5,
                    "type": "text",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_spotlight_center_118",
            "name": "spotlight center",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large centered element with surrounding text",
            "tags": [
                "json",
                "spotlight",
                "center",
                "focus"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 40,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 40,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 40,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 59,
                    "w": 90,
                    "h": 28,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_offset_grid_119",
            "name": "offset grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "offset grid pattern with staggered blocks",
            "tags": [
                "json",
                "offset",
                "grid",
                "stagger"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 25,
                    "h": 20,
                    "type": "textbox"
                },
                {
                    "x": 35,
                    "y": 16,
                    "w": 25,
                    "h": 20,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 65,
                    "y": 16,
                    "w": 25,
                    "h": 20,
                    "type": "textbox"
                },
                {
                    "x": 20,
                    "y": 39,
                    "w": 25,
                    "h": 20,
                    "type": "textbox"
                },
                {
                    "x": 50,
                    "y": 39,
                    "w": 25,
                    "h": 20,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 62,
                    "w": 90,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_reverse_hero_120",
            "name": "reverse hero",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "content first, hero image at bottom",
            "tags": [
                "json",
                "reverse",
                "hero",
                "bottom"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 20,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 25,
                    "w": 90,
                    "h": 12,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 40,
                    "w": 90,
                    "h": 47,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_corner_cluster_121",
            "name": "corner cluster",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "content clustered in corners",
            "tags": [
                "json",
                "corners",
                "cluster",
                "scattered"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 35,
                    "h": 30,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 60,
                    "y": 16,
                    "w": 35,
                    "h": 30,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 52,
                    "w": 35,
                    "h": 30,
                    "type": "textbox"
                },
                {
                    "x": 60,
                    "y": 52,
                    "w": 35,
                    "h": 30,
                    "type": "textbox"
                },
                {
                    "x": 30,
                    "y": 35,
                    "w": 40,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_vertical_thirds_122",
            "name": "vertical thirds",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three vertical sections stacked",
            "tags": [
                "json",
                "vertical",
                "thirds",
                "stacked"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 20,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 90,
                    "h": 20,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 62,
                    "w": 90,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_frame_border_123",
            "name": "frame border",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "content framed with border elements",
            "tags": [
                "json",
                "frame",
                "border",
                "surround"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 12,
                    "h": 50,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 20,
                    "w": 60,
                    "h": 55,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 83,
                    "y": 16,
                    "w": 12,
                    "h": 50,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 78,
                    "w": 60,
                    "h": 9,
                    "type": "button"
                }
            ]
        },
        {
            "id": "json_bullets_three_col_124",
            "name": "three column bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three columns with bullet lists",
            "tags": [
                "json",
                "bullets",
                "columns",
                "list"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 5,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 5,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 5,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 24,
                    "w": 28,
                    "h": 63,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 36,
                    "y": 24,
                    "w": 28,
                    "h": 63,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 67,
                    "y": 24,
                    "w": 28,
                    "h": 63,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_bullets_icons_top_125",
            "name": "bullets with icons above",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "icons on top with bullets below",
            "tags": [
                "json",
                "bullets",
                "icons",
                "list"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 20,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 20,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 20,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 28,
                    "h": 48,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 36,
                    "y": 39,
                    "w": 28,
                    "h": 48,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 67,
                    "y": 39,
                    "w": 28,
                    "h": 48,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_bullets_single_126",
            "name": "single column bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "single wide column with bullet list",
            "tags": [
                "json",
                "bullets",
                "single",
                "list"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 23,
                    "w": 90,
                    "h": 64,
                    "type": "bullets",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_bullets_two_icons_127",
            "name": "two column bullets icons",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "two columns with icons and bullets",
            "tags": [
                "json",
                "bullets",
                "two",
                "icons"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 15,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 15,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 34,
                    "w": 42,
                    "h": 53,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 53,
                    "y": 34,
                    "w": 42,
                    "h": 53,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_numbered_list_128",
            "name": "numbered list three col",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three columns with numbered items",
            "tags": [
                "json",
                "numbered",
                "list",
                "columns"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 28,
                    "h": 66,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 36,
                    "y": 21,
                    "w": 28,
                    "h": 66,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 67,
                    "y": 21,
                    "w": 28,
                    "h": 66,
                    "type": "bullets",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_checklist_129",
            "name": "checklist style",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "checklist with checkmark icons",
            "tags": [
                "json",
                "checklist",
                "check",
                "todo"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 12,
                    "h": 69,
                    "type": "icon",
                    "iconType": "check_box",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 18,
                    "w": 75,
                    "h": 69,
                    "type": "bullets",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_feature_bullets_130",
            "name": "feature bullets grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "grid of features with icons and bullets",
            "tags": [
                "json",
                "features",
                "bullets",
                "grid"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 10,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 10,
                    "type": "icon",
                    "iconType": "security",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 29,
                    "w": 42,
                    "h": 28,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 53,
                    "y": 29,
                    "w": 42,
                    "h": 28,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 60,
                    "w": 42,
                    "h": 10,
                    "type": "icon",
                    "iconType": "speed",
                    "rounded": true
                },
                {
                    "x": 53,
                    "y": 60,
                    "w": 42,
                    "h": 10,
                    "type": "icon",
                    "iconType": "auto_graph",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 73,
                    "w": 42,
                    "h": 14,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 53,
                    "y": 73,
                    "w": 42,
                    "h": 14,
                    "type": "bullets",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_bullets_stacked_131",
            "name": "stacked bullet sections",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "vertically stacked bullet sections",
            "tags": [
                "json",
                "bullets",
                "stacked",
                "sections"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 20,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 49,
                    "w": 90,
                    "h": 20,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 72,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 77,
                    "w": 90,
                    "h": 10,
                    "type": "bullets",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_bullets_offset_132",
            "name": "offset bullet columns",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "offset alternating bullet columns",
            "tags": [
                "json",
                "bullets",
                "offset",
                "alternating"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 40,
                    "h": 35,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 55,
                    "y": 28,
                    "w": 40,
                    "h": 35,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 40,
                    "h": 33,
                    "type": "bullets",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_icon_bullets_133",
            "name": "icon with side bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large icon on left with bullets on right",
            "tags": [
                "json",
                "icon",
                "bullets",
                "side"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 35,
                    "h": 71,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 43,
                    "y": 16,
                    "w": 52,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 43,
                    "y": 21,
                    "w": 52,
                    "h": 66,
                    "type": "bullets",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_compact_bullets_134",
            "name": "compact bullet list",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "compact tight bullet list",
            "tags": [
                "json",
                "compact",
                "bullets",
                "dense"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 69,
                    "type": "bullets",
                    "lines": 10
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 69,
                    "type": "bullets",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_bullets_with_divider_135",
            "name": "bullets with dividers",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bullet sections separated by dividers",
            "tags": [
                "json",
                "bullets",
                "dividers",
                "sections"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 49,
                    "w": 90,
                    "h": 38,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_steps_bullets_136",
            "name": "step-by-step bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "numbered steps with bullet details",
            "tags": [
                "json",
                "steps",
                "bullets",
                "process"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 12,
                    "h": 12,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 20,
                    "y": 16,
                    "w": 75,
                    "h": 12,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 31,
                    "w": 12,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 20,
                    "y": 31,
                    "w": 75,
                    "h": 12,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 12,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 20,
                    "y": 46,
                    "w": 75,
                    "h": 12,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 61,
                    "w": 90,
                    "h": 26,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_bullets_centered_137",
            "name": "centered bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "centered bullet list with icon",
            "tags": [
                "json",
                "centered",
                "bullets",
                "minimal"
            ],
            "blocks": [
                {
                    "x": 20,
                    "y": 5,
                    "w": 60,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 35,
                    "y": 20,
                    "w": 30,
                    "h": 25,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 48,
                    "w": 60,
                    "h": 39,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_bullets_bottom_icon_138",
            "name": "bullets with bottom icon",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bullets above, icon at bottom",
            "tags": [
                "json",
                "bullets",
                "bottom",
                "icon"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 40,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 40,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 35,
                    "y": 61,
                    "w": 30,
                    "h": 26,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_bullets_horizontal_139",
            "name": "horizontal bullet flow",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "horizontal flow of bullet sections",
            "tags": [
                "json",
                "horizontal",
                "bullets",
                "flow"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 20,
                    "h": 8,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 16,
                    "w": 20,
                    "h": 8,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 51,
                    "y": 16,
                    "w": 20,
                    "h": 8,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 74,
                    "y": 16,
                    "w": 20,
                    "h": 8,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 27,
                    "w": 20,
                    "h": 60,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 28,
                    "y": 27,
                    "w": 20,
                    "h": 60,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 51,
                    "y": 27,
                    "w": 20,
                    "h": 60,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 74,
                    "y": 27,
                    "w": 20,
                    "h": 60,
                    "type": "bullets",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_bullets_cards_140",
            "name": "bullet cards",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "card-style sections with bullets",
            "tags": [
                "json",
                "bullets",
                "cards",
                "boxes"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 53,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_bullets_mixed_141",
            "name": "mixed content bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "mixed text and bullets layout",
            "tags": [
                "json",
                "mixed",
                "bullets",
                "text"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 25,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 42,
                    "h": 25,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 53,
                    "y": 46,
                    "w": 42,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 74,
                    "w": 90,
                    "h": 13,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_benefits_bullets_142",
            "name": "benefits list",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "benefits list with checkmarks",
            "tags": [
                "json",
                "benefits",
                "bullets",
                "features"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 12,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 12,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 12,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 33,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 33,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 33,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 38,
                    "w": 28,
                    "h": 49,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 36,
                    "y": 38,
                    "w": 28,
                    "h": 49,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 67,
                    "y": 38,
                    "w": 28,
                    "h": 49,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_timeline_bullets_143",
            "name": "timeline with bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "timeline style with bullet points",
            "tags": [
                "json",
                "timeline",
                "bullets",
                "chronological"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 8,
                    "h": 15,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 16,
                    "y": 16,
                    "w": 79,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 16,
                    "y": 21,
                    "w": 79,
                    "h": 10,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 34,
                    "w": 8,
                    "h": 15,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 16,
                    "y": 34,
                    "w": 79,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 16,
                    "y": 39,
                    "w": 79,
                    "h": 10,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 52,
                    "w": 8,
                    "h": 15,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 16,
                    "y": 52,
                    "w": 79,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 16,
                    "y": 57,
                    "w": 79,
                    "h": 30,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_bullets_wide_icon_144",
            "name": "wide bullets with icon",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "wide bullet list with centered icon",
            "tags": [
                "json",
                "bullets",
                "wide",
                "icon"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 40,
                    "y": 18,
                    "w": 20,
                    "h": 20,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 41,
                    "w": 90,
                    "h": 46,
                    "type": "bullets",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_bullets_dual_icon_145",
            "name": "dual icon bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "two columns with icons and bullets",
            "tags": [
                "json",
                "bullets",
                "dual",
                "icons"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 8,
                    "y": 16,
                    "w": 15,
                    "h": 18,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 55,
                    "y": 16,
                    "w": 15,
                    "h": 18,
                    "type": "icon",
                    "iconType": "thumb_up",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 37,
                    "w": 42,
                    "h": 50,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 53,
                    "y": 37,
                    "w": 42,
                    "h": 50,
                    "type": "bullets",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_bullets_compact_grid_146",
            "name": "compact bullet grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "compact grid of bullets with icons",
            "tags": [
                "json",
                "bullets",
                "grid",
                "compact"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 12,
                    "h": 12,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 12,
                    "h": 12,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 12,
                    "h": 12,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true
                },
                {
                    "x": 68,
                    "y": 16,
                    "w": 27,
                    "h": 35,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 53,
                    "y": 54,
                    "w": 12,
                    "h": 12,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true
                },
                {
                    "x": 68,
                    "y": 54,
                    "w": 27,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_bullets_sidebar_147",
            "name": "sidebar bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bullets in sidebar layout",
            "tags": [
                "json",
                "bullets",
                "sidebar",
                "vertical"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 25,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 25,
                    "h": 12,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 33,
                    "w": 25,
                    "h": 54,
                    "type": "bullets",
                    "lines": 8
                },
                {
                    "x": 35,
                    "y": 5,
                    "w": 60,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 35,
                    "y": 18,
                    "w": 60,
                    "h": 69,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_bullets_pyramid_148",
            "name": "pyramid bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "pyramid style bullet arrangement",
            "tags": [
                "json",
                "bullets",
                "pyramid",
                "hierarchy"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 42,
                    "y": 16,
                    "w": 16,
                    "h": 15,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 35,
                    "y": 34,
                    "w": 30,
                    "h": 15,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 20,
                    "y": 52,
                    "w": 60,
                    "h": 18,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 73,
                    "w": 90,
                    "h": 14,
                    "type": "bullets",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_bullets_spotlight_149",
            "name": "spotlight bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "spotlight icon with surrounding bullets",
            "tags": [
                "json",
                "bullets",
                "spotlight",
                "center"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 71,
                    "type": "bullets",
                    "lines": 9
                },
                {
                    "x": 36,
                    "y": 25,
                    "w": 28,
                    "h": 35,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 71,
                    "type": "bullets",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_bullets_alternating_150",
            "name": "alternating bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "alternating bullets and fields",
            "tags": [
                "json",
                "bullets",
                "alternating",
                "structured"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 8,
                    "h": 13,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 16,
                    "y": 16,
                    "w": 79,
                    "h": 13,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 16,
                    "y": 32,
                    "w": 79,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 37,
                    "w": 8,
                    "h": 13,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 16,
                    "y": 37,
                    "w": 79,
                    "h": 13,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 16,
                    "y": 53,
                    "w": 79,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 8,
                    "h": 13,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 16,
                    "y": 58,
                    "w": 79,
                    "h": 13,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 16,
                    "y": 74,
                    "w": 79,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 79,
                    "w": 8,
                    "h": 8,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 16,
                    "y": 79,
                    "w": 79,
                    "h": 8,
                    "type": "bullets",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_bullets_feature_boxes_151",
            "name": "feature boxes bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "feature boxes with bullet details",
            "tags": [
                "json",
                "bullets",
                "features",
                "boxes"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 36,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 67,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_bullets_stacked_icons_152",
            "name": "stacked icon bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "vertically stacked icons with bullets",
            "tags": [
                "json",
                "bullets",
                "stacked",
                "vertical"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 12,
                    "h": 18,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 16,
                    "w": 75,
                    "h": 18,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 37,
                    "w": 12,
                    "h": 18,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 37,
                    "w": 75,
                    "h": 18,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 12,
                    "h": 18,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 58,
                    "w": 75,
                    "h": 18,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 79,
                    "w": 12,
                    "h": 8,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 79,
                    "w": 75,
                    "h": 8,
                    "type": "bullets",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_bullets_corner_accent_153",
            "name": "corner accent bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bullets with corner icon accent",
            "tags": [
                "json",
                "bullets",
                "corner",
                "accent"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 65,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 73,
                    "y": 5,
                    "w": 22,
                    "h": 25,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 65,
                    "h": 69,
                    "type": "bullets",
                    "lines": 10
                },
                {
                    "x": 73,
                    "y": 33,
                    "w": 22,
                    "h": 54,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_bullets_dense_154",
            "name": "dense bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "dense multi-column bullets",
            "tags": [
                "json",
                "bullets",
                "dense",
                "multi-column"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 36,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 67,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_bullets_hero_155",
            "name": "hero bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "hero icon with bullet list below",
            "tags": [
                "json",
                "bullets",
                "hero",
                "large"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 30,
                    "y": 16,
                    "w": 40,
                    "h": 35,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 53,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_bullets_split_icon_156",
            "name": "split icon bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bullets split by central icon",
            "tags": [
                "json",
                "bullets",
                "split",
                "center"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 71,
                    "type": "bullets",
                    "lines": 9
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 36,
                    "y": 21,
                    "w": 28,
                    "h": 38,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 62,
                    "w": 28,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 71,
                    "type": "bullets",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_bullets_top_bottom_157",
            "name": "top bottom bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bullets at top and bottom",
            "tags": [
                "json",
                "bullets",
                "top",
                "bottom"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 25,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 25,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 35,
                    "y": 44,
                    "w": 30,
                    "h": 20,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 67,
                    "w": 42,
                    "h": 20,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 53,
                    "y": 67,
                    "w": 42,
                    "h": 20,
                    "type": "bullets",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_bullets_compact_features_158",
            "name": "compact features",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "compact feature bullets",
            "tags": [
                "json",
                "bullets",
                "compact",
                "features"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 8,
                    "h": 10,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 16,
                    "y": 16,
                    "w": 79,
                    "h": 10,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 29,
                    "w": 8,
                    "h": 10,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 16,
                    "y": 29,
                    "w": 79,
                    "h": 10,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 42,
                    "w": 8,
                    "h": 10,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 16,
                    "y": 42,
                    "w": 79,
                    "h": 10,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 55,
                    "w": 8,
                    "h": 10,
                    "type": "icon",
                    "iconType": "thumb_up",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 16,
                    "y": 55,
                    "w": 79,
                    "h": 10,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 8,
                    "h": 10,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 16,
                    "y": 68,
                    "w": 79,
                    "h": 10,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 81,
                    "w": 8,
                    "h": 6,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 16,
                    "y": 81,
                    "w": 79,
                    "h": 6,
                    "type": "bullets",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_bullets_diagonal_flow_159",
            "name": "diagonal bullet flow",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "diagonal flowing bullet sections",
            "tags": [
                "json",
                "bullets",
                "diagonal",
                "flow"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 12,
                    "h": 15,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 16,
                    "w": 28,
                    "h": 15,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 20,
                    "y": 34,
                    "w": 12,
                    "h": 15,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 35,
                    "y": 34,
                    "w": 28,
                    "h": 15,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 35,
                    "y": 52,
                    "w": 12,
                    "h": 15,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 50,
                    "y": 52,
                    "w": 28,
                    "h": 15,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 50,
                    "y": 70,
                    "w": 12,
                    "h": 17,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true
                },
                {
                    "x": 65,
                    "y": 70,
                    "w": 30,
                    "h": 17,
                    "type": "bullets",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_bullets_showcase_160",
            "name": "showcase bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "showcase layout with icon and bullets",
            "tags": [
                "json",
                "bullets",
                "showcase",
                "highlight"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 71,
                    "type": "bullets",
                    "lines": 10
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 53,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_bullets_grid_icons_161",
            "name": "grid with icon bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "grid layout with icons above bullets",
            "tags": [
                "json",
                "bullets",
                "grid",
                "icons"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 18,
                    "h": 15,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 16,
                    "w": 18,
                    "h": 15,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 51,
                    "y": 16,
                    "w": 18,
                    "h": 15,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 74,
                    "y": 16,
                    "w": 21,
                    "h": 15,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 34,
                    "w": 18,
                    "h": 53,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 28,
                    "y": 34,
                    "w": 18,
                    "h": 53,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 51,
                    "y": 34,
                    "w": 18,
                    "h": 53,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 74,
                    "y": 34,
                    "w": 21,
                    "h": 53,
                    "type": "bullets",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_bullets_asymmetric_162",
            "name": "asymmetric bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "asymmetric bullet layout",
            "tags": [
                "json",
                "bullets",
                "asymmetric",
                "creative"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 60,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 68,
                    "y": 5,
                    "w": 27,
                    "h": 25,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 60,
                    "h": 35,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 60,
                    "h": 31,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 68,
                    "y": 33,
                    "w": 27,
                    "h": 54,
                    "type": "bullets",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_bullets_minimal_163",
            "name": "minimal bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "minimal clean bullet layout",
            "tags": [
                "json",
                "bullets",
                "minimal",
                "clean"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 15,
                    "y": 20,
                    "w": 70,
                    "h": 15,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 15,
                    "y": 38,
                    "w": 70,
                    "h": 49,
                    "type": "bullets",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_newspaper_masthead_164",
            "name": "newspaper masthead",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper masthead with three column layout below",
            "tags": [
                "json",
                "newspaper",
                "columns",
                "masthead"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 25,
                    "w": 28,
                    "h": 62,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 36,
                    "y": 25,
                    "w": 28,
                    "h": 62,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 67,
                    "y": 25,
                    "w": 28,
                    "h": 62,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_flyer_hero_bottom_grid_165",
            "name": "flyer hero with bottom grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "hero section top with 4-column grid bottom",
            "tags": [
                "json",
                "flyer",
                "hero",
                "grid"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 20,
                    "h": 12,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 56,
                    "w": 20,
                    "h": 12,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true
                },
                {
                    "x": 51,
                    "y": 56,
                    "w": 20,
                    "h": 12,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true
                },
                {
                    "x": 74,
                    "y": 56,
                    "w": 21,
                    "h": 12,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 71,
                    "w": 20,
                    "h": 16,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 28,
                    "y": 71,
                    "w": 20,
                    "h": 16,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 51,
                    "y": 71,
                    "w": 20,
                    "h": 16,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 74,
                    "y": 71,
                    "w": 21,
                    "h": 16,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_signage_split_screen_166",
            "name": "signage split screen",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage 60/40 split screen",
            "tags": [
                "json",
                "signage",
                "split",
                "screen"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 55,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 55,
                    "h": 69,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 63,
                    "y": 5,
                    "w": 32,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 63,
                    "y": 16,
                    "w": 32,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 63,
                    "y": 54,
                    "w": 32,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_flyer_bottom_columns_167",
            "name": "flyer bottom columns",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "top content with three columns at bottom",
            "tags": [
                "json",
                "flyer",
                "columns",
                "bottom"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 28,
                    "h": 31,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 36,
                    "y": 56,
                    "w": 28,
                    "h": 31,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 67,
                    "y": 56,
                    "w": 28,
                    "h": 31,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_newspaper_top_story_168",
            "name": "newspaper top story",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper top story with sidebar columns",
            "tags": [
                "json",
                "newspaper",
                "top",
                "story"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 10,
                    "w": 60,
                    "h": 15,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 25,
                    "w": 60,
                    "h": 62,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 68,
                    "y": 10,
                    "w": 27,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 68,
                    "y": 21,
                    "w": 27,
                    "h": 30,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 68,
                    "y": 54,
                    "w": 27,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 68,
                    "y": 65,
                    "w": 27,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_signage_ticker_bar_169",
            "name": "signage with ticker bar",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage with bottom ticker bar",
            "tags": [
                "json",
                "signage",
                "ticker",
                "bar"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 50,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 50,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 5,
                    "y": 71,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 76,
                    "w": 90,
                    "h": 11,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_flyer_grid_top_text_bottom_170",
            "name": "flyer grid top text bottom",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "icon grid on top with text columns below",
            "tags": [
                "json",
                "flyer",
                "grid",
                "reverse"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 18,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 18,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 18,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 37,
                    "w": 28,
                    "h": 50,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 36,
                    "y": 37,
                    "w": 28,
                    "h": 50,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 67,
                    "y": 37,
                    "w": 28,
                    "h": 50,
                    "type": "text",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_newspaper_classified_171",
            "name": "newspaper classified",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper classified style with 4 narrow columns",
            "tags": [
                "json",
                "newspaper",
                "classified",
                "narrow"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 20,
                    "h": 71,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 28,
                    "y": 16,
                    "w": 20,
                    "h": 71,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 51,
                    "y": 16,
                    "w": 20,
                    "h": 71,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 74,
                    "y": 16,
                    "w": 21,
                    "h": 71,
                    "type": "text",
                    "lines": 13
                }
            ]
        },
        {
            "id": "json_signage_l_shape_172",
            "name": "signage l-shape layout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage L-shaped content division",
            "tags": [
                "json",
                "signage",
                "l-shape",
                "division"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 30,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 51,
                    "w": 28,
                    "h": 36,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 36,
                    "y": 51,
                    "w": 28,
                    "h": 36,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 67,
                    "y": 51,
                    "w": 28,
                    "h": 36,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_flyer_alternating_bands_173",
            "name": "flyer alternating bands",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flyer with alternating horizontal bands",
            "tags": [
                "json",
                "flyer",
                "bands",
                "horizontal"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 18,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 42,
                    "h": 18,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 53,
                    "y": 44,
                    "w": 42,
                    "h": 18,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 65,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 70,
                    "w": 90,
                    "h": 17,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_newspaper_editorial_174",
            "name": "newspaper editorial",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper editorial with pull quote",
            "tags": [
                "json",
                "newspaper",
                "editorial",
                "quote"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 60,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 68,
                    "y": 18,
                    "w": 27,
                    "h": 25,
                    "type": "icon",
                    "iconType": "format_quote",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 60,
                    "h": 41,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 68,
                    "y": 46,
                    "w": 27,
                    "h": 41,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "json_signage_thirds_175",
            "name": "signage rule of thirds",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage rule of thirds layout",
            "tags": [
                "json",
                "signage",
                "thirds",
                "balanced"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 28,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 25,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 28,
                    "h": 41,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 36,
                    "y": 5,
                    "w": 28,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 69,
                    "type": "bullets",
                    "lines": 10
                },
                {
                    "x": 67,
                    "y": 5,
                    "w": 28,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 69,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_flyer_centered_cta_176",
            "name": "flyer centered call to action",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flyer with centered call to action",
            "tags": [
                "json",
                "flyer",
                "cta",
                "centered"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 35,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 25,
                    "y": 56,
                    "w": 50,
                    "h": 31,
                    "type": "textbox",
                    "special": true
                }
            ]
        },
        {
            "id": "json_newspaper_feature_177",
            "name": "newspaper feature spread",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper feature with image placeholder and text wrap",
            "tags": [
                "json",
                "newspaper",
                "feature",
                "wrap"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 35,
                    "h": 69,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 43,
                    "y": 18,
                    "w": 52,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 43,
                    "y": 56,
                    "w": 52,
                    "h": 31,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_signage_header_footer_178",
            "name": "signage header footer",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage with header and footer bars",
            "tags": [
                "json",
                "signage",
                "header",
                "footer"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 28,
                    "h": 55,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 20,
                    "w": 28,
                    "h": 55,
                    "type": "bullets",
                    "lines": 7
                },
                {
                    "x": 67,
                    "y": 20,
                    "w": 28,
                    "h": 55,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 5,
                    "y": 78,
                    "w": 90,
                    "h": 9,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_flyer_zigzag_179",
            "name": "flyer zigzag layout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flyer with zigzag content arrangement",
            "tags": [
                "json",
                "flyer",
                "zigzag",
                "alternating"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 20,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 42,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 53,
                    "y": 39,
                    "w": 42,
                    "h": 20,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 62,
                    "w": 42,
                    "h": 25,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 53,
                    "y": 62,
                    "w": 42,
                    "h": 25,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_newspaper_sidebar_ads_180",
            "name": "newspaper with sidebar ads",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper layout with sidebar ad spaces",
            "tags": [
                "json",
                "newspaper",
                "sidebar",
                "ads"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 60,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 69,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 29,
                    "h": 69,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 68,
                    "y": 5,
                    "w": 27,
                    "h": 38,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 68,
                    "y": 46,
                    "w": 27,
                    "h": 41,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "json_signage_picture_frame_181",
            "name": "signage picture frame",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage with content framed by borders",
            "tags": [
                "json",
                "signage",
                "frame",
                "border"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 2,
                    "h": 62,
                    "type": "field"
                },
                {
                    "x": 10,
                    "y": 21,
                    "w": 38,
                    "h": 62,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 51,
                    "y": 21,
                    "w": 39,
                    "h": 62,
                    "type": "bullets",
                    "lines": 9
                },
                {
                    "x": 93,
                    "y": 21,
                    "w": 2,
                    "h": 62,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 86,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                }
            ]
        },
        {
            "id": "json_flyer_stacked_cards_182",
            "name": "flyer stacked cards",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flyer with vertically stacked card sections",
            "tags": [
                "json",
                "flyer",
                "stacked",
                "cards"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 23,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 23,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 42,
                    "w": 42,
                    "h": 23,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 53,
                    "y": 42,
                    "w": 42,
                    "h": 23,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 42,
                    "h": 19,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 53,
                    "y": 68,
                    "w": 42,
                    "h": 19,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_newspaper_double_decker_183",
            "name": "newspaper double decker",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper double decker headline layout",
            "tags": [
                "json",
                "newspaper",
                "double",
                "headline"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 30,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 49,
                    "w": 28,
                    "h": 38,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 36,
                    "y": 49,
                    "w": 28,
                    "h": 38,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 67,
                    "y": 49,
                    "w": 28,
                    "h": 38,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_signage_sidebar_main_184",
            "name": "signage sidebar main",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage with narrow sidebar and main content",
            "tags": [
                "json",
                "signage",
                "sidebar",
                "main"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 20,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 20,
                    "h": 25,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 20,
                    "h": 43,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 28,
                    "y": 5,
                    "w": 67,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 67,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 28,
                    "y": 56,
                    "w": 67,
                    "h": 31,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_flyer_quadrants_185",
            "name": "flyer quadrants",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flyer divided into four equal quadrants",
            "tags": [
                "json",
                "flyer",
                "quadrants",
                "grid"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 53,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_newspaper_columns_callout_186",
            "name": "newspaper columns with callout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper columns with centered callout box",
            "tags": [
                "json",
                "newspaper",
                "callout",
                "columns"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 30,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 30,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 30,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 20,
                    "y": 49,
                    "w": 60,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 70,
                    "w": 28,
                    "h": 17,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 36,
                    "y": 70,
                    "w": 28,
                    "h": 17,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 67,
                    "y": 70,
                    "w": 28,
                    "h": 17,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_signage_top_heavy_187",
            "name": "signage top heavy",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage with large top section",
            "tags": [
                "json",
                "signage",
                "top",
                "heavy"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 45,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 66,
                    "w": 28,
                    "h": 21,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 36,
                    "y": 66,
                    "w": 28,
                    "h": 21,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 67,
                    "y": 66,
                    "w": 28,
                    "h": 21,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_flyer_accordion_188",
            "name": "flyer accordion",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flyer with accordion style sections",
            "tags": [
                "json",
                "flyer",
                "accordion",
                "sections"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 21,
                    "w": 90,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 90,
                    "h": 15,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 62,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 67,
                    "w": 90,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_newspaper_multi_story_189",
            "name": "newspaper multi story",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper multiple story layout",
            "tags": [
                "json",
                "newspaper",
                "multi",
                "story"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 60,
                    "h": 12,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 60,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 68,
                    "y": 5,
                    "w": 27,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 68,
                    "y": 16,
                    "w": 27,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 68,
                    "y": 37,
                    "w": 27,
                    "h": 16,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 60,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 67,
                    "w": 60,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 68,
                    "y": 56,
                    "w": 27,
                    "h": 31,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_signage_overlay_190",
            "name": "signage overlay style",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage with overlay text boxes",
            "tags": [
                "json",
                "signage",
                "overlay",
                "layers"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 60,
                    "h": 67,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 50,
                    "y": 35,
                    "w": 45,
                    "h": 25,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 68,
                    "y": 63,
                    "w": 27,
                    "h": 24,
                    "type": "bullets",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_flyer_magazine_spread_191",
            "name": "flyer magazine spread",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flyer with magazine spread style layout",
            "tags": [
                "json",
                "flyer",
                "magazine",
                "spread"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 50,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 19,
                    "h": 69,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 76,
                    "y": 18,
                    "w": 19,
                    "h": 69,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 5,
                    "y": 71,
                    "w": 42,
                    "h": 16,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_newspaper_breaking_news_192",
            "name": "newspaper breaking news",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper breaking news banner layout",
            "tags": [
                "json",
                "newspaper",
                "breaking",
                "banner"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 18,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 23,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 28,
                    "w": 42,
                    "h": 59,
                    "type": "text",
                    "lines": 11
                },
                {
                    "x": 53,
                    "y": 28,
                    "w": 42,
                    "h": 59,
                    "type": "text",
                    "lines": 11
                }
            ]
        },
        {
            "id": "json_signage_mosaic_193",
            "name": "signage mosaic",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage mosaic tile layout",
            "tags": [
                "json",
                "signage",
                "mosaic",
                "tiles"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 19,
                    "h": 35,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 76,
                    "y": 16,
                    "w": 19,
                    "h": 35,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 19,
                    "h": 33,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 28,
                    "y": 54,
                    "w": 19,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 53,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_flyer_spotlight_corner_194",
            "name": "flyer spotlight corner",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flyer with spotlight in corner",
            "tags": [
                "json",
                "flyer",
                "spotlight",
                "corner"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 60,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 60,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 60,
                    "h": 31,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 68,
                    "y": 5,
                    "w": 27,
                    "h": 82,
                    "type": "textbox",
                    "special": true
                }
            ]
        },
        {
            "id": "json_newspaper_infographic_195",
            "name": "newspaper infographic style",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper infographic style layout",
            "tags": [
                "json",
                "newspaper",
                "infographic",
                "visual"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 18,
                    "h": 18,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 16,
                    "w": 18,
                    "h": 18,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 51,
                    "y": 16,
                    "w": 18,
                    "h": 18,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 74,
                    "y": 16,
                    "w": 21,
                    "h": 18,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 37,
                    "w": 18,
                    "h": 50,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 28,
                    "y": 37,
                    "w": 18,
                    "h": 50,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 51,
                    "y": 37,
                    "w": 18,
                    "h": 50,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 74,
                    "y": 37,
                    "w": 21,
                    "h": 50,
                    "type": "text",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_signage_billboard_196",
            "name": "signage billboard",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage billboard style",
            "tags": [
                "json",
                "signage",
                "billboard",
                "large"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 22,
                    "type": "header",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 26,
                    "w": 90,
                    "h": 40,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 90,
                    "h": 18,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_flyer_stepped_197",
            "name": "flyer stepped layout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flyer with stepped staircase layout",
            "tags": [
                "json",
                "flyer",
                "stepped",
                "staircase"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 28,
                    "h": 43,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 36,
                    "y": 25,
                    "w": 28,
                    "h": 30,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 58,
                    "w": 28,
                    "h": 29,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 67,
                    "y": 35,
                    "w": 28,
                    "h": 52,
                    "type": "text",
                    "lines": 9
                }
            ]
        },
        {
            "id": "json_newspaper_broadsheet_198",
            "name": "newspaper broadsheet",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "newspaper broadsheet style with 5 columns",
            "tags": [
                "json",
                "newspaper",
                "broadsheet",
                "five-column"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 16,
                    "h": 71,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 24,
                    "y": 16,
                    "w": 16,
                    "h": 71,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 43,
                    "y": 16,
                    "w": 16,
                    "h": 71,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 62,
                    "y": 16,
                    "w": 16,
                    "h": 71,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 81,
                    "y": 16,
                    "w": 14,
                    "h": 71,
                    "type": "text",
                    "lines": 13
                }
            ]
        },
        {
            "id": "json_signage_asymmetric_split_199",
            "name": "signage asymmetric split",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage asymmetric 70/30 split",
            "tags": [
                "json",
                "signage",
                "asymmetric",
                "split"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 65,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 65,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 30,
                    "h": 31,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 40,
                    "y": 56,
                    "w": 30,
                    "h": 31,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 73,
                    "y": 5,
                    "w": 22,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 73,
                    "y": 18,
                    "w": 22,
                    "h": 69,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_flyer_wrapper_200",
            "name": "flyer content wrapper",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "flyer with text wrapping around central element",
            "tags": [
                "json",
                "flyer",
                "wrapper",
                "wrap"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 69,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 25,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 36,
                    "y": 46,
                    "w": 28,
                    "h": 20,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 69,
                    "w": 28,
                    "h": 18,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 69,
                    "type": "text",
                    "lines": 13
                }
            ]
        },
        {
            "id": "json_signage_triple_split_201",
            "name": "signage triple split",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage three equal vertical sections",
            "tags": [
                "json",
                "signage",
                "triple",
                "vertical"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 28,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 40,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 59,
                    "w": 28,
                    "h": 28,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 36,
                    "y": 5,
                    "w": 28,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 71,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 67,
                    "y": 5,
                    "w": 28,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 40,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 67,
                    "y": 59,
                    "w": 28,
                    "h": 28,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_signage_vertical_bar_202",
            "name": "signage vertical divider bar",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage with vertical divider bar",
            "tags": [
                "json",
                "signage",
                "vertical",
                "divider"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 42,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 69,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 50,
                    "y": 5,
                    "w": 2,
                    "h": 82,
                    "type": "field"
                },
                {
                    "x": 55,
                    "y": 5,
                    "w": 40,
                    "h": 40,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 55,
                    "y": 48,
                    "w": 40,
                    "h": 39,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_signage_horizontal_thirds_203",
            "name": "signage horizontal thirds",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage three horizontal sections",
            "tags": [
                "json",
                "signage",
                "horizontal",
                "thirds"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 20,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 42,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 53,
                    "y": 44,
                    "w": 42,
                    "h": 20,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 67,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 72,
                    "w": 90,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_signage_corner_quad_204",
            "name": "signage corner quadrants",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage four corner quadrants with center",
            "tags": [
                "json",
                "signage",
                "quadrants",
                "corners"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 28,
                    "h": 38,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 5,
                    "w": 28,
                    "h": 38,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 36,
                    "y": 25,
                    "w": 28,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 28,
                    "h": 41,
                    "type": "bullets",
                    "lines": 6
                },
                {
                    "x": 67,
                    "y": 46,
                    "w": 28,
                    "h": 41,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_signage_wide_narrow_205",
            "name": "signage wide-narrow split",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage 80/20 wide-narrow split",
            "tags": [
                "json",
                "signage",
                "wide",
                "narrow"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 75,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 75,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 35,
                    "h": 31,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 45,
                    "y": 56,
                    "w": 35,
                    "h": 31,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 83,
                    "y": 5,
                    "w": 12,
                    "h": 82,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_signage_t_shape_206",
            "name": "signage t-shape layout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage T-shaped content division",
            "tags": [
                "json",
                "signage",
                "t-shape",
                "division"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 25,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 42,
                    "h": 41,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 53,
                    "y": 46,
                    "w": 42,
                    "h": 41,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_signage_nested_boxes_207",
            "name": "signage nested boxes",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage nested box layout",
            "tags": [
                "json",
                "signage",
                "nested",
                "boxes"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 10,
                    "y": 21,
                    "w": 38,
                    "h": 62,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 51,
                    "y": 21,
                    "w": 39,
                    "h": 30,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 51,
                    "y": 54,
                    "w": 39,
                    "h": 29,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 86,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                }
            ]
        },
        {
            "id": "json_signage_golden_ratio_208",
            "name": "signage golden ratio",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage golden ratio 62/38 split",
            "tags": [
                "json",
                "signage",
                "golden",
                "ratio"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 57,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 57,
                    "h": 69,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 65,
                    "y": 5,
                    "w": 30,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 65,
                    "y": 18,
                    "w": 30,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 65,
                    "y": 56,
                    "w": 30,
                    "h": 31,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_signage_stacked_horizontal_209",
            "name": "signage stacked horizontal",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage stacked horizontal bands",
            "tags": [
                "json",
                "signage",
                "stacked",
                "horizontal"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 18,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 37,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 42,
                    "w": 90,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 65,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 70,
                    "w": 90,
                    "h": 17,
                    "type": "bullets",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_signage_column_focus_210",
            "name": "signage column with focus",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage narrow column with wide focus area",
            "tags": [
                "json",
                "signage",
                "column",
                "focus"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 18,
                    "h": 82,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 26,
                    "y": 5,
                    "w": 69,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 26,
                    "y": 18,
                    "w": 69,
                    "h": 40,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 26,
                    "y": 61,
                    "w": 32,
                    "h": 26,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 63,
                    "y": 61,
                    "w": 32,
                    "h": 26,
                    "type": "bullets",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_signage_dual_focus_211",
            "name": "signage dual focus",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage two equal focus areas",
            "tags": [
                "json",
                "signage",
                "dual",
                "focus"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 53,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_signage_sidebar_stacked_212",
            "name": "signage sidebar stacked",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage sidebar with stacked sections",
            "tags": [
                "json",
                "signage",
                "sidebar",
                "stacked"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 65,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 65,
                    "h": 69,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 73,
                    "y": 5,
                    "w": 22,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 73,
                    "y": 16,
                    "w": 22,
                    "h": 23,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 73,
                    "y": 42,
                    "w": 22,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 73,
                    "y": 65,
                    "w": 22,
                    "h": 22,
                    "type": "bullets",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_signage_center_panel_213",
            "name": "signage center panel",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage center panel with side content",
            "tags": [
                "json",
                "signage",
                "center",
                "panel"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 18,
                    "h": 82,
                    "type": "text",
                    "lines": 15
                },
                {
                    "x": 26,
                    "y": 5,
                    "w": 48,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 26,
                    "y": 18,
                    "w": 48,
                    "h": 69,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 77,
                    "y": 5,
                    "w": 18,
                    "h": 82,
                    "type": "bullets",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_signage_asymmetric_grid_214",
            "name": "signage asymmetric grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage asymmetric grid layout",
            "tags": [
                "json",
                "signage",
                "asymmetric",
                "grid"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 60,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 68,
                    "y": 16,
                    "w": 27,
                    "h": 35,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 36,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                },
                {
                    "x": 68,
                    "y": 54,
                    "w": 27,
                    "h": 33,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_signage_pip_style_215",
            "name": "signage picture-in-picture",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage picture-in-picture style",
            "tags": [
                "json",
                "signage",
                "pip",
                "overlay"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 69,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 65,
                    "y": 62,
                    "w": 28,
                    "h": 23,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_signage_cross_division_216",
            "name": "signage cross division",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage cross-shaped division",
            "tags": [
                "json",
                "signage",
                "cross",
                "division"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 42,
                    "h": 38,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 5,
                    "w": 42,
                    "h": 38,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 51,
                    "w": 42,
                    "h": 36,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 53,
                    "y": 51,
                    "w": 42,
                    "h": 36,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_signage_floating_panels_217",
            "name": "signage floating panels",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage floating panel style",
            "tags": [
                "json",
                "signage",
                "floating",
                "panels"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 8,
                    "y": 18,
                    "w": 38,
                    "h": 30,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 49,
                    "y": 18,
                    "w": 38,
                    "h": 30,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 8,
                    "y": 51,
                    "w": 38,
                    "h": 33,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 49,
                    "y": 51,
                    "w": 38,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_signage_inverted_t_218",
            "name": "signage inverted t-shape",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage inverted T-shaped layout",
            "tags": [
                "json",
                "signage",
                "inverted",
                "t-shape"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 42,
                    "h": 50,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 5,
                    "w": 42,
                    "h": 50,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 69,
                    "w": 90,
                    "h": 18,
                    "type": "bullets",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_signage_window_panes_219",
            "name": "signage window panes",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage window panes style",
            "tags": [
                "json",
                "signage",
                "window",
                "panes"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 33,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 33,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 52,
                    "w": 42,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 53,
                    "y": 52,
                    "w": 42,
                    "h": 35,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_signage_magazine_layout_220",
            "name": "signage magazine layout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "digital signage magazine-style layout",
            "tags": [
                "json",
                "signage",
                "magazine",
                "editorial"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 55,
                    "h": 12,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 55,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 25,
                    "h": 31,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 35,
                    "y": 56,
                    "w": 25,
                    "h": 31,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 63,
                    "y": 5,
                    "w": 32,
                    "h": 40,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 63,
                    "y": 48,
                    "w": 32,
                    "h": 39,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_image_hero_sidebar_221",
            "name": "image hero with sidebar",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with narrow sidebar content",
            "tags": [
                "json",
                "image",
                "hero",
                "sidebar"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 70,
                    "h": 82,
                    "type": "image"
                },
                {
                    "x": 78,
                    "y": 5,
                    "w": 17,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 78,
                    "y": 18,
                    "w": 17,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 78,
                    "y": 56,
                    "w": 17,
                    "h": 31,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_image_full_bottom_bar_222",
            "name": "image with bottom bar",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with bottom info bar",
            "tags": [
                "json",
                "image",
                "full",
                "bottom"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 65,
                    "type": "image"
                },
                {
                    "x": 5,
                    "y": 73,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 78,
                    "w": 42,
                    "h": 9,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 53,
                    "y": 78,
                    "w": 42,
                    "h": 9,
                    "type": "bullets",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_image_left_text_right_223",
            "name": "image left text right",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image left with text content right",
            "tags": [
                "json",
                "image",
                "left",
                "text"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 60,
                    "h": 82,
                    "type": "image"
                },
                {
                    "x": 68,
                    "y": 5,
                    "w": 27,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 68,
                    "y": 18,
                    "w": 27,
                    "h": 40,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 68,
                    "y": 61,
                    "w": 27,
                    "h": 26,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_image_top_text_bottom_224",
            "name": "image top text bottom",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image on top with text below",
            "tags": [
                "json",
                "image",
                "top",
                "text"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 60,
                    "type": "image"
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 79,
                    "w": 42,
                    "h": 8,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 53,
                    "y": 79,
                    "w": 42,
                    "h": 8,
                    "type": "bullets",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_image_corner_overlay_225",
            "name": "image with corner overlay",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with corner text overlay",
            "tags": [
                "json",
                "image",
                "corner",
                "overlay"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 82,
                    "type": "image"
                },
                {
                    "x": 65,
                    "y": 62,
                    "w": 28,
                    "h": 23,
                    "type": "textbox",
                    "special": true
                }
            ]
        },
        {
            "id": "json_image_split_vertical_226",
            "name": "image vertical split",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with vertical split content",
            "tags": [
                "json",
                "image",
                "vertical",
                "split"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 65,
                    "h": 82,
                    "type": "image"
                },
                {
                    "x": 73,
                    "y": 5,
                    "w": 22,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 73,
                    "y": 16,
                    "w": 22,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 73,
                    "y": 54,
                    "w": 22,
                    "h": 33,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_image_header_footer_227",
            "name": "image with header footer",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with header and footer",
            "tags": [
                "json",
                "image",
                "header",
                "footer"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 60,
                    "type": "image"
                },
                {
                    "x": 5,
                    "y": 81,
                    "w": 90,
                    "h": 6,
                    "type": "text",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_image_l_shape_text_228",
            "name": "image l-shape with text",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with l-shaped text area",
            "tags": [
                "json",
                "image",
                "l-shape",
                "text"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 55,
                    "type": "image"
                },
                {
                    "x": 5,
                    "y": 63,
                    "w": 28,
                    "h": 24,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 36,
                    "y": 63,
                    "w": 28,
                    "h": 24,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 67,
                    "y": 63,
                    "w": 28,
                    "h": 24,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_image_dual_column_229",
            "name": "image with dual columns",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with two column text below",
            "tags": [
                "json",
                "image",
                "dual",
                "columns"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 55,
                    "type": "image"
                },
                {
                    "x": 5,
                    "y": 63,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 42,
                    "h": 19,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 53,
                    "y": 68,
                    "w": 42,
                    "h": 19,
                    "type": "bullets",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_image_right_narrow_230",
            "name": "image right narrow sidebar",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with narrow right sidebar",
            "tags": [
                "json",
                "image",
                "right",
                "narrow"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 75,
                    "h": 82,
                    "type": "image"
                },
                {
                    "x": 83,
                    "y": 5,
                    "w": 12,
                    "h": 82,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_image_top_icon_bar_231",
            "name": "image with top icon bar",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with icon bar on top",
            "tags": [
                "json",
                "image",
                "top",
                "icons"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 69,
                    "type": "image"
                }
            ]
        },
        {
            "id": "json_image_corner_info_232",
            "name": "image corner info boxes",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with corner info boxes",
            "tags": [
                "json",
                "image",
                "corner",
                "info"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 82,
                    "type": "image"
                },
                {
                    "x": 8,
                    "y": 8,
                    "w": 25,
                    "h": 12,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 70,
                    "w": 25,
                    "h": 14,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_image_bottom_bullets_233",
            "name": "image bottom bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with bottom bullet section",
            "tags": [
                "json",
                "image",
                "bottom",
                "bullets"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 65,
                    "type": "image"
                },
                {
                    "x": 5,
                    "y": 73,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 84,
                    "w": 90,
                    "h": 3,
                    "type": "bullets",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_image_sidebar_stacked_234",
            "name": "image sidebar stacked",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with stacked sidebar sections",
            "tags": [
                "json",
                "image",
                "sidebar",
                "stacked"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 68,
                    "h": 82,
                    "type": "image"
                },
                {
                    "x": 76,
                    "y": 5,
                    "w": 19,
                    "h": 25,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 76,
                    "y": 33,
                    "w": 19,
                    "h": 25,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 76,
                    "y": 61,
                    "w": 19,
                    "h": 26,
                    "type": "bullets",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_image_floating_title_235",
            "name": "image floating title",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with floating title overlay",
            "tags": [
                "json",
                "image",
                "floating",
                "title"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 82,
                    "type": "image"
                },
                {
                    "x": 20,
                    "y": 35,
                    "w": 60,
                    "h": 22,
                    "type": "header",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_image_triple_bottom_236",
            "name": "image triple bottom",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with three columns below",
            "tags": [
                "json",
                "image",
                "triple",
                "bottom"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 60,
                    "type": "image"
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 28,
                    "h": 19,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 36,
                    "y": 68,
                    "w": 28,
                    "h": 19,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 67,
                    "y": 68,
                    "w": 28,
                    "h": 19,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_image_asymmetric_text_237",
            "name": "image asymmetric text",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with asymmetric text layout",
            "tags": [
                "json",
                "image",
                "asymmetric",
                "text"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 75,
                    "h": 70,
                    "type": "image"
                },
                {
                    "x": 5,
                    "y": 78,
                    "w": 75,
                    "h": 9,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 83,
                    "y": 5,
                    "w": 12,
                    "h": 35,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 83,
                    "y": 43,
                    "w": 12,
                    "h": 44,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_image_banner_style_238",
            "name": "image banner style",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image banner with minimal text",
            "tags": [
                "json",
                "image",
                "banner",
                "minimal"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 75,
                    "type": "image"
                },
                {
                    "x": 5,
                    "y": 83,
                    "w": 90,
                    "h": 4,
                    "type": "text",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_image_split_info_239",
            "name": "image split info panels",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with split info panels",
            "tags": [
                "json",
                "image",
                "split",
                "panels"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 60,
                    "h": 82,
                    "type": "image"
                },
                {
                    "x": 68,
                    "y": 5,
                    "w": 27,
                    "h": 38,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 68,
                    "y": 46,
                    "w": 27,
                    "h": 41,
                    "type": "bullets",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_image_wide_caption_240",
            "name": "image wide caption",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large image with wide caption area",
            "tags": [
                "json",
                "image",
                "wide",
                "caption"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 70,
                    "type": "image"
                },
                {
                    "x": 5,
                    "y": 78,
                    "w": 90,
                    "h": 2,
                    "type": "field"
                },
                {
                    "x": 5,
                    "y": 83,
                    "w": 60,
                    "h": 4,
                    "type": "text",
                    "lines": 1
                },
                {
                    "x": 68,
                    "y": 83,
                    "w": 27,
                    "h": 4,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_circle_center_radial_241",
            "name": "circle center radial",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "center circle with radial text around",
            "tags": [
                "json",
                "circle",
                "radial",
                "center"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 35,
                    "y": 25,
                    "w": 30,
                    "h": 40,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 25,
                    "h": 71,
                    "type": "text",
                    "lines": 13
                },
                {
                    "x": 70,
                    "y": 16,
                    "w": 25,
                    "h": 71,
                    "type": "bullets",
                    "lines": 10
                }
            ]
        },
        {
            "id": "json_circle_three_radial_242",
            "name": "three circle radial",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three circles in radial arrangement",
            "tags": [
                "json",
                "circle",
                "three",
                "radial"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 12,
                    "y": 20,
                    "w": 20,
                    "h": 25,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 12,
                    "y": 48,
                    "w": 20,
                    "h": 39,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 40,
                    "y": 20,
                    "w": 20,
                    "h": 25,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 40,
                    "y": 48,
                    "w": 20,
                    "h": 39,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 68,
                    "y": 20,
                    "w": 20,
                    "h": 25,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 68,
                    "y": 48,
                    "w": 20,
                    "h": 39,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_circle_corner_four_243",
            "name": "four corner circles",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "four circles in corner positions",
            "tags": [
                "json",
                "circle",
                "corners",
                "four"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 8,
                    "y": 18,
                    "w": 18,
                    "h": 25,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 74,
                    "y": 18,
                    "w": 18,
                    "h": 25,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 8,
                    "y": 62,
                    "w": 18,
                    "h": 25,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 74,
                    "y": 62,
                    "w": 18,
                    "h": 25,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 30,
                    "y": 30,
                    "w": 40,
                    "h": 40,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_circle_grid_six_244",
            "name": "six circle grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "six circles in 2x3 grid layout",
            "tags": [
                "json",
                "circle",
                "grid",
                "six"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 8,
                    "y": 18,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 27,
                    "y": 18,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 46,
                    "y": 18,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 8,
                    "y": 41,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 27,
                    "y": 41,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 46,
                    "y": 41,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 65,
                    "y": 18,
                    "w": 30,
                    "h": 69,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_circle_ring_center_245",
            "name": "circle ring with center",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "circle ring arrangement with center icon",
            "tags": [
                "json",
                "circle",
                "ring",
                "center"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 12,
                    "y": 16,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 40,
                    "y": 16,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 68,
                    "y": 16,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 35,
                    "y": 40,
                    "w": 25,
                    "h": 30,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 12,
                    "y": 67,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 68,
                    "y": 67,
                    "w": 15,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_circle_vertical_stack_246",
            "name": "vertical circle stack",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "vertical stack of circles with text",
            "tags": [
                "json",
                "circle",
                "vertical",
                "stack"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 8,
                    "y": 18,
                    "w": 20,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 32,
                    "y": 18,
                    "w": 63,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 8,
                    "y": 41,
                    "w": 20,
                    "h": 20,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 32,
                    "y": 41,
                    "w": 63,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 8,
                    "y": 64,
                    "w": 20,
                    "h": 23,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 32,
                    "y": 64,
                    "w": 63,
                    "h": 23,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_circle_hero_bullets_247",
            "name": "hero circle with bullets",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large hero circle with bullet points",
            "tags": [
                "json",
                "circle",
                "hero",
                "bullets"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 20,
                    "y": 18,
                    "w": 40,
                    "h": 50,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 63,
                    "y": 18,
                    "w": 32,
                    "h": 69,
                    "type": "bullets",
                    "lines": 10
                },
                {
                    "x": 5,
                    "y": 71,
                    "w": 55,
                    "h": 16,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_circle_dual_focus_248",
            "name": "dual circle focus",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "two large circles side by side",
            "tags": [
                "json",
                "circle",
                "dual",
                "focus"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 18,
                    "w": 35,
                    "h": 45,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 55,
                    "y": 18,
                    "w": 35,
                    "h": 45,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 66,
                    "w": 35,
                    "h": 21,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 55,
                    "y": 66,
                    "w": 35,
                    "h": 21,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_circle_cascade_249",
            "name": "circle cascade",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "cascading circles diagonal arrangement",
            "tags": [
                "json",
                "circle",
                "cascade",
                "diagonal"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 8,
                    "y": 18,
                    "w": 18,
                    "h": 23,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 30,
                    "h": 23,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 20,
                    "y": 44,
                    "w": 18,
                    "h": 23,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 40,
                    "y": 44,
                    "w": 30,
                    "h": 23,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 32,
                    "y": 70,
                    "w": 18,
                    "h": 17,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 70,
                    "w": 30,
                    "h": 17,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_circle_center_quad_250",
            "name": "center circle quadrants",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "center circle with four quadrant circles",
            "tags": [
                "json",
                "circle",
                "center",
                "quadrants"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 35,
                    "y": 35,
                    "w": 30,
                    "h": 35,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 8,
                    "y": 18,
                    "w": 18,
                    "h": 23,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 74,
                    "y": 18,
                    "w": 18,
                    "h": 23,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 8,
                    "y": 64,
                    "w": 18,
                    "h": 23,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 74,
                    "y": 64,
                    "w": 18,
                    "h": 23,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_big_circle_overlap_dual_251",
            "name": "big overlapping dual circles",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "two large overlapping circles with text",
            "tags": [
                "json",
                "circle",
                "overlap",
                "big"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 50,
                    "h": 65,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 45,
                    "y": 16,
                    "w": 50,
                    "h": 65,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_big_circle_triple_overlap_252",
            "name": "big triple overlapping circles",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three large overlapping circles horizontal",
            "tags": [
                "json",
                "circle",
                "overlap",
                "triple"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 40,
                    "h": 55,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 30,
                    "y": 18,
                    "w": 40,
                    "h": 55,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 55,
                    "y": 18,
                    "w": 40,
                    "h": 55,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 76,
                    "w": 90,
                    "h": 11,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_big_circle_venn_253",
            "name": "big venn diagram circles",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large venn diagram style overlapping circles",
            "tags": [
                "json",
                "circle",
                "venn",
                "overlap"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 16,
                    "w": 45,
                    "h": 60,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 45,
                    "y": 16,
                    "w": 45,
                    "h": 60,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 27,
                    "y": 50,
                    "w": 45,
                    "h": 37,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_big_circle_hero_text_254",
            "name": "big hero circle with text",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "huge circle with text overlay and sidebar",
            "tags": [
                "json",
                "circle",
                "hero",
                "big"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 65,
                    "h": 82,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 73,
                    "y": 5,
                    "w": 22,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 73,
                    "y": 18,
                    "w": 22,
                    "h": 35,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 73,
                    "y": 56,
                    "w": 22,
                    "h": 31,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_big_circle_offset_overlap_255",
            "name": "big offset overlapping circles",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large circles offset diagonal overlap",
            "tags": [
                "json",
                "circle",
                "offset",
                "overlap"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 8,
                    "y": 16,
                    "w": 45,
                    "h": 55,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 47,
                    "y": 32,
                    "w": 45,
                    "h": 55,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 8,
                    "y": 74,
                    "w": 35,
                    "h": 13,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_big_circle_cluster_256",
            "name": "big circle cluster",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "cluster of large overlapping circles",
            "tags": [
                "json",
                "circle",
                "cluster",
                "overlap"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 8,
                    "y": 18,
                    "w": 38,
                    "h": 48,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 35,
                    "y": 18,
                    "w": 38,
                    "h": 48,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 57,
                    "y": 18,
                    "w": 38,
                    "h": 48,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 48,
                    "w": 38,
                    "h": 39,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 47,
                    "y": 48,
                    "w": 38,
                    "h": 39,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                }
            ]
        },
        {
            "id": "json_big_circle_side_overlap_257",
            "name": "big side overlapping circles",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large circles overlapping from sides",
            "tags": [
                "json",
                "circle",
                "side",
                "overlap"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 50,
                    "h": 69,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 45,
                    "y": 18,
                    "w": 50,
                    "h": 69,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 35,
                    "y": 35,
                    "w": 30,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                }
            ]
        },
        {
            "id": "json_big_circle_vertical_overlap_258",
            "name": "big vertical overlapping circles",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large circles stacked vertically overlapping",
            "tags": [
                "json",
                "circle",
                "vertical",
                "overlap"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 25,
                    "y": 16,
                    "w": 50,
                    "h": 40,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 42,
                    "w": 50,
                    "h": 45,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 78,
                    "y": 18,
                    "w": 17,
                    "h": 69,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_big_circle_asymmetric_overlap_259",
            "name": "big asymmetric overlapping circles",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large asymmetric overlapping circle layout",
            "tags": [
                "json",
                "circle",
                "asymmetric",
                "overlap"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 55,
                    "h": 71,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 40,
                    "y": 25,
                    "w": 35,
                    "h": 45,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true
                },
                {
                    "x": 65,
                    "y": 50,
                    "w": 30,
                    "h": 37,
                    "type": "icon",
                    "iconType": "circle",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "json_big_circle_sandwich_260",
            "name": "big circle sandwich",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large circle sandwiched between text layers",
            "tags": [
                "json",
                "circle",
                "sandwich",
                "big"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 15,
                    "type": "bullets",
                    "lines": 2
                },
                {
                    "x": 20,
                    "y": 25,
                    "w": 60,
                    "h": 50,
                    "type": "icon",
                    "iconType": "radio_button_checked",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 78,
                    "w": 42,
                    "h": 9,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 53,
                    "y": 78,
                    "w": 42,
                    "h": 9,
                    "type": "bullets",
                    "lines": 1
                }
            ]
        },
        {
            "id": "json_triangle_triple_points_261",
            "name": "triple triangle points",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three large triangles pointing in different directions",
            "tags": [
                "json",
                "triangle",
                "geometric",
                "points"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 40,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 40,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 68,
                    "y": 16,
                    "w": 27,
                    "h": 40,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 59,
                    "w": 90,
                    "h": 28,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "json_triangle_pyramid_262",
            "name": "triangle pyramid stack",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "triangles stacked in pyramid formation",
            "tags": [
                "json",
                "triangle",
                "pyramid",
                "stack"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 40,
                    "y": 16,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 30,
                    "y": 37,
                    "w": 18,
                    "h": 16,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 52,
                    "y": 37,
                    "w": 18,
                    "h": 16,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 22,
                    "y": 56,
                    "w": 15,
                    "h": 14,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 40,
                    "y": 56,
                    "w": 15,
                    "h": 14,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 58,
                    "y": 56,
                    "w": 15,
                    "h": 14,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 73,
                    "w": 90,
                    "h": 14,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_triangle_hero_side_263",
            "name": "triangle hero with sidebar",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large triangle icon with text sidebar",
            "tags": [
                "json",
                "triangle",
                "hero",
                "sidebar"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 62,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 62,
                    "h": 71,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 70,
                    "y": 5,
                    "w": 25,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 70,
                    "y": 18,
                    "w": 25,
                    "h": 25,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 70,
                    "y": 46,
                    "w": 25,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 70,
                    "y": 69,
                    "w": 25,
                    "h": 18,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "json_triangle_corner_cluster_264",
            "name": "triangle corner cluster",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "triangles clustered in corners with center text",
            "tags": [
                "json",
                "triangle",
                "corner",
                "cluster"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 22,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 73,
                    "y": 5,
                    "w": 22,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 30,
                    "y": 15,
                    "w": 40,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 30,
                    "y": 30,
                    "w": 40,
                    "h": 40,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 5,
                    "y": 67,
                    "w": 22,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 73,
                    "y": 67,
                    "w": 22,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history"
                }
            ]
        },
        {
            "id": "json_triangle_alternating_text_265",
            "name": "triangle alternating with text",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "alternating triangles and text blocks",
            "tags": [
                "json",
                "triangle",
                "alternating",
                "zigzag"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 20,
                    "h": 23,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 28,
                    "y": 16,
                    "w": 34,
                    "h": 23,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 65,
                    "y": 16,
                    "w": 30,
                    "h": 23,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 5,
                    "y": 42,
                    "w": 30,
                    "h": 23,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 38,
                    "y": 42,
                    "w": 20,
                    "h": 23,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 61,
                    "y": 42,
                    "w": 34,
                    "h": 23,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 15,
                    "y": 68,
                    "w": 65,
                    "h": 19,
                    "type": "bullets",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_triangle_dual_split_266",
            "name": "triangle dual split screen",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "two large triangles splitting the screen",
            "tags": [
                "json",
                "triangle",
                "split",
                "dual"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 71,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 71,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 10,
                    "y": 50,
                    "w": 32,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 58,
                    "y": 50,
                    "w": 32,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_triangle_center_radial_267",
            "name": "triangle center radial",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "triangles arranged in radial pattern around center",
            "tags": [
                "json",
                "triangle",
                "radial",
                "center"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 38,
                    "y": 16,
                    "w": 24,
                    "h": 22,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 10,
                    "y": 30,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 70,
                    "y": 30,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 38,
                    "y": 50,
                    "w": 24,
                    "h": 22,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 10,
                    "y": 60,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 70,
                    "y": 60,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 30,
                    "y": 35,
                    "w": 40,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_triangle_big_hero_268",
            "name": "big triangle hero",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "single massive triangle with overlay text",
            "tags": [
                "json",
                "triangle",
                "hero",
                "big"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 82,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 10,
                    "y": 10,
                    "w": 80,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 25,
                    "y": 35,
                    "w": 50,
                    "h": 25,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 30,
                    "y": 65,
                    "w": 40,
                    "h": 18,
                    "type": "bullets",
                    "lines": 3
                }
            ]
        },
        {
            "id": "json_triangle_grid_pattern_269",
            "name": "triangle grid pattern",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "triangles arranged in uniform grid",
            "tags": [
                "json",
                "triangle",
                "grid",
                "pattern"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 17,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 25,
                    "y": 16,
                    "w": 17,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 45,
                    "y": 16,
                    "w": 17,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 65,
                    "y": 16,
                    "w": 17,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 85,
                    "y": 16,
                    "w": 10,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 17,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 25,
                    "y": 39,
                    "w": 17,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 45,
                    "y": 39,
                    "w": 17,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 65,
                    "y": 39,
                    "w": 17,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 85,
                    "y": 39,
                    "w": 10,
                    "h": 20,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 62,
                    "w": 90,
                    "h": 25,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "json_triangle_vertical_cascade_270",
            "name": "triangle vertical cascade",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "triangles cascading vertically with text",
            "tags": [
                "json",
                "triangle",
                "cascade",
                "vertical"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 30,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 30,
                    "h": 22,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 45,
                    "w": 30,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 30,
                    "h": 19,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 40,
                    "y": 5,
                    "w": 55,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 40,
                    "y": 18,
                    "w": 55,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 40,
                    "y": 46,
                    "w": 55,
                    "h": 20,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 40,
                    "y": 69,
                    "w": 55,
                    "h": 18,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "json_triangle_diagonal_flow_271",
            "name": "triangle diagonal flow",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "triangles flowing diagonally across screen",
            "tags": [
                "json",
                "triangle",
                "diagonal",
                "flow"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 28,
                    "y": 25,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 51,
                    "y": 34,
                    "w": 20,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 74,
                    "y": 43,
                    "w": 21,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 5,
                    "y": 40,
                    "w": 40,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 50,
                    "y": 60,
                    "w": 45,
                    "h": 27,
                    "type": "bullets",
                    "lines": 5
                }
            ]
        },
        {
            "id": "json_triangle_border_frame_272",
            "name": "triangle border frame",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "triangles forming border frame around content",
            "tags": [
                "json",
                "triangle",
                "border",
                "frame"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 15,
                    "h": 14,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 40,
                    "y": 5,
                    "w": 20,
                    "h": 17,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 80,
                    "y": 5,
                    "w": 15,
                    "h": 14,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 40,
                    "w": 15,
                    "h": 14,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 80,
                    "y": 40,
                    "w": 15,
                    "h": 14,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 5,
                    "y": 73,
                    "w": 15,
                    "h": 14,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 80,
                    "y": 73,
                    "w": 15,
                    "h": 14,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 25,
                    "y": 25,
                    "w": 50,
                    "h": 50,
                    "type": "text",
                    "lines": 12
                }
            ]
        },
        {
            "id": "json_triangle_stacked_layers_273",
            "name": "triangle stacked layers",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "triangles stacked in horizontal layers",
            "tags": [
                "json",
                "triangle",
                "layers",
                "stack"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 10,
                    "y": 16,
                    "w": 25,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 38,
                    "y": 16,
                    "w": 25,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 66,
                    "y": 16,
                    "w": 25,
                    "h": 18,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 37,
                    "w": 90,
                    "h": 18,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 10,
                    "y": 58,
                    "w": 25,
                    "h": 16,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 38,
                    "y": 58,
                    "w": 25,
                    "h": 16,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 66,
                    "y": 58,
                    "w": 25,
                    "h": 16,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 5,
                    "y": 77,
                    "w": 90,
                    "h": 10,
                    "type": "bullets",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_triangle_overlapping_trio_274",
            "name": "triangle overlapping trio",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three large overlapping triangles",
            "tags": [
                "json",
                "triangle",
                "overlap",
                "trio"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 45,
                    "h": 50,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 30,
                    "y": 25,
                    "w": 45,
                    "h": 50,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 55,
                    "y": 16,
                    "w": 40,
                    "h": 50,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 10,
                    "y": 70,
                    "w": 80,
                    "h": 17,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_triangle_matrix_layout_275",
            "name": "triangle matrix layout",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "triangles and text in matrix formation",
            "tags": [
                "json",
                "triangle",
                "matrix",
                "grid"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 20,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                },
                {
                    "x": 28,
                    "y": 16,
                    "w": 34,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 65,
                    "y": 16,
                    "w": 30,
                    "h": 20,
                    "type": "bullets",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 39,
                    "w": 34,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 42,
                    "y": 39,
                    "w": 20,
                    "h": 20,
                    "type": "icon",
                    "iconType": "change_history"
                },
                {
                    "x": 65,
                    "y": 39,
                    "w": 30,
                    "h": 20,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 62,
                    "w": 30,
                    "h": 25,
                    "type": "bullets",
                    "lines": 4
                },
                {
                    "x": 38,
                    "y": 62,
                    "w": 30,
                    "h": 25,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 71,
                    "y": 62,
                    "w": 24,
                    "h": 25,
                    "type": "icon",
                    "iconType": "change_history",
                    "special": true
                }
            ]
        },
        {
            "id": "json_simple_grid_2x2_276",
            "name": "simple 2x2 grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple 2x2 grid layout",
            "tags": [
                "json",
                "grid",
                "simple",
                "2x2"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 53,
                    "y": 54,
                    "w": 42,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_simple_grid_3x3_277",
            "name": "simple 3x3 grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple 3x3 grid layout",
            "tags": [
                "json",
                "grid",
                "simple",
                "3x3"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 68,
                    "y": 16,
                    "w": 27,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 42,
                    "w": 28,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 36,
                    "y": 42,
                    "w": 28,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 68,
                    "y": 42,
                    "w": 27,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 67,
                    "w": 28,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 36,
                    "y": 67,
                    "w": 28,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 68,
                    "y": 67,
                    "w": 27,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_simple_grid_4x2_278",
            "name": "simple 4x2 grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple 4 columns by 2 rows grid",
            "tags": [
                "json",
                "grid",
                "simple",
                "4x2"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 20,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 28,
                    "y": 16,
                    "w": 20,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 51,
                    "y": 16,
                    "w": 20,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 75,
                    "y": 16,
                    "w": 20,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 20,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 28,
                    "y": 54,
                    "w": 20,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 51,
                    "y": 54,
                    "w": 20,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 75,
                    "y": 54,
                    "w": 20,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_simple_grid_2x3_279",
            "name": "simple 2x3 grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple 2 columns by 3 rows grid",
            "tags": [
                "json",
                "grid",
                "simple",
                "2x3"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 42,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 53,
                    "y": 16,
                    "w": 42,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 42,
                    "w": 42,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 53,
                    "y": 42,
                    "w": 42,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 67,
                    "w": 42,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 53,
                    "y": 67,
                    "w": 42,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_simple_grid_5col_280",
            "name": "simple 5 column grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple 5 column single row grid",
            "tags": [
                "json",
                "grid",
                "simple",
                "5col"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 16,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                },
                {
                    "x": 24,
                    "y": 16,
                    "w": 16,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                },
                {
                    "x": 43,
                    "y": 16,
                    "w": 16,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                },
                {
                    "x": 62,
                    "y": 16,
                    "w": 16,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                },
                {
                    "x": 81,
                    "y": 16,
                    "w": 14,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                }
            ]
        },
        {
            "id": "json_simple_grid_3x2_281",
            "name": "simple 3x2 grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple 3 columns by 2 rows grid",
            "tags": [
                "json",
                "grid",
                "simple",
                "3x2"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 68,
                    "y": 16,
                    "w": 27,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 36,
                    "y": 54,
                    "w": 28,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 68,
                    "y": 54,
                    "w": 27,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "json_simple_grid_4x3_282",
            "name": "simple 4x3 grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple 4 columns by 3 rows grid",
            "tags": [
                "json",
                "grid",
                "simple",
                "4x3"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 20,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 28,
                    "y": 16,
                    "w": 20,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 51,
                    "y": 16,
                    "w": 20,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 75,
                    "y": 16,
                    "w": 20,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 42,
                    "w": 20,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 28,
                    "y": 42,
                    "w": 20,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 51,
                    "y": 42,
                    "w": 20,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 75,
                    "y": 42,
                    "w": 20,
                    "h": 22,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 67,
                    "w": 20,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 28,
                    "y": 67,
                    "w": 20,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 51,
                    "y": 67,
                    "w": 20,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 75,
                    "y": 67,
                    "w": 20,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "json_simple_grid_6col_283",
            "name": "simple 6 column grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple 6 column single row grid",
            "tags": [
                "json",
                "grid",
                "simple",
                "6col"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 13,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                },
                {
                    "x": 20,
                    "y": 16,
                    "w": 13,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                },
                {
                    "x": 35,
                    "y": 16,
                    "w": 13,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                },
                {
                    "x": 50,
                    "y": 16,
                    "w": 13,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                },
                {
                    "x": 65,
                    "y": 16,
                    "w": 13,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                },
                {
                    "x": 80,
                    "y": 16,
                    "w": 15,
                    "h": 71,
                    "type": "text",
                    "lines": 15
                }
            ]
        },
        {
            "id": "json_simple_grid_masonry_284",
            "name": "simple masonry grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple masonry-style uneven grid",
            "tags": [
                "json",
                "grid",
                "simple",
                "masonry"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 30,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 45,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 68,
                    "y": 16,
                    "w": 27,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 49,
                    "w": 28,
                    "h": 38,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 68,
                    "y": 44,
                    "w": 27,
                    "h": 30,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 36,
                    "y": 64,
                    "w": 28,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 68,
                    "y": 77,
                    "w": 27,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "json_simple_grid_asymmetric_285",
            "name": "simple asymmetric grid",
            "icon": "data_object",
            "category": "json_item",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "simple asymmetric grid layout",
            "tags": [
                "json",
                "grid",
                "simple",
                "asymmetric"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 35,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 43,
                    "y": 16,
                    "w": 25,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 71,
                    "y": 16,
                    "w": 24,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 20,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 28,
                    "y": 54,
                    "w": 30,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 61,
                    "y": 54,
                    "w": 34,
                    "h": 33,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "cool_fitness_split_fhd_001",
            "name": "fitness split hero",
            "icon": "fitness_center",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "dynamic split layout with large right image and left content stack",
            "tags": [
                "fitness",
                "split",
                "hero",
                "modern"
            ],
            "blocks": [
                {
                    "x": 8,
                    "y": 12,
                    "w": 40,
                    "h": 22,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 9,
                    "y": 33,
                    "w": 32,
                    "h": 18,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 9,
                    "y": 54,
                    "w": 30,
                    "h": 8,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 9,
                    "y": 66,
                    "w": 28,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 50,
                    "y": 15,
                    "w": 43,
                    "h": 85,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                }
            ]
        },
        {
            "id": "cool_services_panel_fhd_002",
            "name": "services vertical panel",
            "icon": "dashboard_customize",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "professional layout with left vertical panel and centered right content",
            "tags": [
                "services",
                "panel",
                "corporate",
                "clean"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 4,
                    "w": 34,
                    "h": 96,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 40,
                    "y": 9,
                    "w": 52,
                    "h": 33,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 44,
                    "y": 39,
                    "w": 44,
                    "h": 16,
                    "type": "text",
                    "lines": 1
                },
                {
                    "x": 38,
                    "y": 58,
                    "w": 54,
                    "h": 21,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 52,
                    "y": 82,
                    "w": 24,
                    "h": 8,
                    "type": "text",
                    "lines": 1
                }
            ]
        },
        {
            "id": "cool_magazine_overlap_fhd_003",
            "name": "magazine overlap design",
            "icon": "auto_stories",
            "category": "media",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "magazine-style layout with overlapping images and dynamic text placement",
            "tags": [
                "magazine",
                "overlap",
                "creative",
                "modern"
            ],
            "blocks": [
                {
                    "x": 17,
                    "y": 12,
                    "w": 34,
                    "h": 81,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 4,
                    "y": 59,
                    "w": 59,
                    "h": 27,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 50,
                    "y": 7,
                    "w": 46,
                    "h": 34,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 54,
                    "y": 37,
                    "w": 37,
                    "h": 22,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 57,
                    "y": 72,
                    "w": 31,
                    "h": 22,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "cool_diagonal_split_fhd_004",
            "name": "diagonal split dynamic",
            "icon": "call_split",
            "category": "bold",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bold diagonal split with contrasting image and text zones",
            "tags": [
                "diagonal",
                "split",
                "bold",
                "dynamic"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 45,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 54,
                    "y": 15,
                    "w": 40,
                    "h": 18,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 54,
                    "y": 33,
                    "w": 40,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 10,
                    "y": 55,
                    "w": 35,
                    "h": 40,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 54,
                    "y": 62,
                    "w": 38,
                    "h": 28,
                    "type": "text",
                    "lines": 6
                }
            ]
        },
        {
            "id": "cool_triple_column_fhd_005",
            "name": "triple column showcase",
            "icon": "view_column",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three-column layout perfect for comparisons or feature highlights",
            "tags": [
                "column",
                "grid",
                "comparison",
                "structured"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 26,
                    "h": 20,
                    "type": "icon",
                    "iconType": "star",
                    "rounded": false
                },
                {
                    "x": 37,
                    "y": 18,
                    "w": 26,
                    "h": 20,
                    "type": "icon",
                    "iconType": "trending_up",
                    "rounded": false
                },
                {
                    "x": 69,
                    "y": 18,
                    "w": 26,
                    "h": 20,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": false
                },
                {
                    "x": 5,
                    "y": 41,
                    "w": 26,
                    "h": 50,
                    "type": "textbox"
                },
                {
                    "x": 37,
                    "y": 41,
                    "w": 26,
                    "h": 50,
                    "type": "textbox"
                },
                {
                    "x": 69,
                    "y": 41,
                    "w": 26,
                    "h": 50,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_hero_center_fhd_006",
            "name": "centered hero spotlight",
            "icon": "center_focus_strong",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "powerful centered hero with supporting side elements",
            "tags": [
                "hero",
                "centered",
                "spotlight",
                "bold"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 10,
                    "w": 15,
                    "h": 30,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 25,
                    "y": 20,
                    "w": 50,
                    "h": 30,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 30,
                    "y": 50,
                    "w": 40,
                    "h": 30,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 80,
                    "y": 60,
                    "w": 15,
                    "h": 30,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 35,
                    "y": 83,
                    "w": 30,
                    "h": 12,
                    "type": "textbox",
                    "special": true
                }
            ]
        },
        {
            "id": "cool_layered_cards_fhd_007",
            "name": "layered card stack",
            "icon": "layers",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "stacked card design with depth and elevation",
            "tags": [
                "cards",
                "layered",
                "depth",
                "modern"
            ],
            "blocks": [
                {
                    "x": 8,
                    "y": 8,
                    "w": 35,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 15,
                    "y": 18,
                    "w": 35,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 55,
                    "y": 12,
                    "w": 38,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 55,
                    "y": 27,
                    "w": 38,
                    "h": 28,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 22,
                    "y": 60,
                    "w": 56,
                    "h": 32,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_asymmetric_mag_fhd_008",
            "name": "asymmetric magazine",
            "icon": "auto_awesome",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "editorial magazine-style asymmetric grid layout",
            "tags": [
                "magazine",
                "asymmetric",
                "editorial",
                "creative"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 55,
                    "h": 42,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 63,
                    "y": 5,
                    "w": 32,
                    "h": 24,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 63,
                    "y": 28,
                    "w": 32,
                    "h": 19,
                    "type": "text",
                    "lines": 4
                },
                {
                    "x": 5,
                    "y": 50,
                    "w": 38,
                    "h": 45,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 46,
                    "y": 50,
                    "w": 49,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                }
            ]
        },
        {
            "id": "cool_circular_focus_fhd_009",
            "name": "circular focus point",
            "icon": "album",
            "category": "minimal",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "clean layout with circular focal point and surrounding content",
            "tags": [
                "circular",
                "minimal",
                "focus",
                "clean"
            ],
            "blocks": [
                {
                    "x": 32,
                    "y": 20,
                    "w": 36,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 8,
                    "w": 80,
                    "h": 12,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 25,
                    "w": 22,
                    "h": 50,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 73,
                    "y": 25,
                    "w": 22,
                    "h": 50,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 35,
                    "y": 85,
                    "w": 30,
                    "h": 10,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_bottom_heavy_fhd_010",
            "name": "bottom heavy impact",
            "icon": "vertical_align_bottom",
            "category": "bold",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "impactful design with large bottom image and compact top content",
            "tags": [
                "bottom",
                "impact",
                "bold",
                "modern"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 5,
                    "w": 35,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 50,
                    "y": 5,
                    "w": 40,
                    "h": 28,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 5,
                    "y": 38,
                    "w": 90,
                    "h": 57,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 20,
                    "w": 12,
                    "h": 12,
                    "type": "icon",
                    "iconType": "rocket_launch",
                    "rounded": true
                }
            ]
        },
        {
            "id": "cool_side_panel_right_fhd_011",
            "name": "right panel showcase",
            "icon": "space_dashboard",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "professional layout with right vertical panel",
            "tags": [
                "panel",
                "right",
                "corporate",
                "professional"
            ],
            "blocks": [
                {
                    "x": 8,
                    "y": 10,
                    "w": 50,
                    "h": 24,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 8,
                    "y": 33,
                    "w": 48,
                    "h": 30,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 8,
                    "y": 67,
                    "w": 24,
                    "h": 24,
                    "type": "icon",
                    "iconType": "analytics",
                    "rounded": false
                },
                {
                    "x": 66,
                    "y": 4,
                    "w": 30,
                    "h": 92,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "cool_corner_accent_fhd_012",
            "name": "corner accent frame",
            "icon": "crop_free",
            "category": "minimal",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "minimalist design with corner accents framing central content",
            "tags": [
                "corner",
                "minimal",
                "frame",
                "accent"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 15,
                    "h": 15,
                    "type": "icon",
                    "iconType": "star",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 80,
                    "y": 5,
                    "w": 15,
                    "h": 15,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 25,
                    "w": 50,
                    "h": 22,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 20,
                    "y": 47,
                    "w": 60,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 5,
                    "y": 80,
                    "w": 15,
                    "h": 15,
                    "type": "icon",
                    "iconType": "lightbulb",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 80,
                    "y": 80,
                    "w": 15,
                    "h": 15,
                    "type": "icon",
                    "iconType": "verified",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "cool_floating_elements_fhd_013",
            "name": "floating elements dynamic",
            "icon": "scatter_plot",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "dynamic layout with scattered overlapping elements",
            "tags": [
                "floating",
                "dynamic",
                "creative",
                "scattered"
            ],
            "blocks": [
                {
                    "x": 15,
                    "y": 10,
                    "w": 30,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 50,
                    "y": 5,
                    "w": 35,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 55,
                    "y": 23,
                    "w": 35,
                    "h": 32,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 8,
                    "y": 50,
                    "w": 40,
                    "h": 40,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 52,
                    "y": 60,
                    "w": 42,
                    "h": 30,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_z_pattern_fhd_014",
            "name": "z-pattern flow",
            "icon": "show_chart",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "strategic z-pattern layout for optimal content flow",
            "tags": [
                "z-pattern",
                "flow",
                "marketing",
                "strategic"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 8,
                    "w": 40,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 8,
                    "w": 43,
                    "h": 28,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 15,
                    "y": 40,
                    "w": 70,
                    "h": 8,
                    "type": "text",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 52,
                    "w": 40,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 50,
                    "y": 58,
                    "w": 45,
                    "h": 32,
                    "type": "text",
                    "lines": 7
                }
            ]
        },
        {
            "id": "cool_frame_layout_fhd_015",
            "name": "framed content showcase",
            "icon": "border_outer",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "content framed by image borders creating depth",
            "tags": [
                "frame",
                "border",
                "creative",
                "depth"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 5,
                    "y": 80,
                    "w": 90,
                    "h": 15,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 5,
                    "y": 23,
                    "w": 18,
                    "h": 54,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 77,
                    "y": 23,
                    "w": 18,
                    "h": 54,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 28,
                    "y": 30,
                    "w": 44,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 30,
                    "y": 48,
                    "w": 40,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "cool_two_tone_split_fhd_016",
            "name": "two-tone vertical split",
            "icon": "vertical_split",
            "category": "bold",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "bold vertical split with contrasting two-tone design",
            "tags": [
                "two-tone",
                "split",
                "bold",
                "contrast"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 10,
                    "w": 40,
                    "h": 30,
                    "type": "header",
                    "lines": 2,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 40,
                    "w": 38,
                    "h": 35,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 8,
                    "y": 78,
                    "w": 18,
                    "h": 18,
                    "type": "icon",
                    "iconType": "check_circle",
                    "rounded": true
                },
                {
                    "x": 52,
                    "y": 5,
                    "w": 43,
                    "h": 90,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                }
            ]
        },
        {
            "id": "cool_cascading_cards_fhd_017",
            "name": "cascading card stack",
            "icon": "gradient",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "cascading offset cards creating visual rhythm",
            "tags": [
                "cascading",
                "cards",
                "rhythm",
                "modern"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 25,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 35,
                    "y": 28,
                    "w": 25,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 65,
                    "y": 36,
                    "w": 25,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 50,
                    "w": 25,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 35,
                    "y": 58,
                    "w": 25,
                    "h": 25,
                    "type": "textbox"
                },
                {
                    "x": 65,
                    "y": 66,
                    "w": 25,
                    "h": 25,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_spotlight_hero_fhd_018",
            "name": "spotlight hero banner",
            "icon": "highlight",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "dramatic hero spotlight with supporting micro-elements",
            "tags": [
                "spotlight",
                "hero",
                "banner",
                "dramatic"
            ],
            "blocks": [
                {
                    "x": 20,
                    "y": 15,
                    "w": 60,
                    "h": 36,
                    "type": "header",
                    "lines": 2,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 48,
                    "w": 50,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 5,
                    "y": 5,
                    "w": 12,
                    "h": 12,
                    "type": "icon",
                    "iconType": "star",
                    "rounded": true
                },
                {
                    "x": 83,
                    "y": 5,
                    "w": 12,
                    "h": 12,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true
                },
                {
                    "x": 35,
                    "y": 76,
                    "w": 30,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                }
            ]
        },
        {
            "id": "cool_grid_gallery_fhd_019",
            "name": "mixed grid gallery",
            "icon": "grid_view",
            "category": "media",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "pinterest-style mixed grid with varied element sizes",
            "tags": [
                "grid",
                "gallery",
                "pinterest",
                "mixed"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 28,
                    "h": 42,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 5,
                    "w": 28,
                    "h": 28,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 67,
                    "y": 5,
                    "w": 28,
                    "h": 56,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 50,
                    "w": 59,
                    "h": 45,
                    "type": "text",
                    "lines": 10
                },
                {
                    "x": 36,
                    "y": 36,
                    "w": 28,
                    "h": 14,
                    "type": "header",
                    "lines": 1
                }
            ]
        },
        {
            "id": "cool_stats_dashboard_fhd_020",
            "name": "stats dashboard premium",
            "icon": "insert_chart",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "premium dashboard layout with stats and data visualization zones",
            "tags": [
                "stats",
                "dashboard",
                "data",
                "analytics"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 20,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 20,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 51,
                    "y": 18,
                    "w": 20,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 74,
                    "y": 18,
                    "w": 21,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 58,
                    "h": 39,
                    "type": "chart",
                    "chartType": "bar"
                },
                {
                    "x": 66,
                    "y": 56,
                    "w": 29,
                    "h": 39,
                    "type": "chart",
                    "chartType": "pie"
                }
            ]
        },
        {
            "id": "cool_retail_promo_fhd_021",
            "name": "retail promo blast",
            "icon": "shopping_bag",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "high-impact retail promotion with product showcase and pricing",
            "tags": [
                "retail",
                "promo",
                "shopping",
                "sale"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 50,
                    "h": 35,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 60,
                    "y": 8,
                    "w": 35,
                    "h": 22,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 60,
                    "y": 30,
                    "w": 35,
                    "h": 8,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 45,
                    "w": 28,
                    "h": 25,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 45,
                    "w": 28,
                    "h": 25,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 67,
                    "y": 45,
                    "w": 28,
                    "h": 25,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 75,
                    "w": 90,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "cool_education_course_fhd_022",
            "name": "education course layout",
            "icon": "school",
            "category": "education",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "educational course presentation with instructor and content zones",
            "tags": [
                "education",
                "course",
                "learning",
                "training"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 35,
                    "h": 48,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 43,
                    "y": 20,
                    "w": 52,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 43,
                    "y": 48,
                    "w": 24,
                    "h": 20,
                    "type": "icon",
                    "iconType": "menu_book",
                    "rounded": true
                },
                {
                    "x": 71,
                    "y": 48,
                    "w": 24,
                    "h": 20,
                    "type": "icon",
                    "iconType": "video_library",
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 72,
                    "w": 90,
                    "h": 23,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_healthcare_info_fhd_023",
            "name": "healthcare info display",
            "icon": "local_hospital",
            "category": "healthcare",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "clean healthcare information display with icons and key data",
            "tags": [
                "healthcare",
                "medical",
                "info",
                "clean"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 10,
                    "w": 80,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 30,
                    "w": 18,
                    "h": 18,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 27,
                    "y": 30,
                    "w": 18,
                    "h": 18,
                    "type": "icon",
                    "iconType": "healing",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 49,
                    "y": 30,
                    "w": 18,
                    "h": 18,
                    "type": "icon",
                    "iconType": "medication",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 71,
                    "y": 30,
                    "w": 18,
                    "h": 18,
                    "type": "icon",
                    "iconType": "emergency",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 52,
                    "w": 42,
                    "h": 43,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 53,
                    "y": 52,
                    "w": 42,
                    "h": 43,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                }
            ]
        },
        {
            "id": "cool_social_feed_fhd_024",
            "name": "social media feed",
            "icon": "dynamic_feed",
            "category": "social",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "social media inspired feed layout with posts and engagement",
            "tags": [
                "social",
                "feed",
                "instagram",
                "modern"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 25,
                    "h": 25,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 33,
                    "y": 5,
                    "w": 62,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 33,
                    "y": 20,
                    "w": 62,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 33,
                    "w": 90,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 5,
                    "y": 81,
                    "w": 20,
                    "h": 14,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": false
                },
                {
                    "x": 28,
                    "y": 81,
                    "w": 20,
                    "h": 14,
                    "type": "icon",
                    "iconType": "comment",
                    "rounded": false
                },
                {
                    "x": 51,
                    "y": 81,
                    "w": 20,
                    "h": 14,
                    "type": "icon",
                    "iconType": "share",
                    "rounded": false
                }
            ]
        },
        {
            "id": "cool_hospitality_menu_fhd_025",
            "name": "hospitality menu board",
            "icon": "restaurant_menu",
            "category": "hospitality",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "elegant restaurant menu or hotel services display",
            "tags": [
                "hospitality",
                "menu",
                "restaurant",
                "hotel"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 38,
                    "h": 90,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 48,
                    "y": 8,
                    "w": 47,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 48,
                    "y": 26,
                    "w": 47,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 48,
                    "y": 47,
                    "w": 47,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 48,
                    "y": 68,
                    "w": 47,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 48,
                    "y": 89,
                    "w": 20,
                    "h": 8,
                    "type": "text",
                    "lines": 1
                }
            ]
        },
        {
            "id": "cool_event_promo_fhd_026",
            "name": "event promo dynamic",
            "icon": "event",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "dynamic event promotion with date, time, and location emphasis",
            "tags": [
                "event",
                "promo",
                "concert",
                "conference"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 15,
                    "w": 90,
                    "h": 30,
                    "type": "header",
                    "lines": 2,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 45,
                    "w": 55,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 63,
                    "y": 45,
                    "w": 32,
                    "h": 15,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 63,
                    "y": 63,
                    "w": 32,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 63,
                    "y": 81,
                    "w": 32,
                    "h": 14,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "cool_portfolio_showcase_fhd_027",
            "name": "portfolio project showcase",
            "icon": "collections",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "creative portfolio project presentation with image grid",
            "tags": [
                "portfolio",
                "creative",
                "project",
                "showcase"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 32,
                    "h": 42,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 40,
                    "y": 5,
                    "w": 27,
                    "h": 20,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 70,
                    "y": 5,
                    "w": 25,
                    "h": 20,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 40,
                    "y": 27,
                    "w": 55,
                    "h": 24,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 50,
                    "w": 90,
                    "h": 45,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "cool_quote_inspire_fhd_028",
            "name": "inspirational quote",
            "icon": "format_quote",
            "category": "minimal",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "minimalist inspirational quote with elegant typography",
            "tags": [
                "quote",
                "inspire",
                "minimal",
                "typography"
            ],
            "blocks": [
                {
                    "x": 15,
                    "y": 25,
                    "w": 70,
                    "h": 42,
                    "type": "header",
                    "lines": 3,
                    "special": true
                },
                {
                    "x": 35,
                    "y": 65,
                    "w": 30,
                    "h": 8,
                    "type": "text",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 5,
                    "w": 12,
                    "h": 12,
                    "type": "icon",
                    "iconType": "format_quote",
                    "rounded": false,
                    "special": true
                },
                {
                    "x": 83,
                    "y": 83,
                    "w": 12,
                    "h": 12,
                    "type": "icon",
                    "iconType": "format_quote",
                    "rounded": false,
                    "special": true
                }
            ]
        },
        {
            "id": "cool_comparison_split_fhd_029",
            "name": "before after comparison",
            "icon": "compare",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "side-by-side comparison layout for before/after or product comparisons",
            "tags": [
                "comparison",
                "before-after",
                "split",
                "versus"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 42,
                    "h": 12,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 42,
                    "h": 12,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 33,
                    "w": 42,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 53,
                    "y": 33,
                    "w": 42,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 47,
                    "y": 60,
                    "w": 6,
                    "h": 6,
                    "type": "icon",
                    "iconType": "compare_arrows",
                    "rounded": true,
                    "special": true
                }
            ]
        },
        {
            "id": "cool_testimonial_quote_fhd_030",
            "name": "customer testimonial",
            "icon": "reviews",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "customer testimonial with photo, quote, and attribution",
            "tags": [
                "testimonial",
                "review",
                "customer",
                "social-proof"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 20,
                    "w": 30,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 40,
                    "y": 15,
                    "w": 55,
                    "h": 30,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 40,
                    "y": 48,
                    "w": 55,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 40,
                    "y": 63,
                    "w": 25,
                    "h": 15,
                    "type": "icon",
                    "iconType": "star",
                    "rounded": false,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                }
            ]
        },
        {
            "id": "cool_infographic_process_fhd_031",
            "name": "process infographic",
            "icon": "timeline",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "step-by-step process visualization with icons and descriptions",
            "tags": [
                "infographic",
                "process",
                "steps",
                "timeline"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 16,
                    "h": 16,
                    "type": "icon",
                    "iconType": "looks_one",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 27,
                    "y": 22,
                    "w": 16,
                    "h": 16,
                    "type": "icon",
                    "iconType": "looks_two",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 49,
                    "y": 22,
                    "w": 16,
                    "h": 16,
                    "type": "icon",
                    "iconType": "looks_3",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 71,
                    "y": 22,
                    "w": 16,
                    "h": 16,
                    "type": "icon",
                    "iconType": "looks_4",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 42,
                    "w": 16,
                    "h": 50,
                    "type": "textbox"
                },
                {
                    "x": 27,
                    "y": 42,
                    "w": 16,
                    "h": 50,
                    "type": "textbox"
                },
                {
                    "x": 49,
                    "y": 42,
                    "w": 16,
                    "h": 50,
                    "type": "textbox"
                },
                {
                    "x": 71,
                    "y": 42,
                    "w": 16,
                    "h": 50,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_feature_highlight_fhd_032",
            "name": "feature highlight grid",
            "icon": "widgets",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "feature highlights in organized grid with icons",
            "tags": [
                "features",
                "grid",
                "highlights",
                "benefits"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 28,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 20,
                    "w": 28,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 67,
                    "y": 20,
                    "w": 28,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 28,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 58,
                    "w": 28,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 67,
                    "y": 58,
                    "w": 28,
                    "h": 35,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_pricing_table_fhd_033",
            "name": "pricing comparison table",
            "icon": "attach_money",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "pricing tiers comparison with features and call-to-action",
            "tags": [
                "pricing",
                "table",
                "comparison",
                "subscription"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 26,
                    "h": 12,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 37,
                    "y": 18,
                    "w": 26,
                    "h": 12,
                    "type": "text",
                    "lines": 2,
                    "special": true
                },
                {
                    "x": 69,
                    "y": 18,
                    "w": 26,
                    "h": 12,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 33,
                    "w": 26,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 37,
                    "y": 33,
                    "w": 26,
                    "h": 15,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 69,
                    "y": 33,
                    "w": 26,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 51,
                    "w": 26,
                    "h": 40,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 37,
                    "y": 51,
                    "w": 26,
                    "h": 40,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 69,
                    "y": 51,
                    "w": 26,
                    "h": 40,
                    "type": "text",
                    "lines": 8
                }
            ]
        },
        {
            "id": "cool_app_mockup_fhd_034",
            "name": "app screen showcase",
            "icon": "phone_iphone",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "mobile app or software interface showcase with features",
            "tags": [
                "app",
                "mockup",
                "mobile",
                "software"
            ],
            "blocks": [
                {
                    "x": 8,
                    "y": 10,
                    "w": 35,
                    "h": 80,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 50,
                    "y": 10,
                    "w": 45,
                    "h": 22,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 50,
                    "y": 32,
                    "w": 45,
                    "h": 25,
                    "type": "text",
                    "lines": 5
                },
                {
                    "x": 50,
                    "y": 60,
                    "w": 20,
                    "h": 12,
                    "type": "icon",
                    "iconType": "touch_app",
                    "rounded": true
                },
                {
                    "x": 75,
                    "y": 60,
                    "w": 20,
                    "h": 12,
                    "type": "icon",
                    "iconType": "notifications",
                    "rounded": true
                },
                {
                    "x": 50,
                    "y": 75,
                    "w": 45,
                    "h": 15,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_team_members_fhd_035",
            "name": "team members showcase",
            "icon": "groups",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "team member profiles with photos and roles",
            "tags": [
                "team",
                "members",
                "staff",
                "about"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 18,
                    "h": 25,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 28,
                    "y": 18,
                    "w": 18,
                    "h": 25,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 51,
                    "y": 18,
                    "w": 18,
                    "h": 25,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 74,
                    "y": 18,
                    "w": 18,
                    "h": 25,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 46,
                    "w": 18,
                    "h": 45,
                    "type": "textbox"
                },
                {
                    "x": 28,
                    "y": 46,
                    "w": 18,
                    "h": 45,
                    "type": "textbox"
                },
                {
                    "x": 51,
                    "y": 46,
                    "w": 18,
                    "h": 45,
                    "type": "textbox"
                },
                {
                    "x": 74,
                    "y": 46,
                    "w": 18,
                    "h": 45,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_weather_widget_fhd_036",
            "name": "weather display widget",
            "icon": "wb_sunny",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "weather information display with forecast and conditions",
            "tags": [
                "weather",
                "forecast",
                "widget",
                "info"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 15,
                    "w": 80,
                    "h": 24,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 40,
                    "w": 60,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 10,
                    "y": 80,
                    "w": 16,
                    "h": 12,
                    "type": "icon",
                    "iconType": "cloud",
                    "rounded": false
                },
                {
                    "x": 30,
                    "y": 80,
                    "w": 16,
                    "h": 12,
                    "type": "icon",
                    "iconType": "wb_sunny",
                    "rounded": false
                },
                {
                    "x": 50,
                    "y": 80,
                    "w": 16,
                    "h": 12,
                    "type": "icon",
                    "iconType": "ac_unit",
                    "rounded": false
                },
                {
                    "x": 70,
                    "y": 80,
                    "w": 16,
                    "h": 12,
                    "type": "icon",
                    "iconType": "water_drop",
                    "rounded": false
                }
            ]
        },
        {
            "id": "cool_news_ticker_fhd_037",
            "name": "news headline ticker",
            "icon": "article",
            "category": "media",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "news headlines with featured story and breaking news",
            "tags": [
                "news",
                "headlines",
                "ticker",
                "media"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 58,
                    "h": 55,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 66,
                    "y": 5,
                    "w": 29,
                    "h": 55,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 5,
                    "y": 63,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 76,
                    "w": 90,
                    "h": 19,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "cool_product_launch_fhd_038",
            "name": "product launch announcement",
            "icon": "new_releases",
            "category": "marketing",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "product launch with dramatic reveal and key features",
            "tags": [
                "product",
                "launch",
                "announcement",
                "new"
            ],
            "blocks": [
                {
                    "x": 15,
                    "y": 10,
                    "w": 70,
                    "h": 24,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 35,
                    "w": 50,
                    "h": 45,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true,
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 35,
                    "w": 16,
                    "h": 12,
                    "type": "icon",
                    "iconType": "new_releases",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 79,
                    "y": 35,
                    "w": 16,
                    "h": 12,
                    "type": "icon",
                    "iconType": "stars",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 84,
                    "w": 60,
                    "h": 11,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_video_player_fhd_039",
            "name": "video player layout",
            "icon": "play_circle",
            "category": "media",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "video content display with title, description, and controls",
            "tags": [
                "video",
                "player",
                "media",
                "youtube"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 42,
                    "y": 28,
                    "w": 16,
                    "h": 16,
                    "type": "icon",
                    "iconType": "play_circle",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 68,
                    "w": 68,
                    "h": 15,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 83,
                    "w": 68,
                    "h": 12,
                    "type": "text",
                    "lines": 2
                },
                {
                    "x": 77,
                    "y": 68,
                    "w": 18,
                    "h": 27,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_wayfinding_map_fhd_040",
            "name": "wayfinding directory",
            "icon": "map",
            "category": "hospitality",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "wayfinding map with location markers and directory",
            "tags": [
                "wayfinding",
                "map",
                "directory",
                "navigation"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 60,
                    "h": 77,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 68,
                    "y": 18,
                    "w": 27,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 68,
                    "y": 39,
                    "w": 27,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 68,
                    "y": 60,
                    "w": 27,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 68,
                    "y": 81,
                    "w": 27,
                    "h": 14,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "cool_safety_protocol_fhd_041",
            "name": "safety protocol display",
            "icon": "health_and_safety",
            "category": "healthcare",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "safety protocols and emergency information display",
            "tags": [
                "safety",
                "protocol",
                "emergency",
                "healthcare"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 42,
                    "h": 22,
                    "type": "icon",
                    "iconType": "health_and_safety",
                    "rounded": false,
                    "special": true
                },
                {
                    "x": 53,
                    "y": 20,
                    "w": 42,
                    "h": 22,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 45,
                    "w": 90,
                    "h": 50,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "cool_countdown_timer_fhd_042",
            "name": "countdown event timer",
            "icon": "timer",
            "category": "bold",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "dramatic countdown timer for events or launches",
            "tags": [
                "countdown",
                "timer",
                "event",
                "urgency"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 10,
                    "w": 80,
                    "h": 22,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 32,
                    "w": 17,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 31,
                    "y": 32,
                    "w": 17,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 32,
                    "w": 17,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 73,
                    "y": 32,
                    "w": 17,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 10,
                    "y": 72,
                    "w": 80,
                    "h": 23,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "cool_gallery_masonry_fhd_043",
            "name": "masonry photo gallery",
            "icon": "photo_library",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "masonry-style photo gallery with varied sizes",
            "tags": [
                "gallery",
                "masonry",
                "photos",
                "portfolio"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 38,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 46,
                    "y": 16,
                    "w": 24,
                    "h": 24,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 73,
                    "y": 16,
                    "w": 22,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 57,
                    "w": 22,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 30,
                    "y": 57,
                    "w": 40,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 46,
                    "y": 43,
                    "w": 24,
                    "h": 11,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_achievement_badge_fhd_044",
            "name": "achievement showcase",
            "icon": "military_tech",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "achievement badges, awards, and recognition display",
            "tags": [
                "achievement",
                "awards",
                "recognition",
                "badges"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 8,
                    "w": 80,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 15,
                    "y": 28,
                    "w": 18,
                    "h": 25,
                    "type": "icon",
                    "iconType": "military_tech",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 41,
                    "y": 28,
                    "w": 18,
                    "h": 25,
                    "type": "icon",
                    "iconType": "emoji_events",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 67,
                    "y": 28,
                    "w": 18,
                    "h": 25,
                    "type": "icon",
                    "iconType": "workspace_premium",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 58,
                    "w": 24,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 38,
                    "y": 58,
                    "w": 24,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 66,
                    "y": 58,
                    "w": 24,
                    "h": 35,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "cool_schedule_timetable_fhd_045",
            "name": "schedule timetable display",
            "icon": "schedule",
            "category": "education",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "daily schedule or timetable with time slots",
            "tags": [
                "schedule",
                "timetable",
                "agenda",
                "calendar"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 12,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 20,
                    "y": 18,
                    "w": 75,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 36,
                    "w": 12,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 20,
                    "y": 36,
                    "w": 75,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 54,
                    "w": 12,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 20,
                    "y": 54,
                    "w": 75,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 72,
                    "w": 12,
                    "h": 15,
                    "type": "textbox"
                },
                {
                    "x": 20,
                    "y": 72,
                    "w": 75,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "ds_split_clock_text_fhd_046",
            "name": "split screen clock display",
            "icon": "splitscreen",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "classic 50/50 split - image left, clock and text right for corporate lobbies",
            "tags": [
                "digital-signage",
                "split-screen",
                "clock",
                "lobby"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 0,
                    "w": 50,
                    "h": 100,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 52,
                    "y": 10,
                    "w": 43,
                    "h": 35,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 52,
                    "y": 50,
                    "w": 43,
                    "h": 24,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 52,
                    "y": 75,
                    "w": 43,
                    "h": 20,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "ds_weather_corner_fhd_047",
            "name": "weather corner widget",
            "icon": "wb_sunny",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "full screen content with weather widget in top-right corner",
            "tags": [
                "digital-signage",
                "weather",
                "widget",
                "corner"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 0,
                    "w": 100,
                    "h": 100,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 70,
                    "y": 5,
                    "w": 28,
                    "h": 22,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 75,
                    "w": 60,
                    "h": 24,
                    "type": "header",
                    "lines": 2,
                    "special": true
                }
            ]
        },
        {
            "id": "ds_timezone_clocks_fhd_048",
            "name": "multi timezone display",
            "icon": "public",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "multiple time zones for global offices and international business",
            "tags": [
                "digital-signage",
                "timezone",
                "global",
                "office"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 22,
                    "w": 21,
                    "h": 32,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 29,
                    "y": 22,
                    "w": 21,
                    "h": 32,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 22,
                    "w": 21,
                    "h": 32,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 77,
                    "y": 22,
                    "w": 18,
                    "h": 32,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 45,
                    "h": 37,
                    "type": "text",
                    "lines": 8
                },
                {
                    "x": 53,
                    "y": 58,
                    "w": 42,
                    "h": 37,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                }
            ]
        },
        {
            "id": "ds_queue_now_serving_fhd_049",
            "name": "queue now serving",
            "icon": "confirmation_number",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "queue management display showing current serving number",
            "tags": [
                "digital-signage",
                "queue",
                "waiting",
                "ticket"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 25,
                    "w": 60,
                    "h": 50,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 80,
                    "w": 90,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "ds_transit_arrivals_fhd_050",
            "name": "transit arrivals board",
            "icon": "directions_transit",
            "category": "hospitality",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "airport/train station arrivals and departures board",
            "tags": [
                "digital-signage",
                "transit",
                "airport",
                "train"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 90,
                    "h": 14,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 34,
                    "w": 90,
                    "h": 14,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 50,
                    "w": 90,
                    "h": 14,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 66,
                    "w": 90,
                    "h": 14,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 82,
                    "w": 90,
                    "h": 14,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "ds_kpi_dashboard_fhd_051",
            "name": "corporate kpi dashboard",
            "icon": "speed",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "real-time kpi metrics dashboard for corporate displays",
            "tags": [
                "digital-signage",
                "kpi",
                "dashboard",
                "metrics"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 10,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 36,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 67,
                    "y": 16,
                    "w": 28,
                    "h": 25,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 58,
                    "h": 51,
                    "type": "chart",
                    "chartType": "bar"
                },
                {
                    "x": 66,
                    "y": 44,
                    "w": 29,
                    "h": 51,
                    "type": "chart",
                    "chartType": "pie"
                }
            ]
        },
        {
            "id": "ds_menu_board_pricing_fhd_052",
            "name": "restaurant menu board",
            "icon": "restaurant",
            "category": "hospitality",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "restaurant or cafe menu with pricing and images",
            "tags": [
                "digital-signage",
                "menu",
                "restaurant",
                "cafe"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 28,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 36,
                    "y": 18,
                    "w": 28,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 67,
                    "y": 18,
                    "w": 28,
                    "h": 38,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 59,
                    "w": 28,
                    "h": 36,
                    "type": "textbox"
                },
                {
                    "x": 36,
                    "y": 59,
                    "w": 28,
                    "h": 36,
                    "type": "textbox"
                },
                {
                    "x": 67,
                    "y": 59,
                    "w": 28,
                    "h": 36,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "ds_building_directory_fhd_053",
            "name": "building directory",
            "icon": "domain",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "office building floor directory and tenant listing",
            "tags": [
                "digital-signage",
                "directory",
                "building",
                "wayfinding"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 42,
                    "h": 75,
                    "type": "text",
                    "lines": 18
                },
                {
                    "x": 53,
                    "y": 20,
                    "w": 42,
                    "h": 75,
                    "type": "text",
                    "lines": 18
                }
            ]
        },
        {
            "id": "ds_meeting_room_booking_fhd_054",
            "name": "conference room schedule",
            "icon": "meeting_room",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "conference room booking and availability display",
            "tags": [
                "digital-signage",
                "meeting",
                "booking",
                "calendar"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 60,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 68,
                    "y": 5,
                    "w": 27,
                    "h": 15,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 23,
                    "w": 90,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 44,
                    "w": 90,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 65,
                    "w": 90,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 86,
                    "w": 90,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "ds_emergency_alert_fhd_055",
            "name": "emergency alert display",
            "icon": "warning",
            "category": "healthcare",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "emergency notification and safety alert screen",
            "tags": [
                "digital-signage",
                "emergency",
                "alert",
                "safety"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 15,
                    "w": 80,
                    "h": 24,
                    "type": "header",
                    "lines": 2,
                    "special": true
                },
                {
                    "x": 15,
                    "y": 40,
                    "w": 70,
                    "h": 35,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 5,
                    "y": 5,
                    "w": 15,
                    "h": 15,
                    "type": "icon",
                    "iconType": "warning",
                    "rounded": false,
                    "special": true
                },
                {
                    "x": 80,
                    "y": 5,
                    "w": 15,
                    "h": 15,
                    "type": "icon",
                    "iconType": "warning",
                    "rounded": false,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 80,
                    "w": 50,
                    "h": 15,
                    "type": "textbox",
                    "special": true
                }
            ]
        },
        {
            "id": "ds_news_ticker_bottom_fhd_056",
            "name": "news ticker with content",
            "icon": "live_tv",
            "category": "media",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "main content area with scrolling news ticker at bottom",
            "tags": [
                "digital-signage",
                "news",
                "ticker",
                "scrolling"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 0,
                    "w": 100,
                    "h": 85,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 0,
                    "y": 87,
                    "w": 100,
                    "h": 13,
                    "type": "textbox",
                    "special": true
                }
            ]
        },
        {
            "id": "ds_social_wall_instagram_fhd_057",
            "name": "social media wall",
            "icon": "grid_on",
            "category": "social",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "instagram-style social media wall with hashtag feed",
            "tags": [
                "digital-signage",
                "social",
                "instagram",
                "hashtag"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 12,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 18,
                    "w": 21,
                    "h": 26,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 29,
                    "y": 18,
                    "w": 21,
                    "h": 26,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 53,
                    "y": 18,
                    "w": 21,
                    "h": 26,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 77,
                    "y": 18,
                    "w": 18,
                    "h": 26,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 47,
                    "w": 21,
                    "h": 26,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 29,
                    "y": 47,
                    "w": 21,
                    "h": 26,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 53,
                    "y": 47,
                    "w": 21,
                    "h": 26,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 77,
                    "y": 47,
                    "w": 18,
                    "h": 26,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 76,
                    "w": 90,
                    "h": 19,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "ds_lobby_welcome_fhd_058",
            "name": "corporate lobby welcome",
            "icon": "waving_hand",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "visitor welcome screen with company branding",
            "tags": [
                "digital-signage",
                "lobby",
                "welcome",
                "visitor"
            ],
            "blocks": [
                {
                    "x": 25,
                    "y": 15,
                    "w": 50,
                    "h": 30,
                    "type": "header",
                    "lines": 2,
                    "special": true
                },
                {
                    "x": 35,
                    "y": 45,
                    "w": 30,
                    "h": 30,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 80,
                    "w": 60,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "ds_employee_spotlight_fhd_059",
            "name": "employee recognition",
            "icon": "workspace_premium",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "employee of the month or team recognition display",
            "tags": [
                "digital-signage",
                "employee",
                "recognition",
                "awards"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 15,
                    "y": 22,
                    "w": 35,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 55,
                    "y": 25,
                    "w": 40,
                    "h": 22,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 55,
                    "y": 48,
                    "w": 40,
                    "h": 34,
                    "type": "text",
                    "lines": 7
                },
                {
                    "x": 5,
                    "y": 87,
                    "w": 90,
                    "h": 8,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "ds_visitor_checkin_fhd_060",
            "name": "visitor check-in",
            "icon": "how_to_reg",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "visitor registration and check-in instructions with qr code",
            "tags": [
                "digital-signage",
                "visitor",
                "checkin",
                "qr-code"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 10,
                    "y": 25,
                    "w": 35,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 50,
                    "y": 25,
                    "w": 45,
                    "h": 60,
                    "type": "text",
                    "lines": 12
                },
                {
                    "x": 30,
                    "y": 90,
                    "w": 40,
                    "h": 8,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "ds_elevator_ads_fhd_061",
            "name": "elevator display",
            "icon": "elevator",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "elevator screen with floor info and advertisements",
            "tags": [
                "digital-signage",
                "elevator",
                "ads",
                "building"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 25,
                    "h": 20,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 35,
                    "y": 8,
                    "w": 60,
                    "h": 18,
                    "type": "header",
                    "lines": 1
                },
                {
                    "x": 5,
                    "y": 30,
                    "w": 90,
                    "h": 55,
                    "type": "mimeType",
                    "isMimeType": true
                },
                {
                    "x": 5,
                    "y": 88,
                    "w": 90,
                    "h": 10,
                    "type": "text",
                    "lines": 2
                }
            ]
        },
        {
            "id": "ds_retail_qr_promo_fhd_062",
            "name": "retail qr promotion",
            "icon": "qr_code_2",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "product promotion with large qr code for mobile engagement",
            "tags": [
                "digital-signage",
                "retail",
                "qr-code",
                "promo"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 8,
                    "w": 90,
                    "h": 18,
                    "type": "header",
                    "lines": 2,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 28,
                    "w": 45,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 55,
                    "y": 28,
                    "w": 40,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 5,
                    "y": 92,
                    "w": 90,
                    "h": 6,
                    "type": "text",
                    "lines": 1
                }
            ]
        },
        {
            "id": "ds_event_agenda_timeline_fhd_063",
            "name": "event agenda timeline",
            "icon": "event_note",
            "category": "education",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "conference or event schedule with timeline view",
            "tags": [
                "digital-signage",
                "event",
                "agenda",
                "conference"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 15,
                    "h": 15,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 23,
                    "y": 20,
                    "w": 72,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 38,
                    "w": 15,
                    "h": 15,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 23,
                    "y": 38,
                    "w": 72,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 56,
                    "w": 15,
                    "h": 15,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 23,
                    "y": 56,
                    "w": 72,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                },
                {
                    "x": 5,
                    "y": 74,
                    "w": 15,
                    "h": 15,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 23,
                    "y": 74,
                    "w": 72,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "ds_cafeteria_daily_menu_fhd_064",
            "name": "cafeteria daily specials",
            "icon": "lunch_dining",
            "category": "hospitality",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "daily cafeteria menu and specials board",
            "tags": [
                "digital-signage",
                "cafeteria",
                "menu",
                "daily"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 5,
                    "w": 90,
                    "h": 15,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 5,
                    "y": 20,
                    "w": 42,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 53,
                    "y": 20,
                    "w": 42,
                    "h": 35,
                    "type": "textbox"
                },
                {
                    "x": 5,
                    "y": 58,
                    "w": 42,
                    "h": 37,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                },
                {
                    "x": 53,
                    "y": 58,
                    "w": 42,
                    "h": 37,
                    "type": "mimeType",
                    "isMimeType": true,
                    "rounded": true
                }
            ]
        },
        {
            "id": "ds_wellness_health_tips_fhd_065",
            "name": "wellness and health tips",
            "icon": "favorite",
            "category": "healthcare",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "daily wellness tips and health information display",
            "tags": [
                "digital-signage",
                "wellness",
                "health",
                "tips"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 10,
                    "w": 80,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 30,
                    "w": 50,
                    "h": 45,
                    "type": "text",
                    "lines": 9
                },
                {
                    "x": 5,
                    "y": 30,
                    "w": 16,
                    "h": 16,
                    "type": "icon",
                    "iconType": "favorite",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 79,
                    "y": 30,
                    "w": 16,
                    "h": 16,
                    "type": "icon",
                    "iconType": "self_improvement",
                    "rounded": true,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 80,
                    "w": 50,
                    "h": 15,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "ds_safety_days_counter_fhd_066",
            "name": "safety days counter",
            "icon": "shield",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "workplace safety metrics - days without incident",
            "tags": [
                "digital-signage",
                "safety",
                "metrics",
                "workplace"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 10,
                    "w": 80,
                    "h": 18,
                    "type": "header",
                    "lines": 1,
                    "special": true
                },
                {
                    "x": 25,
                    "y": 30,
                    "w": 50,
                    "h": 45,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 10,
                    "y": 80,
                    "w": 80,
                    "h": 15,
                    "type": "text",
                    "lines": 3
                }
            ]
        },
        {
            "id": "ds_triple_zone_layout_fhd_067",
            "name": "triple zone layout",
            "icon": "view_agenda",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "three zone layout - top bar, main content, side panel",
            "tags": [
                "digital-signage",
                "multi-zone",
                "three-zone",
                "layout"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 0,
                    "w": 100,
                    "h": 12,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 0,
                    "y": 14,
                    "w": 70,
                    "h": 86,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 72,
                    "y": 14,
                    "w": 28,
                    "h": 28,
                    "type": "textbox"
                },
                {
                    "x": 72,
                    "y": 44,
                    "w": 28,
                    "h": 28,
                    "type": "textbox"
                },
                {
                    "x": 72,
                    "y": 74,
                    "w": 28,
                    "h": 26,
                    "type": "text",
                    "lines": 5
                }
            ]
        },
        {
            "id": "ds_quad_zone_equal_fhd_068",
            "name": "quad zone equal",
            "icon": "dashboard",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "four equal zones for multi-content display",
            "tags": [
                "digital-signage",
                "quad-zone",
                "four-zone",
                "grid"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 0,
                    "w": 50,
                    "h": 50,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 51,
                    "y": 0,
                    "w": 49,
                    "h": 50,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 0,
                    "y": 51,
                    "w": 50,
                    "h": 49,
                    "type": "chart",
                    "chartType": "bar"
                },
                {
                    "x": 51,
                    "y": 51,
                    "w": 49,
                    "h": 49,
                    "type": "text",
                    "lines": 10
                }
            ]
        },
        {
            "id": "ds_l_shaped_content_fhd_069",
            "name": "l-shaped layout",
            "icon": "border_left",
            "category": "creative",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "l-shaped design with top header and left panel",
            "tags": [
                "digital-signage",
                "l-shape",
                "layout",
                "creative"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 0,
                    "w": 100,
                    "h": 22,
                    "type": "header",
                    "lines": 2,
                    "special": true
                },
                {
                    "x": 0,
                    "y": 20,
                    "w": 30,
                    "h": 80,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 32,
                    "y": 20,
                    "w": 68,
                    "h": 80,
                    "type": "mimeType",
                    "isMimeType": true
                }
            ]
        },
        {
            "id": "ds_corner_widgets_fhd_070",
            "name": "four corner widgets",
            "icon": "control_camera",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "main content with data widgets in all four corners",
            "tags": [
                "digital-signage",
                "widgets",
                "corners",
                "dashboard"
            ],
            "blocks": [
                {
                    "x": 15,
                    "y": 15,
                    "w": 70,
                    "h": 70,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 0,
                    "y": 0,
                    "w": 18,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 82,
                    "y": 0,
                    "w": 18,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 0,
                    "y": 82,
                    "w": 18,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 82,
                    "y": 82,
                    "w": 18,
                    "h": 18,
                    "type": "textbox",
                    "special": true
                }
            ]
        },
        {
            "id": "ds_vertical_split_60_40_fhd_071",
            "name": "vertical split 60/40",
            "icon": "vertical_split",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "60/40 vertical split for content and sidebar",
            "tags": [
                "digital-signage",
                "split",
                "vertical",
                "sidebar"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 0,
                    "w": 60,
                    "h": 100,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 62,
                    "y": 5,
                    "w": 36,
                    "h": 30,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 62,
                    "y": 33,
                    "w": 36,
                    "h": 30,
                    "type": "text",
                    "lines": 6
                },
                {
                    "x": 62,
                    "y": 66,
                    "w": 36,
                    "h": 30,
                    "type": "textbox"
                }
            ]
        },
        {
            "id": "ds_horizontal_bands_fhd_072",
            "name": "horizontal info bands",
            "icon": "view_day",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "stacked horizontal information bands",
            "tags": [
                "digital-signage",
                "horizontal",
                "bands",
                "stacked"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 0,
                    "w": 100,
                    "h": 20,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 0,
                    "y": 21,
                    "w": 100,
                    "h": 20,
                    "type": "textbox"
                },
                {
                    "x": 0,
                    "y": 42,
                    "w": 100,
                    "h": 20,
                    "type": "textbox"
                },
                {
                    "x": 0,
                    "y": 63,
                    "w": 100,
                    "h": 18,
                    "type": "textbox"
                },
                {
                    "x": 0,
                    "y": 82,
                    "w": 100,
                    "h": 18,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "ds_clock_weather_combo_fhd_073",
            "name": "clock and weather combo",
            "icon": "schedule",
            "category": "corporate",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "prominent time and weather display for lobbies",
            "tags": [
                "digital-signage",
                "clock",
                "weather",
                "combo"
            ],
            "blocks": [
                {
                    "x": 5,
                    "y": 10,
                    "w": 42,
                    "h": 40,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 53,
                    "y": 10,
                    "w": 42,
                    "h": 40,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 55,
                    "w": 90,
                    "h": 22,
                    "type": "header",
                    "lines": 2
                },
                {
                    "x": 5,
                    "y": 78,
                    "w": 90,
                    "h": 18,
                    "type": "text",
                    "lines": 4
                }
            ]
        },
        {
            "id": "ds_qr_code_large_fhd_074",
            "name": "qr code focus display",
            "icon": "qr_code_scanner",
            "category": "retail",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "large qr code with scan instructions for mobile engagement",
            "tags": [
                "digital-signage",
                "qr-code",
                "scan",
                "mobile"
            ],
            "blocks": [
                {
                    "x": 10,
                    "y": 8,
                    "w": 80,
                    "h": 18,
                    "type": "header",
                    "lines": 2,
                    "special": true
                },
                {
                    "x": 30,
                    "y": 28,
                    "w": 40,
                    "h": 60,
                    "type": "mimeType",
                    "isMimeType": true,
                    "special": true
                },
                {
                    "x": 20,
                    "y": 92,
                    "w": 60,
                    "h": 6,
                    "type": "text",
                    "lines": 1
                }
            ]
        },
        {
            "id": "ds_live_data_ticker_fhd_075",
            "name": "live data feed ticker",
            "icon": "show_chart",
            "category": "data",
            "resolution": "fullhd_landscape",
            "width": 1920,
            "height": 1080,
            "description": "stock ticker, live metrics, or scrolling data feed",
            "tags": [
                "digital-signage",
                "ticker",
                "live-data",
                "stocks"
            ],
            "blocks": [
                {
                    "x": 0,
                    "y": 0,
                    "w": 100,
                    "h": 12,
                    "type": "textbox",
                    "special": true
                },
                {
                    "x": 5,
                    "y": 15,
                    "w": 90,
                    "h": 55,
                    "type": "chart",
                    "chartType": "bar",
                    "special": true
                },
                {
                    "x": 0,
                    "y": 73,
                    "w": 100,
                    "h": 12,
                    "type": "textbox"
                },
                {
                    "x": 0,
                    "y": 87,
                    "w": 100,
                    "h": 13,
                    "type": "text",
                    "lines": 3
                }
            ]
        }
    ]
}